﻿// @ts-nocheck
  window.dataLayer = window.dataLayer || [];
  const gtmConfig = window.__GTM_CONFIG__ || {};

  function getFreshGtmConfig() {
    return window.__GTM_CONFIG__ || {};
  }

  function getGtmPlatformValue() {
    const config = getFreshGtmConfig();
    if (typeof normalizeGtmPlatform === 'function') {
      return normalizeGtmPlatform(config.platform);
    }
    return config.platform || 'web';
  }

  function resolveGtmPageName(additionalPageName) {
    if (additionalPageName != null && additionalPageName !== '') {
      return additionalPageName;
    }
    if (typeof getPageContext === 'function') {
      const pageContext = getPageContext();
      if (pageContext && pageContext.pageName) {
        return pageContext.pageName;
      }
    }
    if (typeof getPageNameFromUrl === 'function') {
      return getPageNameFromUrl();
    }
    return null;
  }

  /**
   * Safe Element for closest() — Text-node click targets (common on Mac Chrome)
   * do not implement Element.closest and break Buy Now / ATC listeners.
   */
  function getEventElement(event) {
    if (!event) return null;
    const path = typeof event.composedPath === 'function' ? event.composedPath() : null;
    if (path && path.length) {
      for (let i = 0; i < path.length; i++) {
        const node = path[i];
        if (node && node.nodeType === 1 && typeof node.closest === 'function') {
          return node;
        }
      }
    }
    const target = event.target;
    if (target && target.nodeType === 1 && typeof target.closest === 'function') {
      return target;
    }
    if (target && target.parentElement && typeof target.parentElement.closest === 'function') {
      return target.parentElement;
    }
    return null;
  }

  /**
   * Canonical cta_name for add-to-bag events.
   * Empty / legacy "add_to_cart" → "add_to_bag" so GA + internal SDK never get a blank enum.
   */
  function normalizeAddToBagCtaName(ctaName) {
    const raw = ctaName == null ? '' : String(ctaName).trim().toLowerCase();
    if (raw === 'buy_now') return 'buy_now';
    if (raw === 'quantity_icon') return 'quantity_icon';
    if (raw === 'delete') return 'delete';
    if (raw === 'add_to_bag' || raw === 'add_to_cart' || raw === '') return 'add_to_bag';
    return raw || 'add_to_bag';
  }
  window.normalizeAddToBagCtaName = normalizeAddToBagCtaName;

  function shouldSkipDuplicateAddToBag(variantId, ctaName) {
    const vid = variantId != null ? String(variantId) : '';
    const cta = normalizeAddToBagCtaName(ctaName);
    const now = Date.now();
    const last = window.__PW_ADD_TO_BAG_DEDUPE__;
    if (last && last.variantId === vid && vid !== '' && now - last.ts < 1500) {
      return true;
    }
    window.__PW_ADD_TO_BAG_DEDUPE__ = { variantId: vid, cta: cta, ts: now };
    return false;
  }

  function fireCartPageViewOnce(additionalData) {
    const now = Date.now();
    if (window.__PW_LAST_CART_PAGE_VIEW_TS__ && now - window.__PW_LAST_CART_PAGE_VIEW_TS__ < 2000) {
      return false;
    }
    window.__PW_LAST_CART_PAGE_VIEW_TS__ = now;
    if (typeof window.trackCartPageView === 'function') {
      try {
        window.trackCartPageView(additionalData || { page_name: 'Cart' });
      } catch (err) {
        console.error('Error tracking cart page view:', err);
      }
    }
    if (typeof window.trackMyBagPageView === 'function') {
      try {
        window.trackMyBagPageView(additionalData || {});
      } catch (err) {
        console.error('Error tracking my bag page view:', err);
      }
    }
    return true;
  }
  window.fireCartPageViewOnce = fireCartPageViewOnce;

  function getShopifySessionId() {
    try {
      if (
        window.PWTrackerRequiredAttrs &&
        typeof window.PWTrackerRequiredAttrs.getShopifySessionId === 'function'
      ) {
        const fromModule = window.PWTrackerRequiredAttrs.getShopifySessionId();
        if (fromModule) return fromModule;
      }
    } catch (e) {}
    try {
      const parts = document.cookie.split('; ');
      for (let i = 0; i < parts.length; i++) {
        if (parts[i].indexOf('_shopify_s=') === 0) {
          return decodeURIComponent(parts[i].slice('_shopify_s='.length));
        }
      }
    } catch (e2) {}
    return window.__PW_SHOPIFY_SESSION_ID__ || null;
  }

  function getBreadcrumbPathArray() {
    try {
      const breadcrumbItems = document.querySelectorAll('.breadcrumbs-list__item');
      const breadcrumbs = [];

      breadcrumbItems.forEach(function(item) {
        const link = item.querySelector('.breadcrumbs-list__link');
        if (link) {
          // Get text content, excluding SVG icons
          const clone = link.cloneNode(true);
          const svgs = clone.querySelectorAll('svg');
          svgs.forEach(function(svg) {
            svg.remove();
          });
          const text = clone.textContent.trim();

          // Skip empty text and duplicates
          if (text && text.length > 0 && !breadcrumbs.includes(text)) {
            breadcrumbs.push(text);
          }
        }
      });

      // If no breadcrumbs found, return default
      if (breadcrumbs.length === 0) {
        return ['Home'];
      }

      // Ensure "Home" is first if not already present
      const finalBreadcrumbs = breadcrumbs[0] !== 'Home' ? ['Home', ...breadcrumbs] : breadcrumbs;

      return finalBreadcrumbs;
    } catch (e) {
      console.error('Error getting breadcrumb path:', e);
      return ['Home'];
    }
  }

  // Definition: When user lands on any page of store (except PDP, cart, search, and PLP)
  function buildPageViewedPayload(eventName, extraData = {}) {
    const userData = typeof getUserData === 'function' ? getUserData() : {};
    let pageName = extraData.page_name || null;
    let pageSubtype = extraData.page_subtype || null;
    if ((!pageName || !pageSubtype) && typeof getPageContext === 'function') {
      const pageContext = getPageContext();
      pageName = pageName || pageContext.pageName || null;
      pageSubtype = pageSubtype || pageContext.pageSubtype || null;
    }

    return buildBaseGtmEventData(
      eventName,
      {
        cohort_name: userData.cohort_name,
        breadcrumb_path: extraData.breadcrumb_path || getBreadcrumbPathArray(),
        ...extraData,
      },
      {
        pageName: pageName,
        pageSubtype: pageSubtype,
      }
    );
  }

  function trackPageView(additionalData = {}) {
    dataLayer.push(buildPageViewedPayload('ga_pwst_page_viewed', additionalData));
  }

  function toLoadTimeSeconds(ms) {
    if (!Number.isFinite(ms) || ms <= 0) return null;
    return Number((ms / 1000).toFixed(3));
  }

  function getPageLoadTimings() {
    let domLoadTime = null;
    let windowLoadTime = null;
    try {
      const navEntries = (performance.getEntriesByType && performance.getEntriesByType('navigation')) || [];
      const nav = navEntries[0];
      if (nav) {
        domLoadTime = toLoadTimeSeconds(nav.domContentLoadedEventEnd);
        windowLoadTime = toLoadTimeSeconds(nav.loadEventEnd);
      }
      if ((domLoadTime == null || windowLoadTime == null) && performance.timing) {
        const timing = performance.timing;
        const start = timing.navigationStart;
        if (start) {
          if (domLoadTime == null) {
            domLoadTime = toLoadTimeSeconds(timing.domContentLoadedEventEnd - start);
          }
          if (windowLoadTime == null) {
            windowLoadTime = toLoadTimeSeconds(timing.loadEventEnd - start);
          }
        }
      }
      // loadEventEnd stays 0 until the load event fully finishes; use time since navigation start.
      if (windowLoadTime == null) {
        windowLoadTime = toLoadTimeSeconds(performance.now());
      }
    } catch (e) {}
    return {
      dom_load_time: domLoadTime,
      window_load_time: windowLoadTime,
    };
  }

  function trackLoadingTimeSec() {
    if (window.__PW_LOADING_TIME_TRACKED__) return;
    window.__PW_LOADING_TIME_TRACKED__ = true;
    dataLayer.push(buildPageViewedPayload('ga_pwst_loading_time_sec', getPageLoadTimings()));
  }

  function scheduleLoadingTimeTracking() {
    const fire = () => {
      window.setTimeout(() => {
        trackLoadingTimeSec();
      }, 0);
    };
    if (document.readyState === 'complete') {
      fire();
      return;
    }
    window.addEventListener('load', fire, { once: true });
  }

  function trackProductListingPageView(additionalData = {}) {
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};

    const userData = {
      user_id: customerData?.customerId || null,
      pw_user_id: customerData.pw_user_id || null,
      cohort_id: customerData.cohort_id || null,
      cohort_name: customerData.cohort_name || null,
    };

    const pageUrl = window.location.href;
    const urlParams = new URLSearchParams(window.location.search);

    function getPageSubtype() {
      const referrer = document.referrer || '';
      if (!referrer) {
        return 'home';
      }

      try {
        const referrerPath = new URL(referrer).pathname.toLowerCase();

        if (referrerPath.includes('/cart')) {
          return 'cart';
        }
        if (referrerPath.includes('/checkout')) {
          return 'checkout';
        }
        if (referrerPath.includes('/orders/') || referrerPath.includes('/order/')) {
          return 'order';
        }
        if (referrerPath.includes('/account') || referrerPath.includes('/login')) {
          return 'login';
        }
        if (referrerPath.includes('/collections/')) {
          return 'plp';
        }
        if (referrerPath === '/' || referrerPath === '') {
          return 'home';
        }
      } catch (e) {
        console.error('Error parsing referrer:', e);
      }

      return 'home';
    }

    function getBreadcrumbPathArrayForPlp() {
      try {
        const breadcrumbItems = document.querySelectorAll('.breadcrumbs-list__item');
        const breadcrumbs = [];

        breadcrumbItems.forEach(function(item) {
          const link = item.querySelector('.breadcrumbs-list__link');
          if (link) {
            const clone = link.cloneNode(true);
            const svgs = clone.querySelectorAll('svg');
            svgs.forEach(function(svg) {
              svg.remove();
            });
            const text = clone.textContent.trim();

            if (text && text.length > 0 && !breadcrumbs.includes(text)) {
              breadcrumbs.push(text);
            }
          }
        });

        if (breadcrumbs.length === 0) {
          return ['Home'];
        }

        const finalBreadcrumbs = breadcrumbs[0] !== 'Home' ? ['Home', ...breadcrumbs] : breadcrumbs;

        return finalBreadcrumbs;
      } catch (e) {
        console.error('Error getting breadcrumb path:', e);
        return ['Home'];
      }
    }

    function getCategoryNames() {
      try {
        const breadcrumbItems = document.querySelectorAll('.breadcrumbs-list__item');
        const breadcrumbs = [];

        breadcrumbItems.forEach(function(item) {
          const link = item.querySelector('.breadcrumbs-list__link');
          if (link) {
            const clone = link.cloneNode(true);
            const svgs = clone.querySelectorAll('svg');
            svgs.forEach(function(svg) {
              svg.remove();
            });
            const text = clone.textContent.trim();

            if (text && text.length > 0 && text !== 'Home' && !breadcrumbs.includes(text)) {
              breadcrumbs.push(text);
            }
          }
        });

        return {
          l1_category_name: breadcrumbs[0] || null,
          l2_category_name: breadcrumbs[1] || null,
          l3_category_name: breadcrumbs[2] || null,
        };
      } catch (e) {
        console.error('Error getting category names:', e);
        return {
          l1_category_name: null,
          l2_category_name: null,
          l3_category_name: null,
        };
      }
    }

    const categoryNames = getCategoryNames();
    const pageSubtype = getPageSubtype();

    // Helper to derive category slug from URL (collections handle)
    function getCategorySlugFromPath() {
      try {
        const path = window.location.pathname.toLowerCase();
        const parts = path.split('/').filter(Boolean);
        const collectionsIndex = parts.indexOf('collections');
        if (collectionsIndex !== -1 && parts[collectionsIndex + 1]) {
          return parts[collectionsIndex + 1];
        }
      } catch (e) {
        console.error('Error getting category slug from path:', e);
      }
      return null;
    }

    const eventData = {
      event: 'ga_pwst_product_listing_page_viewed',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'Collection',
      page_subtype: additionalData.page_subtype || (window.__PLP_COLLECTION_TITLE__ || pageSubtype),
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArrayForPlp(),
      is_logged_in: loginData.is_logged_in || false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      l1_category_name: additionalData.l1_category_name || categoryNames.l1_category_name,
      l2_category_name: additionalData.l2_category_name || categoryNames.l2_category_name,
      l3_category_name: additionalData.l3_category_name || categoryNames.l3_category_name,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };
    dataLayer.push(eventData);

    const moeEventData = buildBaseMoeEventData('moe_pwst_product_listing_page_view', {
      category_id: additionalData.category_id || null,
      category_name: additionalData.category_name || categoryNames.l1_category_name,
      category_slug: additionalData.category_slug || getCategorySlugFromPath(),
      sub_category_id: additionalData.sub_category_id || null,
      sub_catgory_name: additionalData.sub_catgory_name || categoryNames.l2_category_name,
      sub_sub_category_id: additionalData.sub_sub_category_id || null,
      sub_sub_category_name: additionalData.sub_sub_category_name || categoryNames.l3_category_name,
    }, {
      pageUrl: pageUrl,
    });

    console.log('ðŸ’¾ [MOE] PLP Event data:', moeEventData);
    dataLayer.push(moeEventData);
  }

  function getProductData() {
    try {
      const productData = window.__PRODUCT_DATA__ || {};
      
      return {
        product_id: productData.product_id || null,
        product_title: productData.product_title || null,
        product_img_url: productData.product_img_url || null,
        product_slug: productData.product_slug || null,
        product_moq: 50,
        product_discount_percent: productData.product_discount_percent || null,
        is_in_stock: productData.product_available_quantity ?? null,
        product_price: productData.product_price !== undefined ? productData.product_price : null,
        product_discount_price: productData.product_discount_price !== undefined ? productData.product_discount_price : null,
        product_discounted_price: productData.product_discounted_price !== undefined ? productData.product_discounted_price : null,
        product_tag: productData.product_tag || null,
        preorder: productData.preorder || null,
        product_available_quantity: productData.product_available_quantity !== undefined ? productData.product_available_quantity : null,
        l1_category_name: productData.l1_category_name || null,
        l2_category_name: productData.l2_category_name || null,
        l3_category_name: productData.l3_category_name || null,
        product_category_slug: productData.product_category_slug || null,
        product_category_id: productData.product_category_id || null,
        product_sub_category_id: productData.product_sub_category_id || null,
        product_sub_sub_category_id: productData.product_sub_sub_category_id || null,
        product_variant_id: productData.product_variant_id || null,
      };
    } catch (err) {
      console.error('Error getting product data:', err);
      return {
        product_id: null,
        product_title: null,
        product_img_url: null,
        product_slug: null,
        product_moq: 50,
        product_discount_percent: null,
        is_in_stock: null,
        product_price: null,
        product_discount_price: null,
        product_discounted_price: null,
        product_tag: null,
        preorder: null,
        product_available_quantity: null,
        l1_category_name: null,
        l2_category_name: null,
        l3_category_name: null,
        product_category_slug: null,
        product_category_id: null,
        product_sub_category_id: null,
        product_sub_sub_category_id: null,
        product_variant_id: null,
      };
    }
  }

  // Same event as in ga-events-redirect.liquid; fired on non-redirect when sessionStorage has 'loginError'
  function trackLoginAuthToDataLayer(additionalData = {}) {
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const userData = {
      user_id: customerData?.customerId || null,
      pw_user_id: customerData.pw_user_id || null,
      cohort_id: customerData.cohort_id || null,
      cohort_name: customerData.cohort_name || null,
    };
    const isNewUser = typeof safeSessionStorageGet === 'function' ? safeSessionStorageGet('isNewUser') : null;
    const pageUrl = window.location.href;
    const eventData = {
      event: 'ga_pwst_login_auth',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'login',
      page_subtype: 'auth',
      is_logged_in: Boolean(loginData.is_logged_in),
      from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
      user_id: userData.user_id,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      entered_mobile_number: null,
      status: additionalData.status || 'error',
      error_message: additionalData.error_message || null,
      login_type: isNewUser ? 'sign_up' : 'sign_in',
      timestamp: new Date().toISOString(),
      ...additionalData,
    };
    dataLayer.push(eventData);
  }

  // Same event as in ga-events-redirect.liquid; fired when user logs out
  function trackLogoutToDataLayer(additionalData = {}) {
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData.is_logged_in || false;

    if (!isLoggedIn) {
      return;
    }

    const userData = {
      user_id: customerData?.customerId || null,
      pw_user_id: customerData.pw_user_id || null,
      cohort_id: customerData.cohort_id || null,
      cohort_name: customerData.cohort_name || null,
    };
    const pageUrl = window.location.href;
    const eventData = {
      event: 'ga_pwst_logout',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'Header/Account',
      page_subtype: 'Logout',
      from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
      user_id: userData.user_id,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      entered_mobile_number: customerData.phone_number || null,
      status: additionalData.status || 'success',
      error_message: additionalData.error_message || null,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };

    if (typeof window.storeGtmEventData === 'function') {
      window.storeGtmEventData(eventData);
    } else {
      dataLayer.push(eventData);
    }
  }

  window.trackLogoutToDataLayer = trackLogoutToDataLayer;

  // Track login page visit event
  // Event: pwst_login_page_visit
  // Definition: User visiting login page using any flow
  function trackLoginPageVisit(additionalData = {}) {
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    const eventData = {
      event: 'ga_pwst_login_page_viewed',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'Login',
      is_logged_in: Boolean(isLoggedIn),
      from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };
    dataLayer.push(eventData);
  }

  // Track coupon copy event (offer modal copy code)
  // Event: ga_pwst_coupon_copy
  // Definition: User copies a promo/coupon code to clipboard
  function trackCouponCopy(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    
    const pageUrl = window.location.href;
    const path = window.location.pathname.toLowerCase();
    let pageName = 'other';
    if (path.includes('/products/')) pageName = 'pdp';
    else if (path.includes('/collections/')) pageName = 'plp';
    else if (path.includes('/cart')) pageName = 'cart';
    else if (path.includes('/checkout')) pageName = 'checkout';
    else if (path.includes('/search')) pageName = 'search';
    else if (path === '/' || path === '') pageName = 'home';

    const eventData = {
      event: 'ga_pwst_coupon_actions_taken',
      platform: window.__GTM_CONFIG__?.platform ?? null,
      organisation_name: window.__GTM_CONFIG__?.organisation_name ?? null,
      page_url: pageUrl,
      page_name: additionalData.page_name ?? pageName,
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id ?? null,
      cohort_id: userData.cohort_id ?? null,
      cohort_name: userData.cohort_name ?? null,
      business_unit: window.__GTM_CONFIG__?.business_unit ?? null,
      cart_id: window.__PW_CART_ID__ ?? null,
      coupon_type: additionalData.coupon_type ?? null,
      coupon_code: additionalData.coupon_code ?? null,
      coupon_discount_value: additionalData.coupon_discount_value != null ? Number(additionalData.coupon_discount_value) : null,
      cta_name: 'COPY',
      timestamp: new Date().toISOString(),
    };
    dataLayer.push(eventData);
    try {
      const productData = typeof getProductData === 'function' ? getProductData() : {};

      const moeEventDataWithProduct = {
        ...eventData,
        product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
        product_title: additionalData.product_title || productData.product_title,
        product_img_url: additionalData.product_img_url || productData.product_img_url,
        product_slug: additionalData.product_slug || productData.product_slug,
        product_moq: 50,
        product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
        product_in_stock:
          additionalData.product_in_stock !== undefined ? additionalData.product_in_stock : productData.is_in_stock,
        product_price:
          additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
        product_discount_price:
          additionalData.product_discount_price !== undefined
            ? additionalData.product_discount_price
            : productData.product_discount_price,
        product_discounted_price:
          additionalData.product_discounted_price !== undefined
            ? additionalData.product_discounted_price
            : productData.product_discounted_price,
        product_tag: additionalData.product_tag != null ? additionalData.product_tag : productData.product_tag,
        preorder: additionalData.preorder != null ? additionalData.preorder : productData.preorder,
        product_available_quantity:
          additionalData.product_available_quantity !== undefined
            ? additionalData.product_available_quantity
            : productData.product_available_quantity,
        l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
        l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
        l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
        product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
        product_category_id: additionalData.product_category_id || productData.product_category_id,
        product_sub_category_id: additionalData.product_sub_category_id || productData.product_sub_category_id,
        product_sub_sub_category_id:
          additionalData.product_sub_sub_category_id || productData.product_sub_sub_category_id,
        product_variant_id:
          additionalData.product_variant_id !== undefined
            ? additionalData.product_variant_id
            : productData.product_variant_id,
      };

      const moeCouponCopyEvent = buildMoeEventDataWithProduct(
        'moe_pwst_copy_coupon',
        moeEventDataWithProduct,
        productData,
        {
          coupon_id: additionalData.coupon_id ?? null,
          coupon_code: eventData.coupon_code,
          coupon_discount_value: eventData.coupon_discount_value,
        },
        {
          pageUrl: pageUrl,
        }
      );

      dataLayer.push(moeCouponCopyEvent);
    } catch (err) {
      console.error('Error tracking moe_pwst_copy_coupon:', err);
    }
  }
  window.trackCouponCopy = trackCouponCopy;

  // Definition: User enters the first digit in the mobile number input
  function trackMobileNumberClick(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    const eventData = {
      event: 'ga_pwst_mobile_number_clicked',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'login',
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };
    delete eventData.event_type;
    delete eventData.page_subtype;

    window.dataLayer.push(eventData);
  }
  window.trackMobileNumberClick = trackMobileNumberClick;

  // Definition: User clicks Get OTP button
  function trackGetOTPClick(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    const eventData = {
      event: 'ga_pwst_get_otp_clicked',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'login',
      page_subtype: 'get_otp',
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      entered_mobile_number: additionalData.entered_mobile_number || null,
      status: additionalData.status || 'pending', // 'success' or 'failed' or 'pending'
      timestamp: new Date().toISOString(),
      ...additionalData,
    };

    dataLayer.push(eventData);
  }
  window.trackGetOTPClick = trackGetOTPClick;

  // Definition: New signed-in users entering name on the field (first character entered)
  function trackLoginNameEntry(additionalData = {}) {
    const userData = getUserData();
    const pageUrl = window.location.href;

    const eventData = {
      event: 'ga_pwst_login_enter_name_clicked',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'login',
      page_subtype: 'login_name',
      is_logged_in: false, // Always FALSE for new sign-ups
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      login_type: additionalData.login_type || 'sign_up',
      timestamp: new Date().toISOString(),
      ...additionalData,
    };
    dataLayer.push(eventData);

    sessionStorage.setItem('isNewUser', 'true');
  }
  window.trackLoginNameEntry = trackLoginNameEntry;

  let loginNameEntryTracked = false;
  let loginNameEntryListenerAttached = false;

  function tryTrackLoginNameEntry(loginType) {
    if (loginNameEntryTracked || typeof trackLoginNameEntry !== 'function') return;
    loginNameEntryTracked = true;
    trackLoginNameEntry({ login_type: loginType || 'sign_up' });
  }

  function resetLoginNameEntryTracking() {
    loginNameEntryTracked = false;
  }

  function attachLoginNameEntryTracking() {
    const nameInput = document.getElementById('userNameInput');
    if (!nameInput || loginNameEntryListenerAttached) {
      return loginNameEntryListenerAttached;
    }
    if (typeof trackLoginNameEntry !== 'function') return false;

    loginNameEntryListenerAttached = true;

    nameInput.addEventListener('keydown', function (e) {
      if (loginNameEntryTracked) return;
      if (nameInput.value.trim().length !== 0) return;
      const isPrintableChar = e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey;
      if (isPrintableChar) tryTrackLoginNameEntry('sign_up');
    });

    nameInput.addEventListener('input', function (e) {
      if (loginNameEntryTracked) return;
      if (e && e.isTrusted === false) return;
      if (nameInput.value.trim().length > 0) tryTrackLoginNameEntry('sign_up');
    });

    nameInput.addEventListener('paste', function () {
      if (loginNameEntryTracked) return;
      setTimeout(function () {
        if (nameInput.value.trim().length > 0) tryTrackLoginNameEntry('sign_up');
      }, 0);
    });

    return true;
  }

  function initLoginNameEntryTracking() {
    if (attachLoginNameEntryTracking()) return;

    let attempts = 0;
    const timer = window.setInterval(function () {
      attempts += 1;
      if (attachLoginNameEntryTracking() || attempts >= 50) {
        window.clearInterval(timer);
      }
    }, 200);
  }

  window.attachLoginNameEntryTracking = attachLoginNameEntryTracking;
  window.resetLoginNameEntryTracking = resetLoginNameEntryTracking;

  // Definition: When user clicks on search tab and begins writing query, trigger after first character
  function trackSearchFirstCharacter(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;

    const eventData = {
      event: 'ga_pwst_search_initiated',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: window.__PW_GA_PAGE_PATH_URL__ || window.location.href,
      page_name: additionalData.page_name || 'search',
      search_text: additionalData.search_text || null,
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };

    requestIdleCallback(() => {
      dataLayer.push(eventData);
    }, {timeout: 200})
  }

  // Function to attach search first character tracking
  function attachSearchFirstCharacterTracking() {
    let hasTrackedModalSearch = false;
    let hasTrackedPageSearch = false;

    // Event: ga_pwst_product_item_clicked
    function attachSearchModalRecentlyViewedProductClickTracking() {
      if (window.__PW_SEARCH_MODAL_RECENT_PRODUCT_CLICK_ATTACHED__) return;
      window.__PW_SEARCH_MODAL_RECENT_PRODUCT_CLICK_ATTACHED__ = true;

      document.addEventListener(
        'click',
        function (event) {
          const link = event.target.closest('a[href*="/products/"]');
          if (!link) return;

          const item = link.closest('#search-modal [data-pw-search-recent-product="true"]');
          if (!item) return;

          const customerData = window.__CUSTOMER_DATA__ || {};
          const gtmConfig = window.__GTM_CONFIG__ || {};
          const loginData = window.__LOGIN_DATA__ || {};
          const userData = typeof getUserData === 'function' ? getUserData() : {};

          const productIdRaw = item.getAttribute('data-product-id');
          const productId = productIdRaw ? Number(productIdRaw) : null;
          const productTitle = item.getAttribute('data-product-title') || null;
          const productSlug = item.getAttribute('data-product-slug') || null;
          const isInStock = item.getAttribute('data-is-in-stock') === 'true';
          const posRaw = item.getAttribute('data-product-position');
          const positionInsideWidget = posRaw ? Number(posRaw) : null;

          const pageUrl = window.location.href;

          const eventData = {
            event: 'ga_pwst_product_item_clicked',
            platform: gtmConfig.platform || 'web',
            organisation_name: gtmConfig.organisation_name || 'pw',
            business_unit: gtmConfig.business_unit || 'pw_store',
            page_url: pageUrl,
            page_name: 'search',
            page_subtype: 'search_modal',
            breadcrumb_path: typeof getBreadcrumbPathArray === 'function' ? getBreadcrumbPathArray() : ['Home'],
            is_logged_in: loginData.is_logged_in === true,
            user_id: customerData.customerId ?? null,
            pw_user_id: userData.pw_user_id ?? customerData.pw_user_id ?? null,
            cohort_id: userData.cohort_id ?? customerData.cohort_id ?? null,
            cohort_name: userData.cohort_name ?? customerData.cohort_name ?? null,

            page_widget_name: 'recently_viewed',
            page_widget_position: 1,
            product_position_inside_widget: positionInsideWidget,

            product_id: productId,
            product_title: productTitle,
            product_slug: productSlug,
            is_in_stock: isInStock,

            timestamp: new Date().toISOString()
          };

          dataLayer.push(eventData);
        },
        { passive: true }
      );
    }

    function attachSearchModalOpenPageViewTracking() {
      const searchModalComponent = document.getElementById('search-modal');
      if (!searchModalComponent || searchModalComponent.dataset.pageViewOnOpenAttached === 'true') return;
      searchModalComponent.dataset.pageViewOnOpenAttached = 'true';

      searchModalComponent.addEventListener('dialog:open', function () {
        try {
          const now = Date.now();
          const last = window.__PW_SEARCH_MODAL_PAGE_VIEW_LAST_TS__ || 0;
          if (typeof trackPageView === 'function' && (now - last) > 800) {
            window.__PW_SEARCH_MODAL_PAGE_VIEW_LAST_TS__ = now;
            requestIdleCallback(() => {
              trackPageView({
                page_name: 'search',
                page_subtype: 'search_modal'
              });
            }, {timeout: 200});
          }
        } catch (e) {}
      });
    }

      function setupModalSearchTracking() {
        const searchModal = document.getElementById('search-modal');
        if (!searchModal) {
          if (!document.body) {
            return;
          }

          const observer = new MutationObserver(function(mutations, obs) {
            const modal = document.getElementById('search-modal');
            if (modal) {
              obs.disconnect();
              attachSearchModalOpenPageViewTracking();
              attachToModalInput();
            }
          });

          observer.observe(document.body, {
            childList: true,
            subtree: true
          });

          setTimeout(function() {
            const modal = document.getElementById('search-modal');
            if (modal) {
              attachSearchModalOpenPageViewTracking();
              attachToModalInput();
            }
          }, 500);
        } else {
          attachSearchModalOpenPageViewTracking();
          attachToModalInput();
        }

        function attachToModalInput() {
          // Find search input in modal (id="cmdk-input" or class="search-input")
          const searchInput = document.getElementById('cmdk-input') ||
                             document.querySelector('#search-modal .search-input') ||
                             document.querySelector('#search-modal input[type="search"]');

          if (searchInput && !hasTrackedModalSearch) {
            searchInput.addEventListener('input', function(event) {
              const value = event.target.value.trim();
              if (value.length === 1 && !hasTrackedModalSearch) {
                hasTrackedModalSearch = true;
                trackSearchFirstCharacter({
                  search_text: value,
                  page_name: 'search'
                });
              }
            }, { once: false, passive: true });

          }
        }
      }

      function setupPageSearchTracking() {
        const searchPageInputs = document.querySelectorAll('input[id^="SearchPageInput--"]');

        searchPageInputs.forEach(function(input) {
          if (!hasTrackedPageSearch) {
            input.addEventListener('input', function(event) {
              const value = event.target.value.trim();
              if (value.length === 1 && !hasTrackedPageSearch) {
                hasTrackedPageSearch = true;
                trackSearchFirstCharacter({
                  search_text: value,
                  page_name: 'search'
                });
              }
            }, { once: false, passive: true });

          }
        });
      }

      setupModalSearchTracking();
      setupPageSearchTracking();
      attachSearchModalRecentlyViewedProductClickTracking();

      document.addEventListener('click', function(event) {
        const target = event.target.closest('[on\\:click*="#search-modal/showDialog"]') ||
                      event.target.closest('.search-input-overlay') ||
                      event.target.closest('[aria-label*="search" i]');

        if (target) {
          // Reset so first-character event can trigger again after modal was closed and reopened
          hasTrackedModalSearch = false;
          // Wait a bit for modal to open, then attach tracking
          setTimeout(function() {
            setupModalSearchTracking();
          }, 300);
        }
      }, { passive: true });
  }

  attachSearchFirstCharacterTracking();

  // Definition: When user searches and lands on search page with results
  function trackSearchResultPageView(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('q') || urlParams.get('text') || null;

    function getTotalResults() {
      if (window.__SEARCH_RESULTS_COUNT__ !== undefined) {
        return parseInt(window.__SEARCH_RESULTS_COUNT__, 10) || 0;
      }

      const resultsList = document.querySelector('results-list');
      if (resultsList && resultsList.hasAttribute('data-results-count')) {
        return parseInt(resultsList.getAttribute('data-results-count'), 10) || 0;
      }

      const mobileFilterCount = document.querySelector('.mobile_Filter_count');
      if (mobileFilterCount) {
        const text = mobileFilterCount.textContent || '';
        const match = text.match(/(\d+)/);
        if (match) {
          return parseInt(match[1], 10) || 0;
        }
      }

      // Try to get from products count wrapper
      const productsCount = document.querySelector('.products-count--wrapper span');
      if (productsCount) {
        const text = productsCount.textContent || '';
        const match = text.match(/(\d+)/);
        if (match) {
          return parseInt(match[1], 10) || 0;
        }
      }

      // Try to count product grid items (may not be accurate if paginated)
      const productItems = document.querySelectorAll('.product-grid__item, [data-product-id]');
      if (productItems.length > 0) {
        // This might only show current page items, so use as fallback
        return productItems.length;
      }

      return 0;
    }

    const eventData = {
      event: 'ga_pwst_search_result_page_viewed',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: 'search',
      search_text: searchText,
      total_results: additionalData.total_results !== undefined ? additionalData.total_results : getTotalResults(),
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };

    dataLayer.push(eventData);
  }


  // Function to initialize search result page view tracking
  function initSearchResultPageViewTracking() {
    // Prevent multiple initializations
    if (window.__SEARCH_RESULT_PAGE_VIEW_TRACKED__) {
      return;
    }

    // Check if we're on a search results page
    const path = window.location.pathname.toLowerCase();
    const urlParams = new URLSearchParams(window.location.search);
    const searchText = urlParams.get('q') || urlParams.get('text');

    // Only track if we're on search page and have a search query
    if (path.includes('/search') && searchText) {
      window.__SEARCH_RESULT_PAGE_VIEW_TRACKED__ = true;

      // Wait for DOM to be ready to get results count
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          // Small delay to ensure results are rendered
          setTimeout(function() {
            trackSearchResultPageView();
          }, 300);
        }, { once: true });
      } else {
        // DOM already loaded, wait a bit for results to render
        setTimeout(function() {
          trackSearchResultPageView();
        }, 300);
      }
    }
  }

  // Initialize search result page view tracking after DOM load
  runAfterDomLoad(initSearchResultPageViewTracking);

  function resolveProductStockFieldsForPincode(additionalData, productData) {
    const rawQty =
      additionalData.product_in_stock !== undefined && additionalData.product_in_stock !== null
        ? additionalData.product_in_stock
        : additionalData.product_available_quantity !== undefined
          ? additionalData.product_available_quantity
          : productData.product_available_quantity;

    let productInStock = null;
    if (rawQty !== undefined && rawQty !== null && rawQty !== '') {
      const parsed = Number(rawQty);
      if (Number.isFinite(parsed)) {
        productInStock = parsed;
      }
    }

    let isInStock = null;
    if (typeof additionalData.is_in_stock === 'boolean') {
      isInStock = additionalData.is_in_stock;
    } else {
      const windowProduct = window.__PRODUCT_DATA__ || {};
      if (typeof windowProduct.is_in_stock === 'boolean') {
        isInStock = windowProduct.is_in_stock;
      } else if (productInStock != null) {
        isInStock = productInStock > 0;
      }
    }

    return { product_in_stock: productInStock, is_in_stock: isInStock };
  }

  // Track pincode serviceability check event
  // Event: pwst_pincode_serviceability_check
  // Definition: When user clicks check button to verify pincode serviceability
  function trackPincodeServiceabilityCheck(additionalData = {}) {
    const userData = getUserData();
    const productData = getProductData();
    const stockFields = resolveProductStockFieldsForPincode(additionalData, productData);
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;

    // Determine page_name from URL
    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) {
        return 'pdp';
      }
      if (path.includes('/collections/')) {
        return 'plp';
      }
      if (path.includes('/cart')) {
        return 'cart';
      }
      if (path.includes('/checkout')) {
        return 'checkout';
      }
      if (path.includes('/search')) {
        return 'search';
      }
      if (path === '/' || path === '') {
        return 'home';
      }
      return 'other';
    }

    const eventData = {
      event: 'ga_pwst_pincode_serviceability_checked',
      platform: gtmConfig.platform || 'web',
      organisation_name: 'pw',
      business_unit: 'pw_store',
      page_url: pageUrl,
      page_name: additionalData.page_name || getPageNameFromUrl(),
      is_logged_in: Boolean((window.__LOGIN_DATA__ || {}).is_logged_in),
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
      entered_pincode: additionalData.entered_pincode || null,
      is_serviceable: additionalData.is_serviceable !== undefined ? additionalData.is_serviceable : null,
      checked_state: additionalData.checked_state || null,
      checked_city: additionalData.checked_city || null,
      product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
      product_title: additionalData.product_title || productData.product_title,
      product_slug: additionalData.product_slug || productData.product_slug,
      product_moq: 50,
      product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
      is_in_stock: stockFields.is_in_stock,
      product_in_stock: stockFields.product_in_stock,
      product_price: additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
      product_discount_price: additionalData.product_discount_price !== undefined ? additionalData.product_discount_price : productData.product_discount_price,
      product_discounted_price: additionalData.product_discounted_price !== undefined ? additionalData.product_discounted_price : productData.product_discounted_price,
      product_tag: additionalData.product_tag || productData.product_tag,
      preorder: additionalData.preorder || productData.preorder,
      product_available_quantity:
        stockFields.product_in_stock !== null
          ? stockFields.product_in_stock
          : additionalData.product_available_quantity !== undefined
            ? additionalData.product_available_quantity
            : productData.product_available_quantity,
      l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
      l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
      l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
      product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
      product_variant_id: additionalData.product_variant_id || productData.product_variant_id,
      timestamp: new Date().toISOString(),
    };

    // Moe pincode serviceability event - use helper for base structure with class/exam
    const baseMoeData = buildBaseMoeEventData('moe_pwst_pincode_serviceability_check', {
      client_type: 'pw_store',
      device_id: additionalData.device_id || null,
    }, {
      pageUrl: pageUrl,
    });

    // Add pincode-specific and product fields
    const moeEventData = {
      ...baseMoeData,
      
      // Pincode / location info
      pin: eventData.entered_pincode,
      found: eventData.is_serviceable,
      state: eventData.checked_state,
      city: eventData.checked_city,
      district: additionalData.district || null,


      // Product info
      product_id: eventData.product_id,
      product_title: eventData.product_title,
      product_img_url: productData.product_img_url || additionalData.product_img_url || null,
      product_moq: 50,
      product_in_stock: eventData.product_in_stock,
      product_price: eventData.product_price,
      product_discount_price: eventData.product_discount_price,
      product_discounted_price: eventData.product_discounted_price,
      product_discount_percent: eventData.product_discount_percent,
      product_slug: eventData.product_slug,
      product_tag: eventData.product_tag,

      // Category hierarchy
      category_name: eventData.l1_category_name || null,
      sub_catgory_name: eventData.l2_category_name || null,
      sub_sub_category_name: eventData.l3_category_name || null,
      l1_category_name: eventData.l1_category_name || null,
      l2_category_name: eventData.l2_category_name || null,
      l3_category_name: eventData.l3_category_name || null,
    };

    console.log('ðŸ’¾ [MOE] Pincode serviceability Event data:', moeEventData);
    dataLayer.push(moeEventData);
    dataLayer.push(eventData);
  }

  // Track store FAQ view event
  // Event: pwst_store_faq_view
  // Definition: When user views/clicks on FAQs on page
  function trackStoreFaqView(additionalData = {}) {
    const userData = getUserData();
    const productData = getProductData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    // Determine page_name from URL
    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) {
        return 'pdp';
      }
      if (path.includes('/collections/')) {
        return 'plp';
      }
      if (path.includes('/cart')) {
        return 'cart';
      }
      if (path.includes('/checkout')) {
        return 'checkout';
      }
      if (path.includes('/search')) {
        return 'search';
      }
      if (path === '/' || path === '') {
        return 'home';
      }
      return 'other';
    }

    const eventData = {
      event: 'ga_pwst_store_faq_viewed',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: additionalData.page_name || getPageNameFromUrl(),
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      faq_title: additionalData.faq_title || null,
      product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
      product_title: additionalData.product_title || productData.product_title,
      product_slug: additionalData.product_slug || productData.product_slug,
      product_moq: 50,
      product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
      product_in_stock: (additionalData.product_available_quantity !== undefined ? additionalData.product_available_quantity : productData.product_available_quantity) ?? null,
      product_price: additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
      product_discount_price: additionalData.product_discount_price !== undefined ? additionalData.product_discount_price : productData.product_discount_price,
      product_discounted_price: additionalData.product_discounted_price !== undefined ? additionalData.product_discounted_price : productData.product_discounted_price,
      product_tag: additionalData.product_tag || productData.product_tag,
      preorder: additionalData.preorder || productData.preorder,
      product_available_quantity: additionalData.product_available_quantity !== undefined ? additionalData.product_available_quantity : productData.product_available_quantity,
      product_category_id: additionalData.product_category_id || productData.product_category_id,
      product_sub_category_id: additionalData.product_sub_category_id || productData.product_sub_category_id,
      product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
      product_variant_id: additionalData.product_variant_id || productData.product_variant_id,
      timestamp: new Date().toISOString(),
    };
    dataLayer.push(eventData);
  }

  // Function to attach FAQ view tracking
  function attachFaqViewTracking() {
    // Find all FAQ accordion details elements
    const faqDetails = document.querySelectorAll('.product-content-accordion-details');
    
    if (faqDetails.length === 0) {
      return;
    }

    faqDetails.forEach(function(detailsElement) {
      // Track when FAQ is opened (toggle event fires when details opens)
      detailsElement.addEventListener('toggle', function(event) {
        // Only track when opening (not closing)
        if (this.open) {
          // Extract FAQ title from the accordion title element
          const titleElement = this.querySelector('.product-content-accordion-title');
          const faqTitle = titleElement ? titleElement.textContent.trim() : null;

          if (faqTitle && typeof window.trackStoreFaqView === 'function') {
            try {
              window.trackStoreFaqView({
                faq_title: faqTitle,
              });
            } catch (err) {
              console.error('Error tracking FAQ view:', err);
            }
          }
        }
      }, { passive: true });
    });
  }

  function trackProductDescriptionView(additionalData = {}) {
    const userData = getUserData();
    const productData = getProductData();
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;

    // Get coupon information from product offers data
    function getCouponInfo() {
      try {
        const offerData = window.__PRODUCT_OFFER_DATA__ || {};
        
        return {
          coupon_present: offerData.coupon_present === true,
          coupon_type: offerData.coupon_type || null,
        };
      } catch (err) {
        console.error('Error getting coupon info:', err);
        return { coupon_present: false, coupon_type: null };
      }
    }

    // Get coupon info and then track event
    const couponInfo = getCouponInfo();
    const eventData = {
      event: 'ga_pwst_product_description_viewed',
      platform: getGtmPlatformValue(),
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: resolveGtmPageName(additionalData.page_name),
      is_logged_in: Boolean((window.__LOGIN_DATA__ || {}).is_logged_in),
      from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
      coupon_type: additionalData.coupon_type !== undefined ? additionalData.coupon_type : couponInfo.coupon_type,
      coupon_present: additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present,
      product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
      product_title: additionalData.product_title || productData.product_title,
      product_slug: additionalData.product_slug || productData.product_slug,
      product_moq: additionalData.product_moq !== undefined ? additionalData.product_moq : (productData.product_moq ?? null),
      product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
      product_in_stock: (additionalData.product_available_quantity !== undefined ? additionalData.product_available_quantity : productData.product_available_quantity) ?? null,
      product_price: additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
      product_discount_price: additionalData.product_discount_price !== undefined ? additionalData.product_discount_price : productData.product_discount_price,
      product_discounted_price: additionalData.product_discounted_price !== undefined ? additionalData.product_discounted_price : productData.product_discounted_price,
      product_tag: additionalData.product_tag || productData.product_tag,
      preorder: additionalData.preorder || productData.preorder,
      product_available_quantity: additionalData.product_available_quantity !== undefined ? additionalData.product_available_quantity : productData.product_available_quantity,
      l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
      l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
      l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
      product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
      product_category_id: additionalData.product_category_id || productData.product_category_id,
      product_sub_category_id: additionalData.product_sub_category_id || productData.product_sub_category_id,
      product_sub_sub_category_id: additionalData.product_sub_sub_category_id || productData.product_sub_sub_category_id,
      product_variant_id: additionalData.product_variant_id !== undefined ? additionalData.product_variant_id : productData.product_variant_id,
      timestamp: new Date().toISOString(),
    };

    // Mengage + product data for product description page view - use helper
    // productData is already declared at the beginning of the function
    const moeEventData = buildMoeEventDataWithProduct(
      'moe_pwst_product_description_page_view',
      eventData,
      productData,
      {},
      {
        pageUrl: pageUrl,
      }
    );

    dataLayer.push(moeEventData);
    dataLayer.push(eventData);
  }

  function trackProductPreviewViewed(additionalData = {}) {
    const userData = getUserData();
    const productData = getProductData();
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;

    function getCouponInfo() {
      try {
        const offerData = window.__PRODUCT_OFFER_DATA__ || {};
        return {
          coupon_present: offerData.coupon_present === true,
          coupon_type: offerData.coupon_type || null,
        };
      } catch (err) {
        console.error('Error getting coupon info:', err);
        return { coupon_present: false, coupon_type: null };
      }
    }

    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) return 'pdp';
      if (path.includes('/collections/')) return 'plp';
      if (path.includes('/cart')) return 'cart';
      if (path.includes('/checkout')) return 'checkout';
      if (path.includes('/search')) return 'search';
      if (path === '/' || path === '') return 'home';
      return 'other';
    }

    const couponInfo = getCouponInfo();
    const eventData = {
      event: 'ga_pwst_product_preview_viewed',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: additionalData.page_name || getPageNameFromUrl(),
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
      coupon_type: additionalData.coupon_type !== undefined ? additionalData.coupon_type : couponInfo.coupon_type,
      coupon_present: additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present,
      product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
      product_title: additionalData.product_title || productData.product_title,
      product_slug: additionalData.product_slug || productData.product_slug,
      product_moq: 50,
      product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
      product_in_stock:
        (additionalData.product_available_quantity !== undefined
          ? additionalData.product_available_quantity
          : productData.product_available_quantity) ?? null,
      product_price: additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
      product_discount_price:
        additionalData.product_discount_price !== undefined
          ? additionalData.product_discount_price
          : productData.product_discount_price,
      product_discounted_price:
        additionalData.product_discounted_price !== undefined
          ? additionalData.product_discounted_price
          : productData.product_discounted_price,
      product_tag: additionalData.product_tag || productData.product_tag,
      preorder: additionalData.preorder || productData.preorder,
      product_available_quantity:
        additionalData.product_available_quantity !== undefined
          ? additionalData.product_available_quantity
          : productData.product_available_quantity,
      l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
      l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
      l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
      product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
      product_category_id: additionalData.product_category_id || productData.product_category_id,
      product_sub_category_id: additionalData.product_sub_category_id || productData.product_sub_category_id,
      product_sub_sub_category_id: additionalData.product_sub_sub_category_id || productData.product_sub_sub_category_id,
      product_variant_id:
        additionalData.product_variant_id !== undefined ? additionalData.product_variant_id : productData.product_variant_id,
      timestamp: new Date().toISOString(),
    };

    dataLayer.push(eventData);
  }

  function attachProductPreviewViewedTracking() {
    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;
      const previewBtn =
        event.target.closest('[data-preview-book-button]') ||
        event.target.closest('[aria-label="Preview Book"]');
      if (!previewBtn) return;

      try {
        const productIdAttr = previewBtn.getAttribute('data-product-id');
        const productId = productIdAttr ? Number(productIdAttr) : undefined;
        trackProductPreviewViewed({
          product_id: Number.isFinite(productId) ? productId : undefined,
        });
      } catch (err) {
        console.error('Error tracking product preview viewed:', err);
      }
    }, { capture: true, passive: true });
  }

  // Function to get variant data from variant picker JSON script tag
  function getVariantDataFromPicker(variantId) {
    try {
      // Find variant picker component
      const variantPicker = document.querySelector('variant-picker');
      if (!variantPicker) return null;

      // Try to get variant data from script tag with JSON (updated after variant change)
      const scriptTag = variantPicker.querySelector('script[type="application/json"]');
      if (scriptTag && scriptTag.textContent) {
        try {
          const variantData = JSON.parse(scriptTag.textContent);
          // If the variant ID matches, return it
          if (variantData.id && variantData.id.toString() === variantId.toString()) {
            return variantData;
          }
        } catch (e) {
          // JSON parse failed, continue
        }
      }

      return null;
    } catch (err) {
      console.error('Error getting variant data:', err);
      return null;
    }
  }

  // Function to attach product description view tracking
  function attachProductDescriptionViewTracking() {
    // Ensure we have a valid body node before setting up observers
    if (!document.body) {
      // If body is not ready yet, wait for DOMContentLoaded and try again
      document.addEventListener('DOMContentLoaded', function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        attachProductDescriptionViewTracking();
      });
      return;
    }

    // Track if initial page load event has been fired and if variant change has occurred
    let initialPageLoadTracked = false;
    let variantChangeTracked = false;
    let isInitialLoad = true;
    let initialVariantId = null;
    let lastTrackedVariantId = null;
    let lastTrackedTime = 0;
    const TRACKING_DEBOUNCE_MS = 500; // Prevent duplicate tracking within 500ms

      // Get initial variant ID on page load
      function getInitialVariantId() {
        try {
          const variantPicker = document.querySelector('variant-picker');
          if (variantPicker) {
            const scriptTag = variantPicker.querySelector('script[type="application/json"]');
            if (scriptTag && scriptTag.textContent) {
              const variantData = JSON.parse(scriptTag.textContent);
              return variantData.id ? variantData.id.toString() : null;
            }
          }
        } catch (e) {
          // Ignore errors
        }
        return null;
      }

      // Set initial variant ID after a short delay
      setTimeout(() => {
        initialVariantId = getInitialVariantId();
      }, 300);

      // Function to handle variant click/change
      function handleVariantChange(event) {
        const target = event.target;
        let variantId = null;
        let isFromLabel = false;

        // Get variant ID from different element types
        if (target.type === 'radio' && target.hasAttribute('data-variant-id')) {
          variantId = target.getAttribute('data-variant-id');
        } else if (target.tagName === 'OPTION' && target.hasAttribute('data-variant-id')) {
          variantId = target.getAttribute('data-variant-id');
        } else if (target.closest('label') || target.closest('.variant-option__button-label')) {
          // If clicked on label, find the input inside
          const label = target.closest('label') || target.closest('.variant-option__button-label');
          const input = label?.querySelector('input[type="radio"][data-variant-id]');
          if (input) {
            variantId = input.getAttribute('data-variant-id');
            isFromLabel = true;
          }
        }

        if (!variantId) return;

        // Skip if this is the initial variant (prevent tracking on page load)
        if (isInitialLoad && initialVariantId && variantId.toString() === initialVariantId.toString()) {
          return;
        }

        // Prevent duplicate tracking: if same variant was tracked recently, skip
        const now = Date.now();
        if (lastTrackedVariantId === variantId.toString() && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) {
          return;
        }

        // If event came from label, stop propagation to prevent input event from also firing
        if (isFromLabel && event.stopPropagation) {
          event.stopPropagation();
        }

        // Mark that variant change has been tracked (user actually changed variant)
        variantChangeTracked = true;
        lastTrackedVariantId = variantId.toString();
        lastTrackedTime = now;

        // Variant change tracking removed - now handled in ga-events-redirect.liquid
      }

      // Attach click listeners to variant radio inputs and select dropdowns
      // Note: We don't attach to labels because clicking a label triggers the input's click event
      function attachVariantListeners() {
        // Find all variant pickers
        const variantPickers = document.querySelectorAll('variant-picker, swatches-variant-picker-component');
        
        variantPickers.forEach(function(picker) {
          // Attach to radio inputs (this will also catch label clicks that trigger input clicks)
          const radioInputs = picker.querySelectorAll('input[type="radio"][data-variant-id]');
          radioInputs.forEach(function(input) {
            if (!input.hasAttribute('data-variant-tracked')) {
              input.setAttribute('data-variant-tracked', 'true');
              input.addEventListener('click', handleVariantChange, { passive: true });
            }
          });

          // Attach to select dropdowns
          const selects = picker.querySelectorAll('select.variant-option__select');
          selects.forEach(function(select) {
            if (!select.hasAttribute('data-variant-tracked')) {
              select.setAttribute('data-variant-tracked', 'true');
              select.addEventListener('change', handleVariantChange, { passive: true });
            }
          });
        });
      }

      // Initial attachment
      attachVariantListeners();

      // Use MutationObserver to attach to dynamically added variant pickers
      const observer = new MutationObserver(function(mutations) {
        let shouldReattach = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) { // Element node
                if (node.matches && (node.matches('variant-picker') || node.matches('swatches-variant-picker-component') || 
                    node.querySelector('variant-picker') || node.querySelector('swatches-variant-picker-component'))) {
                  shouldReattach = true;
                }
              }
            });
          }
        });
        if (shouldReattach) {
          attachVariantListeners();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true
      });

      // Mark initial load as complete after a delay
      setTimeout(() => {
        isInitialLoad = false;
      }, 1000);

    // Initial page load tracking removed - now handled in ga-events-redirect.liquid
  }

  // Initialize product description view tracking
  attachProductDescriptionViewTracking();

  function readGtmAttrFromAncestors(element, attr) {
    if (!element) return null;
    let node = element;
    let depth = 0;
    while (node && depth < 15) {
      const value = node.getAttribute && node.getAttribute(attr);
      if (value != null && String(value).trim() !== '') {
        return String(value).trim();
      }
      node = node.parentElement;
      depth++;
    }
    return null;
  }

  function findProductCardContextElement(element) {
    if (!element || !element.closest) return null;
    return (
      element.closest('product-card, product-card-link') ||
      element.closest('.swiper-slide[data-product-id], .swiper-slide') ||
      element.closest('.product-card, [data-product-id], .resource-list__item, .product-grid__item')
    );
  }

  function findWidgetSectionElement(element) {
    if (!element || !element.closest) return null;
    return (
      element.closest('product-recommendations') ||
      element.closest('section[data-section-index], section.custom-product-list, section[data-testid="product-list"]') ||
      element.closest('section') ||
      element.closest('.shopify-section[id^="shopify-section-"], .section-wrapper[id^="shopify-section-"], [id^="shopify-section-"]')
    );
  }

  function normalizeWidgetPositionValue(value) {
    if (typeof window.coerceWidgetPositionNumber === 'function') {
      return window.coerceWidgetPositionNumber(value);
    }
    if (value == null || value === '') return null;
    const n = Number(value);
    return Number.isFinite(n) ? n : null;
  }

  function resolvePageWidgetPosition(element, section) {
    const fromGtmAttr = readGtmAttrFromAncestors(element, 'data-gtm-page-widget-position');
    if (fromGtmAttr) return normalizeWidgetPositionValue(fromGtmAttr);

    const shopifySection =
      element?.closest?.('.shopify-section[id^="shopify-section-"]') ||
      section?.closest?.('.shopify-section[id^="shopify-section-"]') ||
      (section?.id && String(section.id).startsWith('shopify-section-') ? section : null);

    const positionHost = shopifySection || section;
    if (positionHost) {
      const sectionPosition =
        positionHost.getAttribute('data-gtm-section-position') ||
        positionHost.querySelector?.('[data-gtm-section-position]')?.getAttribute('data-gtm-section-position') ||
        positionHost.querySelector?.('[data-section-index]')?.getAttribute('data-section-index') ||
        section?.getAttribute('data-section-index');
      if (sectionPosition) return normalizeWidgetPositionValue(sectionPosition);
    }

    if (shopifySection) {
      const visibleSections = Array.from(
        document.querySelectorAll('.shopify-section[id^="shopify-section-"]')
      ).filter(function (sec) {
        return sec.getClientRects().length > 0;
      });
      const sectionIndex = visibleSections.indexOf(shopifySection);
      if (sectionIndex >= 0) return sectionIndex + 1;
    }

    if (section) {
      const allSections = Array.from(
        document.querySelectorAll('.shopify-section[id^="shopify-section-"]')
      );
      const sectionIndex = allSections.indexOf(section);
      if (sectionIndex >= 0) return sectionIndex + 1;
    }

    return null;
  }

  function resolveProductPositionInsideWidget(element, section) {
    const slide =
      element?.closest?.('.swiper-slide[data-product-position], .swiper-slide[data-product-id]') || null;
    if (slide) {
      const slidePosition = slide.getAttribute('data-product-position');
      if (slidePosition) return normalizeWidgetPositionValue(slidePosition);
    }

    const resourceListItem = element?.closest?.('.resource-list__item');
    if (resourceListItem && section) {
      const items = Array.from(section.querySelectorAll('.resource-list__item'));
      const resourceIndex = items.indexOf(resourceListItem);
      if (resourceIndex >= 0) return resourceIndex + 1;
    }

    const productCard = findProductCardContextElement(element);
    if (!productCard) return null;

    let dataPosition = productCard.getAttribute('data-product-position');
    if (!dataPosition) {
      const parentSlide = productCard.closest('.swiper-slide');
      if (parentSlide) {
        dataPosition = parentSlide.getAttribute('data-product-position');
      }
    }
    if (dataPosition) return normalizeWidgetPositionValue(dataPosition);

    if (!section) return null;

    const cardSelectors = [
      '.swiper-slide:not(.skeleton-slide)[data-product-id]',
      '.swiper-slide:not(.skeleton-slide)',
      'product-card[data-product-id]',
      '.product-card[data-product-id]',
      '[data-product-id]',
      '.resource-list__item',
      '.product-grid__item',
    ];

    let cards = [];
    for (const selector of cardSelectors) {
      const foundCards = Array.from(section.querySelectorAll(selector)).filter(function (card) {
        return !card.classList.contains('skeleton-slide');
      });
      if (foundCards.length > 0) {
        cards = foundCards;
        break;
      }
    }

    const cardToIndex = slide || productCard.closest('.swiper-slide') || productCard;
    let cardIndex = cards.indexOf(cardToIndex);
    if (cardIndex < 0) {
      cardIndex = cards.indexOf(productCard);
    }
    if (cardIndex >= 0) return cardIndex + 1;

    const productId = productCard.getAttribute('data-product-id');
    if (productId) {
      const matchingCard = cards.find(function (card) {
        return (
          card.getAttribute('data-product-id') === productId ||
          (card.contains && card.contains(productCard)) ||
          (productCard.contains && productCard.contains(card))
        );
      });
      if (matchingCard) {
        const idx = cards.indexOf(matchingCard);
        if (idx >= 0) return idx + 1;
      }
    }

    return null;
  }

  function buildGtmWidgetPayload(widgetInfo) {
    const info = widgetInfo || {};
    const pageWidgetPosition = normalizeWidgetPositionValue(info.page_widget_position);
    const productPosition =
      normalizeWidgetPositionValue(info.product_position_inside_widget) ??
      normalizeWidgetPositionValue(info.position_inside_widget);
    return {
      page_widget_name: info.page_widget_name || null,
      page_widget_position: pageWidgetPosition != null ? pageWidgetPosition : 1,
      product_position_inside_widget: productPosition,
    };
  }

  function getCollectionPlpWidgetContext(element) {
    const path = (window.location.pathname || '').toLowerCase();
    const onCollectionPage = path.includes('/collections/') && !path.includes('/products/');
    if (!onCollectionPage || !element) return null;

    const inCollectionGrid = element.closest(
      'results-list, .main-collection-grid, .collection-wrapper'
    );
    if (!inCollectionGrid) return null;

    const gridItem =
      element.closest('.product-grid__item') ||
      element.closest('li[data-product-id]');
    if (!gridItem) return null;

    const productGrid = gridItem.closest('.product-grid');
    if (!productGrid) return null;

    const items = Array.from(
      productGrid.querySelectorAll('.product-grid__item[data-product-id]')
    );
    let cardIndex = items.indexOf(gridItem);
    if (cardIndex < 0) {
      const productId =
        element.getAttribute('data-product-id') ||
        element.closest('[data-product-id]')?.getAttribute('data-product-id');
      if (productId) {
        cardIndex = items.findIndex(function (item) {
          return (
            item.getAttribute('data-product-id') === productId ||
            (item.querySelector && item.querySelector('[data-product-id="' + productId + '"]'))
          );
        });
      }
    }

    const productPosition = cardIndex >= 0 ? cardIndex + 1 : null;
    return {
      page_widget_name: 'Collection',
      page_widget_position: 1,
      product_position_inside_widget: productPosition,
    };
  }

  function getWidgetInfoFromElement(element) {
    let widgetName = null;
    let widgetPosition = null;
    let productPositionInsideWidget = null;

    if (!element) {
      return {
        page_widget_name: null,
        page_widget_position: null,
        product_position_inside_widget: null,
      };
    }

    const collectionContext = getCollectionPlpWidgetContext(element);
    if (collectionContext) {
      return collectionContext;
    }

    widgetName =
      readGtmAttrFromAncestors(element, 'data-gtm-widget-name') ||
      readGtmAttrFromAncestors(element, 'data-widget-name');

    const section = findWidgetSectionElement(element);

    if (section) {
      if (!widgetName) {
        widgetName =
          section.getAttribute('data-widget-name') ||
          section.getAttribute('data-gtm-widget-name') ||
          null;
      }

      const titleSelectors = [
        '.section-resource-list__header h3',
        '.section-resource-list__header h2',
        '.section-resource-list__header .custom-product-list-title h3',
        '.section-resource-list__header .custom-product-list-title h2',
        'h2.section-title',
        'h3.section-title',
        '.section-title',
        '.custom-product-list-title h3',
        '.custom-product-list-title h2',
        '.section-resource-list__header [class*="title"]',
        'h2',
        'h3',
        '[class*="section-title"]',
        '[class*="title"]'
      ];
      
      for (const selector of titleSelectors) {
        const titleElement = section.querySelector(selector);
        if (titleElement && titleElement.textContent) {
          // Clean the text - remove HTML tags and trim
          const text = titleElement.textContent.trim();
          if (text) {
            widgetName = text;
            break;
          }
        }
      }

      // If no title found, try to get from section attributes or ID
      if (!widgetName) {
        widgetName = section.getAttribute('data-section-type') || 
                    section.getAttribute('data-section-id') || 
                    (section.id ? section.id.replace('shopify-section-', '') : null) || 
                    null;
      }

      widgetPosition = resolvePageWidgetPosition(element, section);
    }

    productPositionInsideWidget =
      resolveProductPositionInsideWidget(element, section) ||
      normalizeWidgetPositionValue(
        readGtmAttrFromAncestors(element, 'data-gtm-position-inside-widget')
      );

    return {
      page_widget_name: widgetName,
      page_widget_position: normalizeWidgetPositionValue(widgetPosition),
      product_position_inside_widget: productPositionInsideWidget,
    };
  }

  function isInsideQuickAddModal(element) {
    return !!element?.closest?.('#quick-add-modal-content, quick-add-dialog, .quick-add-modal');
  }

  function findProductCardOnPage(productId, triggerElement) {
    const pid = productId != null ? String(productId) : null;
    if (!pid) return null;

    if (triggerElement && triggerElement.closest && !isInsideQuickAddModal(triggerElement)) {
      const fromTrigger =
        triggerElement.closest('product-card[data-product-id="' + pid + '"]') ||
        triggerElement.closest('.swiper-slide[data-product-id="' + pid + '"]') ||
        triggerElement.closest('[data-product-id="' + pid + '"][data-product-handle]') ||
        triggerElement.closest('[data-product-id="' + pid + '"][data-product-price]');
      if (fromTrigger && !isInsideQuickAddModal(fromTrigger)) {
        return fromTrigger.closest('product-card, .swiper-slide[data-product-id]') || fromTrigger;
      }
    }

    const selectors = [
      'product-card[data-product-id="' + pid + '"]',
      '.swiper-slide[data-product-id="' + pid + '"]',
      '[data-product-id="' + pid + '"][data-product-handle]',
      '[data-product-id="' + pid + '"][data-product-price]',
    ];

    for (const selector of selectors) {
      const matches = document.querySelectorAll(selector);
      for (const match of matches) {
        if (isInsideQuickAddModal(match)) continue;
        return match.closest('product-card, .swiper-slide[data-product-id]') || match;
      }
    }

    return null;
  }

  function storeQuickViewWidgetInfo(widgetInfo, productId) {
    if (!widgetInfo) return;
    window.__QUICK_VIEW_WIDGET_INFO__ = widgetInfo;
    if (productId == null || productId === '') return;
    window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__ = window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__ || {};
    window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__[String(productId)] = widgetInfo;
  }

  function resolveQuickViewWidgetInfo(element, options = {}) {
    const stored = window.__QUICK_VIEW_WIDGET_INFO__;
    if (
      stored &&
      (stored.page_widget_name ||
        stored.page_widget_position ||
        stored.product_position_inside_widget ||
        stored.position_inside_widget)
    ) {
      return stored;
    }

    const productId =
      options.productId != null
        ? String(options.productId)
        : element?.getAttribute?.('data-product-id') ||
          element?.dataset?.productId ||
          element?.closest?.('[data-product-id]')?.getAttribute('data-product-id') ||
          null;

    if (productId && window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__) {
      const mapped = window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__[String(productId)];
      if (mapped) return mapped;
    }

    const pageCard = findProductCardOnPage(productId, null);
    if (pageCard) {
      return getWidgetInfoFromElement(pageCard);
    }

    return stored || null;
  }

  function resolveCartLineWidgetInfo(element, options) {
    options = options || {};
    let row =
      element?.closest?.(
        '.cart-items__table-row[data-product-id], tr[data-product-id][data-variant-id], [data-product-id][data-variant-id]'
      ) || null;

    if (!row) {
      const variantId = options.productVariantId != null ? String(options.productVariantId) : null;
      const productId = options.productId != null ? String(options.productId) : null;
      const rows = getCartItemRowsFromDom();
      if (variantId) {
        row =
          rows.find(function (itemRow) {
            return String(itemRow.getAttribute('data-variant-id') || '') === variantId;
          }) || null;
      }
      if (!row && productId) {
        row =
          rows.find(function (itemRow) {
            return String(itemRow.getAttribute('data-product-id') || '') === productId;
          }) || null;
      }
    }

    const linePosition = normalizeWidgetPositionValue(
      row?.getAttribute('data-line-item-position') ||
        row?.getAttribute('data-product-position') ||
        null
    );
    const ctaNameHint = String(options.ctaName || '').toLowerCase();
    const isUpsellAdd = ctaNameHint === 'add_to_bag' || ctaNameHint === 'add_to_cart';
    const inRecommendationWidget = !!(
      element?.closest?.('product-recommendations, [data-testid="product-recommendations-section"]') ||
      row?.closest?.('product-recommendations, [data-testid="product-recommendations-section"]')
    );

    let widgetName = options.cartWidgetName || null;
    if (!widgetName) {
      if (isUpsellAdd && inRecommendationWidget) {
        widgetName = 'cart_upsell';
      } else if (element?.closest?.('.sidecart, cart-drawer-component, cart-items-component')) {
        widgetName = 'cart';
      } else {
        widgetName = 'line_item';
      }
    }

    return {
      page_widget_name: widgetName,
      page_widget_position: 1,
      product_position_inside_widget:
        options.cartWidgetName === 'cart_upsell'
          ? getCartUpsellProductPosition(element) ??
            normalizeWidgetPositionValue(options.productPositionInsideWidget)
          : linePosition,
    };
  }

  function resolveWidgetInfoForTracking(element, options = {}) {
    const pageNameHint = String(options.pageName || '').toLowerCase();
    const ctaNameHint = String(options.ctaName || '').toLowerCase();
    const isCartContext =
      pageNameHint === 'cart' ||
      !!element?.closest('.sidecart, cart-drawer-component, cart-items-component') ||
      window.location.pathname.toLowerCase().includes('/cart');

    if (
      isCartContext &&
      (ctaNameHint === 'add_to_bag' || options.cartWidgetName) &&
      !element
    ) {
      return {
        page_widget_name: options.cartWidgetName || 'cart_upsell',
        page_widget_position: 1,
        product_position_inside_widget: normalizeWidgetPositionValue(options.productPositionInsideWidget),
      };
    }

    if (isCartContext) {
      if (ctaNameHint === 'add_to_bag' || ctaNameHint === 'add_to_cart') {
        if (isCartUpsellSectionElement(element)) {
          const upsellWidget = getWidgetInfoFromElement(element);
          return {
            page_widget_name: options.cartWidgetName || 'cart_upsell',
            page_widget_position: 1,
            product_position_inside_widget:
              getCartUpsellProductPosition(element) ??
              upsellWidget.product_position_inside_widget ??
              null,
          };
        }

        const storedWidget = resolveQuickViewWidgetInfo(element, options);
        if (
          storedWidget &&
          (storedWidget.page_widget_name ||
            storedWidget.product_position_inside_widget ||
            storedWidget.position_inside_widget)
        ) {
          return Object.assign({}, storedWidget, {
            page_widget_name:
              options.cartWidgetName || storedWidget.page_widget_name || 'cart_upsell',
          });
        }
        const cardRoot = findProductCardContextElement(element);
        if (cardRoot) {
          const cardWidget = getWidgetInfoFromElement(cardRoot);
          if (
            cardWidget.page_widget_name ||
            cardWidget.product_position_inside_widget ||
            cardWidget.position_inside_widget
          ) {
            return Object.assign({}, cardWidget, {
              page_widget_name:
                options.cartWidgetName || cardWidget.page_widget_name || 'cart_upsell',
              page_widget_position:
                cardWidget.page_widget_position != null
                  ? normalizeWidgetPositionValue(cardWidget.page_widget_position)
                  : 1,
            });
          }
        }
      }

      return resolveCartLineWidgetInfo(element, options);
    }

    if (element) {
      const isInModal =
        element.closest('#quick-add-modal-content, quick-add-dialog, .quick-add-modal') !== null;
      if (isInModal) {
        const quickViewInfo = resolveQuickViewWidgetInfo(element, options);
        if (quickViewInfo) return quickViewInfo;
      }
    }

    let rootElement = element;
    if (!rootElement && options.productId != null) {
      rootElement = findProductCardElement(options.productId, null);
    }
    if (!rootElement && options.productId != null) {
      rootElement = document.querySelector(
        'product-form-component[data-product-id="' + String(options.productId) + '"]'
      );
    }

    return getWidgetInfoFromElement(rootElement);
  }

  window.getWidgetInfoFromElement = getWidgetInfoFromElement;
  window.resolveWidgetInfoForTracking = resolveWidgetInfoForTracking;
  window.storeQuickViewWidgetInfo = storeQuickViewWidgetInfo;

  // Cart rows / product cards store prices in cents; __PRODUCT_DATA__ (PDP) uses rupees.
  function normalizeGtmProductPrice(value, pricesInCents) {
    if (value === undefined || value === null) return null;
    var n = Number(value);
    if (!Number.isFinite(n)) return null;
    return pricesInCents ? n / 100 : n;
  }

  /** When cart/form payload lacks compare-at, use product-card data attributes. */
  function preferProductCardPricing(productData, triggerElement, productId, variantId) {
    if (!productData || typeof productData !== 'object') return productData;

    var listPrice = productData.product_price;
    var salePrice = productData.product_discounted_price;
    if (listPrice != null && salePrice != null && Number(listPrice) !== Number(salePrice)) {
      var cardForImg = findProductCardElement(productId, triggerElement);
      var fromCardForImg = buildProductDataFromProductCardElement(
        cardForImg,
        productId != null ? String(productId) : null,
        variantId
      );
      if (!productData.product_img_url && fromCardForImg?.product_img_url) {
        return Object.assign({}, productData, { product_img_url: fromCardForImg.product_img_url });
      }
      return productData;
    }

    var card = findProductCardElement(productId, triggerElement);
    var fromCard = buildProductDataFromProductCardElement(
      card,
      productId != null ? String(productId) : null,
      variantId
    );
    if (!fromCard) return productData;

    var cardList = fromCard.product_price;
    var cardSale = fromCard.product_discounted_price;
    if (cardList == null || cardSale == null || Number(cardList) <= Number(cardSale)) {
      if (!productData.product_img_url && fromCard.product_img_url) {
        return Object.assign({}, productData, { product_img_url: fromCard.product_img_url });
      }
      return productData;
    }

    var pricesInCents = productData._pricesInCents === true;
    return Object.assign({}, productData, {
      product_price: pricesInCents ? cardList : normalizeGtmProductPrice(cardList, true),
      product_discounted_price: pricesInCents ? cardSale : normalizeGtmProductPrice(cardSale, true),
      product_discount_price:
        fromCard.product_discount_price != null
          ? pricesInCents
            ? fromCard.product_discount_price
            : normalizeGtmProductPrice(fromCard.product_discount_price, true)
          : productData.product_discount_price,
      product_discount_percent: fromCard.product_discount_percent || productData.product_discount_percent,
      product_img_url: productData.product_img_url || fromCard.product_img_url || null,
      product_available_quantity:
        productData.product_available_quantity != null
          ? productData.product_available_quantity
          : fromCard.product_available_quantity,
      is_in_stock: productData.is_in_stock != null ? productData.is_in_stock : fromCard.is_in_stock,
    });
  }

  function getGokwikSidecartElement() {
    try {
      var host = document.querySelector('shadow-dom-container');
      return host && host.shadowRoot ? host.shadowRoot.querySelector('.sidecart') : null;
    } catch (e) {
      return null;
    }
  }

  function isCartLineItemElement(element) {
    return !!element?.closest?.(
      '.cart-items__table-row, tr[data-line-item-position], tbody tr[data-variant-id], [data-line-item-position]'
    );
  }

  function isCartUpsellSectionElement(element) {
    if (!element || typeof element.closest !== 'function') return false;
    if (isCartLineItemElement(element)) return false;

    if (
      element.closest(
        'product-recommendations, [data-testid="product-recommendations-section"], [data-testid="product-list"], .ui-test-product-list, .section-resource-list'
      )
    ) {
      return true;
    }

    var sidecart = getGokwikSidecartElement();
    if (sidecart && sidecart.contains(element)) {
      var cartItemsArea = sidecart.querySelector(
        'tbody, .cart-items, .cart-items__table, [class*="cart-item"], [class*="line-item"]'
      );
      if (cartItemsArea && cartItemsArea.contains(element)) return false;
      return true;
    }

    var upsellRoot = element.closest(
      '[class*="upsell"], [class*="recommend"], [class*="paired"], [class*="cross-sell"], [class*="frequently"]'
    );
    if (upsellRoot && !isCartLineItemElement(upsellRoot)) return true;

    return false;
  }

  function parseRupeeTextToCents(text) {
    if (text == null || text === '') return null;
    var match = String(text)
      .replace(/,/g, '')
      .match(/₹?\s*([\d]+(?:\.\d+)?)/);
    if (!match) return null;
    var n = Number(match[1]);
    return Number.isFinite(n) ? Math.round(n * 100) : null;
  }

  function parseDiscountPercentFromText(text) {
    if (!text) return null;
    var match = String(text).match(/(\d+)\s*%?\s*off/i);
    if (!match) return null;
    return match[1];
  }

  function resolveProductInStockForEvent(additionalData, productData) {
    if (additionalData?.product_in_stock != null) return additionalData.product_in_stock;
    if (additionalData?.product_available_quantity != null) return additionalData.product_available_quantity;
    if (productData?.product_available_quantity != null) return productData.product_available_quantity;
    if (productData?.is_in_stock != null) return productData.is_in_stock;
    return null;
  }

  function resolveProductPositionForAddToBag(additionalData, productData, widgetFields, triggerElement) {
    if (additionalData?.product_position_inside_widget != null && additionalData.product_position_inside_widget !== '') {
      return normalizeWidgetPositionValue(additionalData.product_position_inside_widget);
    }
    if (additionalData?.position_inside_widget != null && additionalData.position_inside_widget !== '') {
      return normalizeWidgetPositionValue(additionalData.position_inside_widget);
    }
    if (productData?.product_position_inside_widget != null && productData.product_position_inside_widget !== '') {
      return normalizeWidgetPositionValue(productData.product_position_inside_widget);
    }
    if (widgetFields?.product_position_inside_widget != null && widgetFields.product_position_inside_widget !== '') {
      return normalizeWidgetPositionValue(widgetFields.product_position_inside_widget);
    }
    return getCartUpsellProductPosition(triggerElement);
  }

  function getGokwikUpsellPositionFromElement(element) {
    var sidecart = getGokwikSidecartElement();
    if (!sidecart || !element || !sidecart.contains(element)) return null;

    var gokwikUpsell = findGokwikUpsellContainer(sidecart);
    if (!gokwikUpsell) return null;

    var addButtons = Array.from(gokwikUpsell.querySelectorAll('button')).filter(function (btn) {
      var t = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      return t === '+ add' || t === 'add' || t.indexOf('add') !== -1;
    });
    if (!addButtons.length) return null;

    var clickedBtn = element.tagName === 'BUTTON' ? element : element.closest?.('button');
    if (!clickedBtn) return null;

    var idx = addButtons.indexOf(clickedBtn);
    if (idx < 0) {
      var card = clickedBtn.parentElement;
      for (var depth = 0; depth < 8 && card && card !== gokwikUpsell; depth++) {
        idx = addButtons.findIndex(function (btn) {
          return card.contains(btn);
        });
        if (idx >= 0) return idx + 1;
        card = card.parentElement;
      }
      return null;
    }
    return idx + 1;
  }

  function findGokwikUpsellContainer(sidecart) {
    if (!sidecart) return null;
    var headingCandidates = sidecart.querySelectorAll('h1, h2, h3, h4, h5, h6, p, span, div');
    for (var i = 0; i < headingCandidates.length; i++) {
      var text = (headingCandidates[i].textContent || '').toLowerCase();
      if (
        text.includes('commonly paired') ||
        text.includes('you may also like') ||
        text.includes('paired by students') ||
        text.includes('frequently bought')
      ) {
        var container = headingCandidates[i].parentElement;
        for (var u = 0; u < 6 && container && container !== sidecart; u++) {
          var addBtns = Array.from(container.querySelectorAll('button')).filter(function (btn) {
            var t = (btn.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
            return t === '+ add' || t === 'add' || t.indexOf('add') !== -1;
          });
          if (addBtns.length >= 1) return container;
          container = container.parentElement;
        }
        return (
          headingCandidates[i].closest(
            '[class*="upsell"], [class*="recommend"], [class*="paired"], [class*="cross-sell"], [class*="carousel"], section, article, div'
          ) || headingCandidates[i].parentElement
        );
      }
    }
    return null;
  }

  function getCartUpsellProductPosition(element) {
    if (!element) return null;

    var gokwikPosition = getGokwikUpsellPositionFromElement(element);
    if (gokwikPosition != null) return gokwikPosition;

    var resourceListItem = element.closest?.('.resource-list__item');
    if (resourceListItem) {
      var listRoot =
        resourceListItem.closest(
          '[data-testid="product-list"], .section-resource-list, product-recommendations, [data-testid="product-recommendations-section"]'
        ) || resourceListItem.parentElement;
      if (listRoot) {
        var listItems = Array.from(listRoot.querySelectorAll('.resource-list__item')).filter(function (item) {
          return !isCartLineItemElement(item);
        });
        var listIndex = listItems.indexOf(resourceListItem);
        if (listIndex >= 0) return listIndex + 1;
      }
    }

    var slide = element.closest?.('.swiper-slide[data-product-position], .swiper-slide[data-product-id]');
    if (slide) {
      var slidePos = slide.getAttribute('data-product-position');
      if (slidePos) return normalizeWidgetPositionValue(slidePos);
    }

    var sidecart = getGokwikSidecartElement();
    var gokwikUpsell = sidecart && sidecart.contains(element) ? findGokwikUpsellContainer(sidecart) : null;
    var section =
      gokwikUpsell ||
      element.closest?.(
        '[data-testid="product-list"], product-recommendations, [data-testid="product-recommendations-section"], .section-resource-list, [class*="upsell"], [class*="recommend"], [class*="paired"]'
      ) ||
      sidecart;
    if (!section) return null;

    var selectors = [
      '.swiper-slide[data-product-id]:not(.skeleton-slide)',
      '.swiper-slide[data-product-position]:not(.skeleton-slide)',
      '.resource-list__item',
      'product-card[data-product-id]',
      '.product-card[data-product-id]',
      '[data-product-id][data-product-price]',
      '[class*="product-card"]:not(.cart-items__table-row)',
      '[class*="product-item"]:not(.cart-items__table-row)',
    ];

    var items = [];
    for (var i = 0; i < selectors.length; i++) {
      items = Array.from(section.querySelectorAll(selectors[i])).filter(function (item) {
        return !isCartLineItemElement(item);
      });
      if (items.length > 0) break;
    }
    if (!items.length) return null;

    var cardRoot =
      element.closest?.(
        '.swiper-slide, .resource-list__item, product-card, .product-card, [data-product-id], [class*="product-card"], [class*="product-item"]'
      ) || element;

    var cardIndex = items.indexOf(cardRoot);
    if (cardIndex < 0) {
      for (var j = 0; j < items.length; j++) {
        if (items[j] === cardRoot || items[j].contains(cardRoot) || cardRoot.contains(items[j])) {
          cardIndex = j;
          break;
        }
      }
    }
    if (cardIndex < 0 && gokwikUpsell) {
      var pricedCard = cardRoot;
      while (
        pricedCard &&
        pricedCard !== gokwikUpsell &&
        (pricedCard.textContent || '').indexOf('₹') === -1
      ) {
        pricedCard = pricedCard.parentElement;
      }
      if (pricedCard && pricedCard.parentElement) {
        var peers = Array.from(pricedCard.parentElement.children).filter(function (child) {
          return (child.textContent || '').indexOf('₹') !== -1;
        });
        var peerIndex = peers.indexOf(pricedCard);
        if (peerIndex >= 0) return peerIndex + 1;
      }
    }
    return cardIndex >= 0 ? cardIndex + 1 : null;
  }

  function normalizeInventoryQuantityValue(value) {
    if (typeof window.parseProductAvailableQuantity === 'function') {
      return window.parseProductAvailableQuantity(value);
    }
    if (value == null || value === '') return null;
    var n = Number(value);
    if (!Number.isFinite(n)) return null;
    return n < 0 ? Math.abs(n) : n;
  }

  function getStorefrontAccessToken() {
    if (window.__PW_STOREFRONT_TOKEN__) return window.__PW_STOREFRONT_TOKEN__;
    var el =
      document.querySelector('[data-storefront-token]') ||
      document.querySelector('[data-collection-handle][data-token]') ||
      document.querySelector('.product-swiper[data-token]');
    var token = el && (el.getAttribute('data-storefront-token') || el.getAttribute('data-token'));
    if (token) window.__PW_STOREFRONT_TOKEN__ = token;
    return token || null;
  }

  async function fetchVariantQuantityAvailableFromStorefront(variantId) {
    var token = getStorefrontAccessToken();
    if (!token || variantId == null) return null;
    try {
      var res = await fetch('/api/2025-01/graphql.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
          query:
            'query VariantQuantity($id: ID!) { node(id: $id) { ... on ProductVariant { quantityAvailable } } }',
          variables: { id: 'gid://shopify/ProductVariant/' + String(variantId) },
        }),
      });
      if (!res.ok) return null;
      var json = await res.json();
      return normalizeInventoryQuantityValue(json?.data?.node?.quantityAvailable);
    } catch (e) {
      return null;
    }
  }

  async function resolveProductAvailableQuantity(variantId) {
    var candidates = Array.prototype.slice.call(arguments, 1);
    for (var i = 0; i < candidates.length; i++) {
      var qty = normalizeInventoryQuantityValue(candidates[i]);
      if (qty != null) return qty;
    }
    return fetchVariantQuantityAvailableFromStorefront(variantId);
  }

  function parseUpsellCardProductData(cardRoot, variantId) {
    if (!cardRoot) return null;

    var dataHost =
      cardRoot.matches?.('[data-product-id][data-product-price], product-card[data-product-id], .product-card[data-product-id]')
        ? cardRoot
        : cardRoot.querySelector?.(
            'product-card[data-product-id], .product-card[data-product-id], [data-product-id][data-product-price], [data-product-handle][data-product-id]'
          );
    if (dataHost) {
      var pid = dataHost.getAttribute('data-product-id');
      if (pid) {
        return buildProductDataFromProductCardElement(dataHost, pid, variantId);
      }
    }

    var rupeeAmounts = [];
    var rupeeRegex = /₹\s*([\d,]+(?:\.\d+)?)/g;
    var text = cardRoot.textContent || '';
    var match;
    while ((match = rupeeRegex.exec(text)) !== null) {
      var cents = parseRupeeTextToCents(match[0]);
      if (cents != null) rupeeAmounts.push(cents);
    }
    rupeeAmounts = Array.from(new Set(rupeeAmounts)).sort(function (a, b) {
      return b - a;
    });

    var listCents = rupeeAmounts[0] || null;
    var saleCents = rupeeAmounts.length > 1 ? rupeeAmounts[rupeeAmounts.length - 1] : listCents;
    var discountCents =
      listCents != null && saleCents != null && listCents > saleCents ? listCents - saleCents : null;
    var discountPercent = parseDiscountPercentFromText(text);
    if (!discountPercent && listCents && saleCents && listCents > saleCents) {
      discountPercent = String(Math.round(((listCents - saleCents) * 100) / listCents));
    }

    var titleEl = cardRoot.querySelector?.('h2, h3, h4, [class*="title"], [class*="name"]');
    var title = titleEl?.textContent?.trim() || null;
    var invRaw =
      cardRoot.getAttribute?.('data-product-inventory-quantity') ||
      cardRoot.getAttribute?.('data-inventory-quantity') ||
      null;
    var invQty = normalizeInventoryQuantityValue(invRaw);

    return {
      product_id: cardRoot.getAttribute?.('data-product-id') || null,
      product_title: title,
      product_img_url: pickProductImgUrlFromElement(cardRoot),
      product_slug: cardRoot.getAttribute?.('data-product-handle') || null,
      product_variant_id: variantId != null ? String(variantId) : cardRoot.getAttribute?.('data-variant-id') || null,
      product_price: listCents,
      product_discounted_price: saleCents,
      product_discount_price: discountCents,
      product_discount_percent: discountPercent,
      product_available_quantity: invQty,
      is_in_stock: invQty,
      _pricesInCents: true,
    };
  }

  async function fetchProductDataFromProductJs(variantId, productId, productSlug) {
    try {
      var handle = productSlug || null;
      var pid = productId != null ? String(productId) : null;
      if (!handle || !pid) {
        var cartRes = await fetch('/cart.js');
        if (!cartRes.ok) return null;
        var cart = await cartRes.json();
        var item = (cart.items || []).find(function (it) {
          return String(it.variant_id) === String(variantId);
        });
        if (!item) return null;
        if (!handle && typeof item.url === 'string') {
          var slugMatch = item.url.match(/\/products\/([^\/\?]+)/);
          handle = slugMatch ? slugMatch[1] : null;
        }
        pid = pid || (item.product_id != null ? String(item.product_id) : null);
      }
      if (!handle) return null;

      var res = await fetch('/products/' + handle + '.js');
      if (!res.ok) return null;
      var product = await res.json();
      var variant =
        (product.variants || []).find(function (v) {
          return String(v.id) === String(variantId);
        }) ||
        (product.variants || []).find(function (v) {
          return v.available;
        }) ||
        (product.variants || [])[0];
      if (!variant) return null;

      var compareAt = Number(variant.compare_at_price) || 0;
      var salePrice = Number(variant.price) || 0;
      var listCents = compareAt > salePrice ? compareAt : salePrice;
      var discountedCents = salePrice;
      var discountCents = listCents > discountedCents ? listCents - discountedCents : null;
      var discountPercent =
        compareAt > salePrice && compareAt > 0
          ? String(Math.round(((compareAt - salePrice) * 100) / compareAt))
          : null;
      var invQty = variant.inventory_quantity;
      var availQty = normalizeInventoryQuantityValue(invQty);
      if (availQty == null) {
        availQty = await fetchVariantQuantityAvailableFromStorefront(variant.id);
      }

      return {
        product_id: String(product.id),
        product_title: product.title,
        product_img_url:
          (variant.featured_image && variant.featured_image.src) ||
          (typeof product.featured_image === 'string' ? product.featured_image : null) ||
          (Array.isArray(product.images) && product.images[0]) ||
          null,
        product_slug: product.handle,
        product_variant_id: String(variant.id),
        product_price: listCents,
        product_discounted_price: discountedCents,
        product_discount_price: discountCents,
        product_discount_percent: discountPercent,
        product_available_quantity: availQty,
        is_in_stock: availQty,
        _pricesInCents: true,
      };
    } catch (e) {
      return null;
    }
  }

  async function buildCartUpsellAddToBagData(variantId, triggerElement) {
    var stored = window.__PW_LAST_CART_UPSELL_CLICK__;
    var recentStored =
      stored && Date.now() - stored.ts < 8000 ? stored : null;
    if (
      recentStored &&
      recentStored.variantId &&
      variantId &&
      String(recentStored.variantId) !== String(variantId)
    ) {
      recentStored = null;
    }
    var clickElement = triggerElement || recentStored?.triggerElement || null;
    var upsellCard =
      recentStored?.cardElement ||
      (clickElement
        ? clickElement.closest?.(
            '.swiper-slide, .resource-list__item, product-card, .product-card, [data-product-id], [class*="product-card"], [class*="product-item"]'
          )
        : null);

    var productData = recentStored?.productData ? Object.assign({}, recentStored.productData) : null;
    if (!productData && upsellCard) {
      productData = parseUpsellCardProductData(upsellCard, variantId);
    }

    var card = findProductCardElement(
      productData?.product_id || recentStored?.productId || null,
      clickElement
    );
    var fromCard = null;
    if (card) {
      fromCard = buildProductDataFromProductCardElement(
        card,
        card.getAttribute('data-product-id'),
        variantId
      );
      if (fromCard) {
        productData = preferProductCardPricing(
          fillMissingProductFields(productData || {}, fromCard),
          clickElement,
          fromCard.product_id,
          variantId
        );
      }
    }

    var fromApi = await fetchProductDataFromProductJs(
      variantId,
      productData?.product_id,
      productData?.product_slug
    );
    if (fromApi) {
      productData = fillMissingProductFields(productData || {}, fromApi);
      if (fromApi.product_price != null && fromApi.product_discounted_price != null) {
        productData.product_price = fromApi.product_price;
        productData.product_discounted_price = fromApi.product_discounted_price;
        productData.product_discount_price = fromApi.product_discount_price;
        productData.product_discount_percent = fromApi.product_discount_percent;
      }
      productData._pricesInCents = true;
    }

    var resolvedInventoryQty = await resolveProductAvailableQuantity(
      variantId,
      fromCard?.product_available_quantity,
      productData?.product_available_quantity,
      recentStored?.productData?.product_available_quantity
    );
    if (productData && resolvedInventoryQty != null) {
      productData.product_available_quantity = resolvedInventoryQty;
      productData.is_in_stock = resolvedInventoryQty;
    }

    var upsellWidget = resolveWidgetInfoForTracking(clickElement || upsellCard || card, {
      pageName: 'Cart',
      productId: productData?.product_id,
      productVariantId: variantId,
      ctaName: 'add_to_bag',
      cartWidgetName: 'cart_upsell',
    });
    var sectionPosition =
      recentStored?.product_position_inside_widget ??
      getCartUpsellProductPosition(clickElement || upsellCard || card);
    upsellWidget = Object.assign({}, upsellWidget, {
      page_widget_name: 'cart_upsell',
      page_widget_position: 1,
      product_position_inside_widget:
        sectionPosition != null ? sectionPosition : upsellWidget.product_position_inside_widget,
    });

    if (productData) {
      productData.product_position_inside_widget = upsellWidget.product_position_inside_widget ?? null;
      productData.product_in_stock =
        productData.product_available_quantity != null ? productData.product_available_quantity : null;
    }

    return { productData: productData || {}, upsellWidget: upsellWidget || {} };
  }

  function storeCartUpsellClickContext(payload) {
    window.__PW_LAST_CART_UPSELL_CLICK__ = Object.assign({ ts: Date.now() }, payload || {});
  }

  function findProductCardElement(productId, triggerElement) {
    var pid = productId != null ? String(productId) : null;
    if (!pid) return null;

    var fromPage = findProductCardOnPage(pid, triggerElement);
    if (fromPage) return fromPage;

    var roots = [document];
    try {
      var host = document.querySelector('shadow-dom-container');
      if (host && host.shadowRoot) roots.push(host.shadowRoot);
    } catch (e) {}

    var selectors = [
      'product-card[data-product-id="' + pid + '"]',
      '[data-product-id="' + pid + '"][data-product-price]',
      '[data-product-id="' + pid + '"][data-product-handle]',
    ];

    for (var r = 0; r < roots.length; r++) {
      for (var s = 0; s < selectors.length; s++) {
        var el = roots[r].querySelector(selectors[s]);
        if (el && !isInsideQuickAddModal(el)) return el;
      }
    }

    return null;
  }

  function pickProductImgUrlFromElement(element) {
    if (!element) return null;
    const fromAttr = element.getAttribute('data-product-img-url');
    if (fromAttr) return fromAttr;
    const featuredLink = element.closest('[data-featured-media-url]');
    if (featuredLink) {
      const featuredUrl = featuredLink.getAttribute('data-featured-media-url');
      if (featuredUrl) return featuredUrl;
    }
    const imgEl = element.querySelector('img[src]');
    if (imgEl) {
      return imgEl.currentSrc || imgEl.getAttribute('src') || null;
    }
    return null;
  }

  function resolveProductImgUrl(productData, options = {}) {
    if (productData?.product_img_url) return productData.product_img_url;
    if (options.additionalData?.product_img_url) {
      return options.additionalData.product_img_url;
    }

    const triggerElement = options.triggerElement || null;
    if (triggerElement) {
      let fromTrigger = pickProductImgUrlFromElement(triggerElement);
      if (fromTrigger) return fromTrigger;

      const cartRow = triggerElement.closest(
        '.cart-items__table-row[data-product-id], [data-product-id][data-variant-id]'
      );
      if (cartRow) {
        fromTrigger = pickProductImgUrlFromElement(cartRow);
        if (fromTrigger) return fromTrigger;
      }
    }

    const productId = productData?.product_id != null ? productData.product_id : null;
    if (productId != null) {
      const card = findProductCardElement(productId, triggerElement);
      const fromCard = pickProductImgUrlFromElement(card);
      if (fromCard) return fromCard;
    }

    return null;
  }

  function withMoeProductImgUrl(productData, options) {
    if (!productData || typeof productData !== 'object') return productData;
    const productImgUrl = resolveProductImgUrl(productData, options);
    if (!productImgUrl) return productData;
    return Object.assign({}, productData, { product_img_url: productImgUrl });
  }

  async function enrichProductDataWithImgUrl(productData, options) {
    let enriched = withMoeProductImgUrl(productData, options);
    if (enriched.product_img_url) return enriched;

    const variantId =
      options?.additionalData?.product_variant_id ?? enriched.product_variant_id ?? null;
    const productId = options?.additionalData?.product_id ?? enriched.product_id ?? null;
    if (variantId == null && productId == null) return enriched;

    const fromCartJs = await fetchProductDataFromCartJs(variantId, productId);
    if (fromCartJs?.product_img_url) {
      enriched = Object.assign({}, enriched, { product_img_url: fromCartJs.product_img_url });
    }
    return enriched;
  }

  function buildProductDataFromProductCardElement(productCard, pid, variantId) {
    if (!productCard) return null;

    var productTitle =
      productCard.getAttribute('data-product-title') ||
      productCard.querySelector('.product-title, [class*="product-title"]')?.textContent?.trim() ||
      productCard.querySelector('h2, h3, h4')?.textContent?.trim() ||
      null;

    var l1 = productCard.getAttribute('data-l1-category-name');
    var l2 = productCard.getAttribute('data-l2-category-name');
    var l3 = productCard.getAttribute('data-l3-category-name');
    var parentSlide = productCard.closest('.swiper-slide');
    if (parentSlide) {
      l1 = l1 || parentSlide.getAttribute('data-l1-category-name');
      l2 = l2 || parentSlide.getAttribute('data-l2-category-name');
      l3 = l3 || parentSlide.getAttribute('data-l3-category-name');
    }
    var parentLi = productCard.closest('.product-grid__item, li[data-product-id]');
    if (parentLi) {
      l1 = l1 || parentLi.getAttribute('data-l1-category-name');
      l2 = l2 || parentLi.getAttribute('data-l2-category-name');
      l3 = l3 || parentLi.getAttribute('data-l3-category-name');
    }

    var priceRaw = productCard.getAttribute('data-product-price');
    var compareAtRaw = productCard.getAttribute('data-product-compare-at-price');
    var priceCent = priceRaw ? parseFloat(priceRaw) : 0;
    var compareAtCent = compareAtRaw ? parseFloat(compareAtRaw) : 0;
    var productPrice = compareAtCent > 0 ? compareAtCent : priceCent;
    var productDiscountedPrice = priceCent;
    var productDiscountPrice =
      compareAtCent > 0 && compareAtCent > priceCent ? compareAtCent - priceCent : null;
    var productDiscountPercent = productCard.getAttribute('data-product-discount-percent') || null;
    var productAvailableQuantity = productCard.getAttribute('data-product-inventory-quantity');
    var qtyNum =
      typeof window.parseProductAvailableQuantity === 'function'
        ? window.parseProductAvailableQuantity(productAvailableQuantity)
        : productAvailableQuantity
          ? parseInt(productAvailableQuantity, 10)
          : null;

    return {
      product_id: pid,
      product_title: productTitle,
      product_img_url: pickProductImgUrlFromElement(productCard),
      product_slug: productCard.getAttribute('data-product-handle') || null,
      product_moq: 50,
      product_discount_percent: productDiscountPercent,
      is_in_stock: qtyNum ?? null,
      product_price: productPrice || null,
      product_discount_price: productDiscountPrice,
      product_discounted_price: productDiscountedPrice || null,
      product_tag: productCard.getAttribute('data-product-tags') || null,
      preorder: productCard.getAttribute('data-preorder') || 'no',
      product_available_quantity: qtyNum ?? null,
      l1_category_name: l1 || null,
      l2_category_name: l2 || null,
      l3_category_name: l3 || null,
      product_category_slug: productCard.getAttribute('data-product-category-slug') || null,
      product_category_id: productCard.getAttribute('data-product-category-id') || null,
      product_sub_category_id: productCard.getAttribute('data-product-sub-category-id') || null,
      product_sub_sub_category_id: productCard.getAttribute('data-product-sub-sub-category-id') || null,
      product_variant_id:
        (variantId != null ? String(variantId) : null) ||
        productCard.getAttribute('data-product-variant-id') ||
        productCard.getAttribute('data-variant-id'),
      _pricesInCents: true,
    };
  }

  async function fetchProductDataFromCartJs(variantId, productId) {
    try {
      var root =
        typeof window.Shopify !== 'undefined' && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root
          : '/';
      var response = await fetch(root + 'cart.js');
      if (!response.ok) return null;
      var cart = await response.json();
      var item = (cart.items || []).find(function (it) {
        if (variantId != null) return String(it.variant_id) === String(variantId);
        if (productId != null) return String(it.product_id) === String(productId);
        return false;
      });
      if (!item) return null;

      var priceCents = typeof item.price === 'number' ? item.price : null;
      var originalCents = typeof item.original_price === 'number' ? item.original_price : priceCents;
      var actualPriceCents =
        originalCents != null && priceCents != null && originalCents > priceCents
          ? originalCents
          : originalCents ?? priceCents;
      var discountedPriceCents = priceCents;
      var discountPriceCents =
        actualPriceCents != null && discountedPriceCents != null
          ? Math.max(0, actualPriceCents - discountedPriceCents)
          : null;
      var slug = null;
      if (typeof item.url === 'string') {
        var slugMatch = item.url.match(/\/products\/([^\/\?]+)/);
        slug = slugMatch ? slugMatch[1] : null;
      }

      return {
        product_id: item.product_id != null ? String(item.product_id) : null,
        product_title: item.product_title || item.title || null,
        product_img_url: item.image || null,
        product_slug: slug,
        product_moq: 50,
        product_discount_percent: null,
        is_in_stock: null,
        product_price: actualPriceCents,
        product_discount_price: discountPriceCents,
        product_discounted_price: discountedPriceCents,
        product_tag: null,
        preorder: null,
        product_available_quantity: null,
        l1_category_name: null,
        l2_category_name: null,
        l3_category_name: null,
        product_category_slug: null,
        product_category_id: null,
        product_sub_category_id: null,
        product_sub_sub_category_id: null,
        product_variant_id: item.variant_id != null ? String(item.variant_id) : null,
        _pricesInCents: true,
      };
    } catch (e) {
      return null;
    }
  }

  function fillMissingProductFields(target, source) {
    if (!target || !source || typeof target !== 'object' || typeof source !== 'object') {
      return target;
    }
    Object.keys(source).forEach(function (key) {
      if (key.indexOf('_') === 0) return;
      if (target[key] != null && target[key] !== '') return;
      if (source[key] == null || source[key] === '') return;
      target[key] = source[key];
    });
    return target;
  }

  function mergeAdditionalDataProductFields(additionalData) {
    if (
      additionalData.product_price == null &&
      additionalData.product_title == null &&
      additionalData.product_discounted_price == null
    ) {
      return null;
    }
    return {
      product_id: additionalData.product_id != null ? String(additionalData.product_id) : null,
      product_title: additionalData.product_title || null,
      product_img_url: additionalData.product_img_url || null,
      product_slug: additionalData.product_slug || null,
      product_moq: 50,
      product_discount_percent: additionalData.product_discount_percent || null,
      is_in_stock: additionalData.product_available_quantity ?? null,
      product_price: additionalData.product_price ?? null,
      product_discount_price: additionalData.product_discount_price ?? null,
      product_discounted_price: additionalData.product_discounted_price ?? null,
      product_tag: additionalData.product_tag || null,
      preorder: additionalData.preorder || null,
      product_available_quantity: additionalData.product_available_quantity ?? null,
      l1_category_name: additionalData.l1_category_name || null,
      l2_category_name: additionalData.l2_category_name || null,
      l3_category_name: additionalData.l3_category_name || null,
      product_category_slug: additionalData.product_category_slug || null,
      product_category_id: additionalData.product_category_id || null,
      product_sub_category_id: additionalData.product_sub_category_id || null,
      product_sub_sub_category_id: additionalData.product_sub_sub_category_id || null,
      product_variant_id:
        additionalData.product_variant_id != null ? String(additionalData.product_variant_id) : null,
      _pricesInCents: additionalData._pricesInCents !== false,
    };
  }

  // Track remove from bag event
  // Event: pwst_remove_from_bag
  // Definition: User removing product from bag/cart
  function trackRemoveFromBag(additionalData = {}) {
    const userData = getUserData();
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;
    
    // Get product data - reuse the same function as add to bag
    async function getProductDataForTracking() {
      const productId = additionalData.product_id;
      const variantId = additionalData.product_variant_id;
      const triggerElement = additionalData.triggerElement || additionalData.trigger_element || null;
      const triggerRow = triggerElement?.closest('.cart-items__table-row[data-product-id], [data-product-id][data-variant-id]') || null;
      const pageNameHint = (additionalData.page_name || '').toLowerCase();
      const useCartLineRowForPricing =
        pageNameHint === 'cart' ||
        !!triggerRow ||
        !!triggerElement?.closest('.sidecart, cart-drawer-component') ||
        !!(triggerElement && triggerElement.closest('tbody tr.cart-items__table-row[data-product-id]')) ||
        !!triggerElement?.closest('cart-quantity-selector-component');

      if (useCartLineRowForPricing) {
        const rows = getCartItemRowsFromDom();
        let matchedRow = triggerRow || null;
        const variantIdStr = variantId != null ? String(variantId) : null;
        const productIdStr = productId != null ? String(productId) : null;

        if (!matchedRow && variantIdStr) {
          matchedRow = rows.find(function (row) {
            return String(row.getAttribute('data-variant-id') || '') === variantIdStr;
          }) || null;
        }
        if (!matchedRow && productIdStr && !variantIdStr) {
          matchedRow = rows.find(function (row) {
            return String(row.getAttribute('data-product-id') || '') === productIdStr;
          }) || null;
        }

        if (matchedRow) {
          const cartProduct = mapCartRowToProductData(matchedRow);
          return {
            product_id: cartProduct.product_id || (productId != null ? String(productId) : null),
            product_title: cartProduct.product_title || null,
            product_img_url: cartProduct.product_img_url || pickProductImgUrlFromElement(matchedRow) || null,
            product_slug: cartProduct.product_slug || null,
            product_moq: 50,
            product_discount_percent: cartProduct.product_discount_percent,
            is_in_stock: cartProduct.product_in_stock,
            product_price: cartProduct.product_price,
            product_discount_price: cartProduct.product_discount_price,
            product_discounted_price: cartProduct.product_discounted_price,
            product_tag: cartProduct.product_tag || null,
            preorder: cartProduct.preorder || null,
            product_available_quantity: cartProduct.product_available_quantity ?? null,
            l1_category_name: cartProduct.l1_category_name || null,
            l2_category_name: cartProduct.l2_category_name || null,
            l3_category_name: cartProduct.l3_category_name || null,
            product_category_slug: cartProduct.product_category_slug || null,
            product_category_id: cartProduct.product_category_id || null,
            product_sub_category_id: cartProduct.product_sub_category_id || null,
            product_sub_sub_category_id: null,
            product_variant_id: cartProduct.product_variant_id || (variantId != null ? String(variantId) : null),
            product_position_inside_widget: cartProduct.product_position_inside_widget ?? null,
            _pricesInCents: true,
          };
        }
      }
      
      if (productId) {
        if (window.__PRODUCT_DATA__ && window.__PRODUCT_DATA__.product_id && 
            window.__PRODUCT_DATA__.product_id.toString() === productId.toString()) {
          return Object.assign({}, getProductData(), { _pricesInCents: false });
        }
        
        let productCard = null;
        if (triggerElement && triggerElement.closest) {
          productCard = triggerElement.closest('product-card[data-product-id="' + productId + '"]');
        }
        if (!productCard) {
          productCard = document.querySelector('product-card[data-product-id="' + productId + '"]');
        }
        if (!productCard) {
          productCard = document.querySelector('[data-product-id="' + productId + '"]');
        }
        
        let l1CategoryName = null;
        let l2CategoryName = null;
        let l3CategoryName = null;
        
        if (productCard) {
          const productTitle = productCard.querySelector('.product-title, [class*="product-title"]')?.textContent?.trim() ||
                              productCard.querySelector('h2, h3, h4')?.textContent?.trim() ||
                              null;
          
          l1CategoryName = productCard.getAttribute('data-l1-category-name');
          l2CategoryName = productCard.getAttribute('data-l2-category-name');
          l3CategoryName = productCard.getAttribute('data-l3-category-name');
          
          if (!l1CategoryName || !l2CategoryName || !l3CategoryName) {
            const parentSlide = productCard.closest('.swiper-slide');
            if (parentSlide) {
              if (!l1CategoryName) l1CategoryName = parentSlide.getAttribute('data-l1-category-name');
              if (!l2CategoryName) l2CategoryName = parentSlide.getAttribute('data-l2-category-name');
              if (!l3CategoryName) l3CategoryName = parentSlide.getAttribute('data-l3-category-name');
            }
            
            if (!l1CategoryName || !l2CategoryName || !l3CategoryName) {
              const parentLi = productCard.closest('.product-grid__item, li[data-product-id]');
              if (parentLi) {
                if (!l1CategoryName) l1CategoryName = parentLi.getAttribute('data-l1-category-name');
                if (!l2CategoryName) l2CategoryName = parentLi.getAttribute('data-l2-category-name');
                if (!l3CategoryName) l3CategoryName = parentLi.getAttribute('data-l3-category-name');
              }
            }
          }
          
          l1CategoryName = l1CategoryName || null;
          l2CategoryName = l2CategoryName || null;
          l3CategoryName = l3CategoryName || null;
          
          // Use data attributes as base source (same approach as cart events)
          const priceRaw = productCard.getAttribute('data-product-price');
          const compareAtRaw = productCard.getAttribute('data-product-compare-at-price');
          const priceCent = priceRaw ? parseFloat(priceRaw) : 0;
          const compareAtCent = compareAtRaw ? parseFloat(compareAtRaw) : 0;
          const priceRupees = priceCent;
          const compareAtRupees = compareAtCent;
          const productPrice = compareAtRupees > 0 ? compareAtRupees : priceRupees;
          const productDiscountedPrice = priceRupees;
          const productDiscountPrice = (compareAtRupees > 0 && compareAtRupees > priceRupees)
            ? (compareAtRupees - priceRupees)
            : null;
          const productDiscountPercent = productCard.getAttribute('data-product-discount-percent') || null;
          const productAvailableQuantity = productCard.getAttribute('data-product-inventory-quantity');
          const productTags = productCard.getAttribute('data-product-tags') || null;
          const preorder = productCard.getAttribute('data-preorder') || 'no';
          const productHandle = productCard.getAttribute('data-product-handle') || null;
          const productVariantId = additionalData.product_variant_id || productCard.getAttribute('data-product-variant-id') || null;
          const qtyNum = productAvailableQuantity ? parseInt(productAvailableQuantity, 10) : null;

          return {
            product_id: productId.toString(),
            product_title: productTitle,
            product_img_url: pickProductImgUrlFromElement(productCard),
            product_slug: productHandle,
            product_moq: 50,
            product_discount_percent: productDiscountPercent,
            is_in_stock: qtyNum ?? null,
            product_price: productPrice,
            product_discount_price: productDiscountPrice,
            product_discounted_price: productDiscountedPrice,
            product_tag: productTags,
            preorder: preorder,
            product_available_quantity: qtyNum ?? null,
            l1_category_name: l1CategoryName,
            l2_category_name: l2CategoryName,
            l3_category_name: l3CategoryName,
            product_category_slug: null,
            product_variant_id: productVariantId,
          };
        }
      }
      
      return Object.assign({}, getProductData(), { _pricesInCents: false });
    }
    
    // Get coupon information
    function getCouponInfo() {
      try {
        const offerData = window.__PRODUCT_OFFER_DATA__ || {};
        return {
          coupon_present: offerData.coupon_present === true,
          coupon_type: offerData.coupon_type || null,
        };
      } catch (err) {
        console.error('Error getting coupon info:', err);
        return { coupon_present: false, coupon_type: null };
      }
    }

    // Determine page_name from URL
    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) {
        return 'pdp';
      }
      if (path.includes('/cart')) {
        return 'cart';
      }
      return 'other';
    }

    const couponInfo = getCouponInfo();
    const triggerElement =
      additionalData.triggerElement ||
      additionalData.trigger_element ||
      (additionalData.product_id != null
        ? findProductCardElement(additionalData.product_id, null)
        : null) ||
      document.activeElement ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    const widgetInfo =
      additionalData.page_widget_name !== undefined
        ? {
            page_widget_name: additionalData.page_widget_name,
            page_widget_position: additionalData.page_widget_position,
            product_position_inside_widget: additionalData.product_position_inside_widget,
          }
        : resolveWidgetInfoForTracking(triggerElement, {
            pageName: additionalData.page_name,
            productId: additionalData.product_id,
            productVariantId: additionalData.product_variant_id,
          });
    const widgetFields = buildGtmWidgetPayload(widgetInfo);

    // Get product data asynchronously, cart_id always from global state
    getProductDataForTracking().then(async (productData) => {
      productData = await enrichProductDataWithImgUrl(productData, { triggerElement, additionalData });
      const pricesInCents = productData._pricesInCents !== false;
      const cartId = window.__PW_CART_ID__ || null;
      const ctaName = additionalData.cta_name || 'quantity_icon';
      const pageNameResolved = additionalData.page_name || getPageNameFromUrl();
      const pageContextName = (typeof getPageContext === 'function' && getPageContext() && getPageContext().pageName != null)
        ? getPageContext().pageName
        : pageNameResolved;
      const cartOpen = (function () {
        try {
          const host = document.querySelector('shadow-dom-container');
          const sidecart = host?.shadowRoot?.querySelector('.sidecart');
          return !!(sidecart && sidecart.getClientRects().length > 0);
        } catch (e) {
          return false;
        }
      })();
      const eventPageName =
        (ctaName === 'quantity_icon' || ctaName === 'delete') && cartOpen
          ? 'Cart'
          : pageContextName;
      const eventData = {
        event: 'ga_pwst_remove_from_bag',
        platform: gtmConfig.platform || 'web',
        organisation_name: gtmConfig.organisation_name || 'pw',
        business_unit: gtmConfig.business_unit || 'pw_store',
        page_url: pageUrl,
        page_name: eventPageName,
        is_logged_in: Boolean((window.__LOGIN_DATA__ || {}).is_logged_in),
        from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
        user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
        pw_user_id: userData.pw_user_id,
        cohort_id: userData.cohort_id,
        cohort_name: userData.cohort_name,
        breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
        ...widgetFields,
        product_position_inside_widget:
          productData.product_position_inside_widget != null &&
          productData.product_position_inside_widget !== ''
            ? normalizeWidgetPositionValue(productData.product_position_inside_widget)
            : widgetFields.product_position_inside_widget ?? 1,
        coupon_type: additionalData.coupon_type !== undefined ? additionalData.coupon_type : couponInfo.coupon_type,
        coupon_present: additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present,
        total_quantity: additionalData.total_quantity !== undefined ? additionalData.total_quantity : 1,
        cta_name: additionalData.cta_name || 'quantity_icon',
        cart_id: cartId,
        product_id: (productData.product_id != null && productData.product_id !== '') ? productData.product_id : (additionalData.product_id !== undefined ? additionalData.product_id : null),
        product_title: additionalData.product_title || productData.product_title,
        product_slug: additionalData.product_slug || productData.product_slug,
        product_moq: additionalData.product_moq !== undefined ? additionalData.product_moq : (productData.product_moq ?? null),
        product_discount_percent: additionalData.product_discount_percent || productData.product_discount_percent,
        product_in_stock: (additionalData.product_available_quantity !== undefined ? additionalData.product_available_quantity : productData.product_available_quantity) ?? null,
        product_price: normalizeGtmProductPrice(
          additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price,
          pricesInCents
        ),
        product_discount_price: normalizeGtmProductPrice(
          additionalData.product_discount_price !== undefined ? additionalData.product_discount_price : productData.product_discount_price,
          pricesInCents
        ),
        product_discounted_price: normalizeGtmProductPrice(
          additionalData.product_discounted_price !== undefined ? additionalData.product_discounted_price : productData.product_discounted_price,
          pricesInCents
        ),
        product_tag: additionalData.product_tag != null ? additionalData.product_tag : productData.product_tag,
        preorder: additionalData.preorder != null ? additionalData.preorder : productData.preorder,
        l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
        l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
        l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
        product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
        product_variant_id: additionalData.product_variant_id !== undefined ? additionalData.product_variant_id : productData.product_variant_id,
        timestamp: new Date().toISOString(),
      };

      // Mengage event data - use helper for base structure with class/exam
      const baseMoeData = buildBaseMoeEventData('moe_pwst_remove_product_from_bag', {
        // Cart data
        cart_added_date: additionalData.cart_added_date || null,
      }, {
        pageUrl: pageUrl,
      });

      const moeProductData = await enrichProductDataWithImgUrl(productData, { triggerElement, additionalData });

      // Add product and category fields
      const moeEventData = {
        ...baseMoeData,

        // Category
        category: eventData.l1_category_name || null,
        l1_category_name: eventData.l1_category_name || null,
        l2_category_name: eventData.l2_category_name || null,
        l3_category_name: eventData.l3_category_name || null,
        // Product fields
        product_id: eventData.product_id,
        product_title: eventData.product_title,
        product_img_url: moeProductData.product_img_url || null,
        product_moq: 50,
        product_discount_percent: eventData.product_discount_percent,
        product_in_stock: eventData.product_in_stock,
        product_price: eventData.product_price,
        product_discounted_price: eventData.product_discounted_price,
        product_available_quantity: productData.product_available_quantity ?? null,
      };

      console.log('ðŸ’¾ [MOE] Remove from bag Event data:', moeEventData);
      dataLayer.push(moeEventData);
      dataLayer.push(eventData);
    }).catch((err) => {
      console.error('Error tracking remove from bag:', err);
    });
  }
  window.trackRemoveFromBag = trackRemoveFromBag;

  // Track add to bag event
  // Event: pwst_add_to_bag
  // Definition: User adding product to bag/cart
  function trackAddToBag(additionalData = {}) {
    additionalData = Object.assign({}, additionalData, {
      cta_name: normalizeAddToBagCtaName(additionalData.cta_name),
    });
    const userData = getUserData();
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;
    
    // Get product data - prioritize product ID from additionalData or trigger element
    async function getProductDataForTracking() {
      const productId = additionalData.product_id;
      const variantId = additionalData.product_variant_id;
      const triggerElement = additionalData.triggerElement || additionalData.trigger_element || null;
      const triggerRow = triggerElement?.closest('.cart-items__table-row[data-product-id], [data-product-id][data-variant-id]') || null;
      const pageNameHint = (additionalData.page_name || '').toLowerCase();
      const ctaNameHint = (additionalData.cta_name || '').toLowerCase();
      const isCartUpsellNewAdd =
        pageNameHint === 'cart' &&
        (ctaNameHint === 'add_to_bag' || ctaNameHint === 'add_to_cart');

      if (isCartUpsellNewAdd && variantId != null) {
        const upsellPayload = await buildCartUpsellAddToBagData(variantId, triggerElement);
        if (upsellPayload.productData && upsellPayload.productData.product_id) {
          return Object.assign({}, upsellPayload.productData, {
            product_position_inside_widget:
              upsellPayload.upsellWidget?.product_position_inside_widget ?? null,
            _pricesInCents: true,
          });
        }
      }

      const fromAdditional = mergeAdditionalDataProductFields(additionalData);
      if (fromAdditional) {
        const cardForAdditional = buildProductDataFromProductCardElement(
          findProductCardElement(productId, triggerElement),
          productId != null ? String(productId) : null,
          variantId
        );
        if (cardForAdditional) {
          return fillMissingProductFields(fromAdditional, cardForAdditional);
        }
        return fromAdditional;
      }

      const useCartLineRowForPricing =
        !isCartUpsellNewAdd &&
        ((pageNameHint === 'cart' && ctaNameHint === 'quantity_icon') ||
          !!triggerRow ||
          !!(triggerElement && triggerElement.closest('tbody tr.cart-items__table-row[data-product-id]')) ||
          !!triggerElement?.closest('cart-quantity-selector-component'));

      if (useCartLineRowForPricing) {
        const rows = getCartItemRowsFromDom();
        let matchedRow = triggerRow || null;
        const variantIdStr = variantId != null ? String(variantId) : null;
        const productIdStr = productId != null ? String(productId) : null;

        if (!matchedRow && variantIdStr) {
          matchedRow = rows.find(function (row) {
            return String(row.getAttribute('data-variant-id') || '') === variantIdStr;
          }) || null;
        }
        if (!matchedRow && productIdStr && !variantIdStr) {
          matchedRow = rows.find(function (row) {
            return String(row.getAttribute('data-product-id') || '') === productIdStr;
          }) || null;
        }

        if (matchedRow) {
          const cartProduct = mapCartRowToProductData(matchedRow);
          return {
            product_id: cartProduct.product_id || (productId != null ? String(productId) : null),
            product_title: cartProduct.product_title || null,
            product_img_url: cartProduct.product_img_url || pickProductImgUrlFromElement(matchedRow) || null,
            product_slug: cartProduct.product_slug || null,
            product_moq: 50,
            product_discount_percent: cartProduct.product_discount_percent,
            is_in_stock: cartProduct.product_in_stock,
            product_price: cartProduct.product_price,
            product_discount_price: cartProduct.product_discount_price,
            product_discounted_price: cartProduct.product_discounted_price,
            product_tag: cartProduct.product_tag || null,
            preorder: cartProduct.preorder || null,
            product_available_quantity: cartProduct.product_available_quantity ?? null,
            l1_category_name: cartProduct.l1_category_name || null,
            l2_category_name: cartProduct.l2_category_name || null,
            l3_category_name: cartProduct.l3_category_name || null,
            product_category_slug: cartProduct.product_category_slug || null,
            product_category_id: cartProduct.product_category_id || null,
            product_sub_category_id: cartProduct.product_sub_category_id || null,
            product_sub_sub_category_id: null,
            product_variant_id: cartProduct.product_variant_id || (variantId != null ? String(variantId) : null),
            _pricesInCents: true,
          };
        }
      }

      // Resolve from PDP or product card (cart recommendations, PLP, PDP, or when no cart line match)
      const resolvedProductId = productId != null ? String(productId) : null;
      if (resolvedProductId || variantId != null) {
        const pid = resolvedProductId || null;
        if (pid && window.__PRODUCT_DATA__ && window.__PRODUCT_DATA__.product_id && window.__PRODUCT_DATA__.product_id.toString() === pid) {
          return Object.assign({}, getProductData(), { _pricesInCents: false });
        }
        if (pid) {
          var productCard = findProductCardElement(pid, triggerElement);
          var fromCard = buildProductDataFromProductCardElement(productCard, pid, variantId);
          if (fromCard) {
            var fromCartJsForCard = await fetchProductDataFromCartJs(variantId, pid);
            if (fromCartJsForCard) {
              return preferProductCardPricing(
                fillMissingProductFields(fromCartJsForCard, fromCard),
                triggerElement,
                pid,
                variantId
              );
            }
            return fromCard;
          }
        }

        var fromCartJs = await fetchProductDataFromCartJs(variantId, pid);
        if (fromCartJs) {
          var cardForCartJs = findProductCardElement(pid, triggerElement);
          var enrichFromCard = buildProductDataFromProductCardElement(cardForCartJs, pid, variantId);
          if (enrichFromCard) {
            return fillMissingProductFields(fromCartJs, enrichFromCard);
          }
          return fromCartJs;
        }

        return {
          product_id: pid,
          product_title: null,
          product_slug: null,
          product_moq: 50,
          product_discount_percent: null,
          is_in_stock: null,
          product_price: null,
          product_discount_price: null,
          product_discounted_price: null,
          product_tag: null,
          preorder: null,
          product_available_quantity: null,
          l1_category_name: null,
          l2_category_name: null,
          l3_category_name: null,
          product_category_slug: null,
          product_category_id: null,
          product_sub_category_id: null,
          product_sub_sub_category_id: null,
          product_variant_id: variantId != null ? String(variantId) : null,
        };
      }

      if (variantId != null || productId != null) {
        var fromCartJsOnly = await fetchProductDataFromCartJs(variantId, productId);
        if (fromCartJsOnly) return fromCartJsOnly;
      }

      return {};
    }
    
    // Get coupon information from product offers data
    function getCouponInfo() {
      try {
        const offerData = window.__PRODUCT_OFFER_DATA__ || {};
        
        return {
          coupon_present: offerData.coupon_present === true,
          coupon_type: offerData.coupon_type || null,
        };
      } catch (err) {
        console.error('Error getting coupon info:', err);
        return { coupon_present: false, coupon_type: null };
      }
    }

    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) {
        return 'pdp';
      }
      if (path.includes('/collections/')) {
        return 'plp';
      }
      if (path.includes('/cart')) {
        return 'cart';
      }
      if (path.includes('/checkout')) {
        return 'checkout';
      }
      if (path.includes('/search')) {
        return 'search';
      }
      if (path === '/' || path === '') {
        return 'home';
      }
      return 'other';
    }

    const couponInfo = getCouponInfo();

    const triggerElement =
      additionalData.triggerElement ||
      additionalData.trigger_element ||
      (additionalData.product_id != null
        ? findProductCardElement(additionalData.product_id, null)
        : null) ||
      document.activeElement ||
      document.querySelector('[ref="addToCartButton"]') ||
      document.querySelector('form[data-type="add-to-cart-form"]');

    const resolvedWidgetInfo = resolveWidgetInfoForTracking(triggerElement, {
      pageName: additionalData.page_name,
      productId: additionalData.product_id,
      productVariantId: additionalData.product_variant_id,
      ctaName: additionalData.cta_name,
      cartWidgetName: additionalData.cta_name === 'add_to_bag' ? 'cart_upsell' : undefined,
    });
    const widgetInfo =
      additionalData.page_widget_name !== undefined
        ? Object.assign({}, resolvedWidgetInfo, {
            page_widget_name: additionalData.page_widget_name,
            page_widget_position:
              additionalData.page_widget_position != null &&
              additionalData.page_widget_position !== ''
                ? additionalData.page_widget_position
                : resolvedWidgetInfo.page_widget_position,
            product_position_inside_widget:
              additionalData.product_position_inside_widget != null &&
              additionalData.product_position_inside_widget !== ''
                ? additionalData.product_position_inside_widget
                : additionalData.position_inside_widget != null &&
                    additionalData.position_inside_widget !== ''
                  ? additionalData.position_inside_widget
                  : resolvedWidgetInfo.product_position_inside_widget,
          })
        : resolvedWidgetInfo;
    const widgetFields = buildGtmWidgetPayload(widgetInfo);

    // Get product data asynchronously, cart_id always from global state
    getProductDataForTracking().then(async (productData) => {
      productData = await enrichProductDataWithImgUrl(productData, { triggerElement, additionalData });
      const pricesInCents =
        additionalData._pricesInCents !== undefined
          ? additionalData._pricesInCents !== false
          : productData._pricesInCents !== false;
      const resolvedPricing = preferProductCardPricing(
        {
          product_price:
            additionalData.product_price !== undefined
              ? additionalData.product_price
              : productData.product_price,
          product_discount_price:
            additionalData.product_discount_price !== undefined
              ? additionalData.product_discount_price
              : productData.product_discount_price,
          product_discounted_price:
            additionalData.product_discounted_price !== undefined
              ? additionalData.product_discounted_price
              : productData.product_discounted_price,
          product_discount_percent:
            additionalData.product_discount_percent || productData.product_discount_percent,
          _pricesInCents: pricesInCents,
        },
        triggerElement,
        additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
        additionalData.product_variant_id || productData.product_variant_id
      );
      const cartId = window.__PW_CART_ID__ || null;
      const ctaName = normalizeAddToBagCtaName(additionalData.cta_name);
      const isFromYouMayAlsoLike = (ctaName === 'add_to_bag' && additionalData.page_name === 'Cart');
      const pageNameResolved = additionalData.page_name || getPageNameFromUrl();
      const pageContextName = (typeof getPageContext === 'function' && getPageContext() && getPageContext().pageName != null)
        ? getPageContext().pageName
        : pageNameResolved;
      const cartOpen = (function () {
        try {
          const host = document.querySelector('shadow-dom-container');
          const sidecart = host?.shadowRoot?.querySelector('.sidecart');
          return !!(sidecart && sidecart.getClientRects().length > 0);
        } catch (e) {
          return false;
        }
      })();
      const eventPageName =
        (ctaName === 'quantity_icon' || isFromYouMayAlsoLike || pageNameResolved === 'cart') && cartOpen
          ? 'Cart'
          : pageContextName;
      const eventData = {
        event: 'ga_pwst_add_to_bag',
        platform: getGtmPlatformValue(),
        organisation_name: gtmConfig.organisation_name || 'pw',
        business_unit: gtmConfig.business_unit || 'pw_store',
        page_url: pageUrl,
        page_name: eventPageName,
        is_logged_in: Boolean((window.__LOGIN_DATA__ || {}).is_logged_in),
        from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
        user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
        pw_user_id: userData.pw_user_id,
        cohort_id: userData.cohort_id,
        cohort_name: userData.cohort_name,
        breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
        ...widgetFields,
        product_position_inside_widget: resolveProductPositionForAddToBag(
          additionalData,
          productData,
          widgetFields,
          triggerElement
        ),
        coupon_type: additionalData.coupon_type !== undefined ? additionalData.coupon_type : couponInfo.coupon_type,
        coupon_present: additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present,
        total_quantity: additionalData.total_quantity !== undefined ? additionalData.total_quantity : 1,
        cta_name: ctaName,
        cart_id: cartId,
        product_id: additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id,
        product_title: additionalData.product_title || productData.product_title,
        product_slug: additionalData.product_slug || productData.product_slug,
        product_moq: additionalData.product_moq !== undefined ? additionalData.product_moq : (productData.product_moq ?? null),
        product_discount_percent:
          resolvedPricing.product_discount_percent ||
          additionalData.product_discount_percent ||
          productData.product_discount_percent,
        product_in_stock: resolveProductInStockForEvent(additionalData, productData),
        product_price: normalizeGtmProductPrice(resolvedPricing.product_price, pricesInCents),
        product_discount_price: (function () {
          const value = normalizeGtmProductPrice(resolvedPricing.product_discount_price, pricesInCents);
          return value != null && Number(value) === 0 ? null : value;
        })(),
        product_discounted_price: normalizeGtmProductPrice(
          resolvedPricing.product_discounted_price,
          pricesInCents
        ),
        product_tag: additionalData.product_tag != null ? additionalData.product_tag : productData.product_tag,
        preorder: additionalData.preorder != null ? additionalData.preorder : productData.preorder,
        l1_category_name: additionalData.l1_category_name || productData.l1_category_name,
        l2_category_name: additionalData.l2_category_name || productData.l2_category_name,
        l3_category_name: additionalData.l3_category_name || productData.l3_category_name,
        product_category_slug: additionalData.product_category_slug || productData.product_category_slug,
        product_category_id: additionalData.product_category_id || productData.product_category_id || null,
        product_sub_category_id: additionalData.product_sub_category_id || productData.product_sub_category_id || null,
        product_sub_sub_category_id: additionalData.product_sub_sub_category_id || productData.product_sub_sub_category_id || null,
        product_variant_id: additionalData.product_variant_id !== undefined ? additionalData.product_variant_id : productData.product_variant_id,
        timestamp: new Date().toISOString(),
      };

      // Mengage event data with product - use helper
      const moeProductData = await enrichProductDataWithImgUrl(productData, { triggerElement, additionalData });
      const moeEventData = buildMoeEventDataWithProduct(
        'moe_pwst_add_to_bag',
        eventData,
        moeProductData,
        {
          // Where add-to-bag came from (PLP, PDP, cart, etc.)
          source: eventData.page_name,
        },
        {
          pageUrl: pageUrl,
        }
      );

      console.log('ðŸ’¾ [MOE] Add to bag Event data:', moeEventData);
      dataLayer.push(moeEventData);
      dataLayer.push(eventData);
    }).catch((err) => {
      console.error('Error tracking add to bag:', err);
    });
  }
  window.trackAddToBag = trackAddToBag;

  /** Shared product fields for addToCartGtm. product_in_stock from available_quantity or is_in_stock. */
  function getAddToCartGtmProductFields(source, fallback) {
    const inStock =
      source?.product_available_quantity ??
      fallback?.product_available_quantity ??
      source?.is_in_stock ??
      fallback?.is_in_stock ??
      null;
    const discountPrice = source?.product_discount_price ?? fallback?.product_discount_price ?? null;
    return {
      product_id: source?.product_id ?? fallback?.product_id ?? null,
      product_title: source?.product_title ?? fallback?.product_title ?? null,
      product_slug: source?.product_slug ?? fallback?.product_slug ?? null,
      product_discount_percent: source?.product_discount_percent ?? fallback?.product_discount_percent ?? null,
      product_in_stock: inStock ?? null,
      product_price: source?.product_price ?? fallback?.product_price ?? null,
      product_discount_price:
        discountPrice != null && Number(discountPrice) === 0 ? null : discountPrice,
      product_discounted_price: source?.product_discounted_price ?? fallback?.product_discounted_price ?? null,
      product_tag: source?.product_tag ?? fallback?.product_tag ?? null,
      preorder: source?.preorder ?? fallback?.preorder ?? null,
      product_available_quantity: source?.product_available_quantity ?? fallback?.product_available_quantity ?? null,
      l1_category_name: source?.l1_category_name ?? fallback?.l1_category_name ?? null,
      l2_category_name: source?.l2_category_name ?? fallback?.l2_category_name ?? null,
      l3_category_name: source?.l3_category_name ?? fallback?.l3_category_name ?? null,
      product_category_slug: source?.product_category_slug ?? fallback?.product_category_slug ?? null,
      product_category_id: source?.product_category_id ?? fallback?.product_category_id ?? null,
      product_sub_category_id: source?.product_sub_category_id ?? fallback?.product_sub_category_id ?? null,
      product_sub_sub_category_id: source?.product_sub_sub_category_id ?? fallback?.product_sub_sub_category_id ?? null,
      product_variant_id: source?.product_variant_id ?? fallback?.product_variant_id ?? null,
    };
  }

  function addToCartGtm(data = {}) {
    (async function () {
    data = Object.assign({}, data, {
      cta_name: normalizeAddToBagCtaName(data.cta_name),
    });
    // Stamp dedupe so sidecart quantity_change / cart:update cannot double-fire the same add.
    window.__PW_ADD_TO_BAG_DEDUPE__ = {
      variantId: data.product_variant_id != null ? String(data.product_variant_id) : '',
      cta: data.cta_name,
      ts: Date.now(),
    };
    const gtmConfig = getFreshGtmConfig();
    const isProductTemplate = (typeof Theme !== 'undefined' && Theme?.template?.name === 'product');
    if (isProductTemplate) {
      data = { ...data, page_name: 'Product' };
    }
    const userData = getUserData();
    const loginData = window.__LOGIN_DATA__ || {};
    const isLoggedIn = loginData?.is_logged_in || false;
    const pageUrl = window.location.href;
    const couponInfo = getCouponInfo();
    const triggerElement =
      data.triggerElement ||
      data.trigger_element ||
      (data.product_id != null ? findProductCardElement(data.product_id, null) : null) ||
      (data.product_id != null
        ? document.querySelector(
            'product-form-component[data-product-id="' + String(data.product_id) + '"]'
          )
        : null) ||
      document.querySelector('form[data-type="add-to-cart-form"]');
    let widgetInfo =
      data.page_widget_name !== undefined
        ? {
            page_widget_name: data.page_widget_name,
            page_widget_position: data.page_widget_position,
            product_position_inside_widget: data.product_position_inside_widget,
          }
        : resolveWidgetInfoForTracking(triggerElement, {
            pageName: data.page_name,
            productId: data.product_id,
            productVariantId: data.product_variant_id,
          });
    if (isProductTemplate) {
      widgetInfo = {
        page_widget_name: 'product-page',
        page_widget_position: 1,
        product_position_inside_widget: 1,
      };
    } else if (
      (data.page_name === 'Cart' || data.page_name === 'cart' || window.location.pathname.toLowerCase().includes('/cart')) &&
      isCartUpsellSectionElement(triggerElement)
    ) {
      widgetInfo = {
        page_widget_name: 'cart_upsell',
        page_widget_position: 1,
        product_position_inside_widget: getCartUpsellProductPosition(triggerElement),
      };
    }
    const widgetFields = buildGtmWidgetPayload(widgetInfo);
    const cartId = window.__PW_CART_ID__ || null;

    const cardForGtm = findProductCardElement(data.product_id, triggerElement);
    const fromCardForGtm = buildProductDataFromProductCardElement(
      cardForGtm,
      data.product_id != null ? String(data.product_id) : null,
      data.product_variant_id
    );
    const enrichedBase = await enrichProductDataWithImgUrl(
      withMoeProductImgUrl(fillMissingProductFields(data, fromCardForGtm || {}), {
        triggerElement,
        additionalData: data,
      }),
      { triggerElement, additionalData: data }
    );
    const productFields = getAddToCartGtmProductFields(
      preferProductCardPricing(
        enrichedBase,
        triggerElement,
        data.product_id,
        data.product_variant_id
      ),
      null
    );
    const ctaName = normalizeAddToBagCtaName(data.cta_name);
    const isFromYouMayAlsoLike = (ctaName === 'add_to_bag' && (data.page_name === 'Cart' || data.page_name === 'cart'));
    const pageNameResolved = data.page_name != null ? data.page_name : getPageNameFromUrl();
    const eventPageName = (ctaName === 'quantity_icon' || isFromYouMayAlsoLike || pageNameResolved === 'cart') ? 'Cart' : (typeof getPageContext === 'function' && getPageContext() && getPageContext().pageName != null ? getPageContext().pageName : pageNameResolved);
    const eventData = {
      event: 'ga_pwst_add_to_bag',
      platform: getGtmPlatformValue(),
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: eventPageName,
      is_logged_in: Boolean((window.__LOGIN_DATA__ || {}).is_logged_in),
      from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      breadcrumb_path: data.breadcrumb_path != null ? data.breadcrumb_path : getBreadcrumbPathArray(),
      ...widgetFields,
      product_position_inside_widget:
        widgetFields.product_position_inside_widget ??
        resolveProductPositionForAddToBag(data, fromCardForGtm || data, widgetFields, triggerElement),
      coupon_type: data.coupon_type !== undefined ? data.coupon_type : couponInfo.coupon_type,
      coupon_present: data.coupon_present !== undefined ? data.coupon_present : couponInfo.coupon_present,
      total_quantity: data.total_quantity !== undefined ? data.total_quantity : 1,
      cta_name: ctaName,
      cart_id: cartId,
      ...productFields,
      product_moq: 50,
      timestamp: new Date().toISOString(),
    };
    const productData = await enrichProductDataWithImgUrl(
      { product_moq: 50, ...productFields, is_in_stock: productFields.product_in_stock },
      { triggerElement, additionalData: data }
    );

    const moeEventData = buildMoeEventDataWithProduct(
      'moe_pwst_add_to_bag',
      eventData,
      productData,
      { source: eventData.page_name },
      { pageUrl: pageUrl }
    );
    window.dataLayer.push(moeEventData);
    window.dataLayer.push(eventData);
    })().catch(function (err) {
      console.error('Error in addToCartGtm:', err);
    });
  }
  window.addToCartGtm = addToCartGtm;

  // Track buy now click event (non-redirect event)
  // Event: pwst_buy_now_click
  // Definition: When user clicks Buy Now button
  // MoEngage: pwst_buy_now_click (includes category, product, user attributes per spec)
  function trackBuyNowClick(additionalData = {}) {
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};
    const userData = getUserData();
    const pageUrl = window.location.href;
    const path = window.location.pathname.toLowerCase();

    let productData = getProductData();

    // Override with additionalData
    productData = {
      ...productData,
      ...(additionalData.product_id !== undefined && { product_id: additionalData.product_id }),
      ...(additionalData.product_title !== undefined && { product_title: additionalData.product_title }),
      ...(additionalData.product_img_url !== undefined && { product_img_url: additionalData.product_img_url }),
      ...(additionalData.product_slug !== undefined && { product_slug: additionalData.product_slug }),
      ...(additionalData.product_variant_id !== undefined && { product_variant_id: additionalData.product_variant_id }),
      ...(additionalData.product_price !== undefined && { product_price: additionalData.product_price }),
      ...(additionalData.product_discounted_price !== undefined && { product_discounted_price: additionalData.product_discounted_price }),
      ...(additionalData.product_discount_percent !== undefined && { product_discount_percent: additionalData.product_discount_percent }),
      ...(additionalData.product_available_quantity !== undefined && { is_in_stock: additionalData.product_available_quantity, product_available_quantity: additionalData.product_available_quantity }),
      ...(additionalData.l1_category_name !== undefined && { l1_category_name: additionalData.l1_category_name }),
      ...(additionalData.l2_category_name !== undefined && { l2_category_name: additionalData.l2_category_name }),
      ...(additionalData.l3_category_name !== undefined && { l3_category_name: additionalData.l3_category_name }),
      ...(additionalData.product_category_id !== undefined && { product_category_id: additionalData.product_category_id }),
      ...(additionalData.product_sub_category_id !== undefined && { product_sub_category_id: additionalData.product_sub_category_id }),
      ...(additionalData.product_sub_sub_category_id !== undefined && { product_sub_sub_category_id: additionalData.product_sub_sub_category_id }),
      ...(additionalData.product_category_slug !== undefined && { product_category_slug: additionalData.product_category_slug }),
    };

    // Get current variant from form if on PDP
    const variantInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    const variantId = additionalData.product_variant_id || (variantInput ? variantInput.value : null) || productData.product_variant_id;
    if (variantId) {
      productData.product_variant_id = variantId.toString();
    }

    // Try to get updated variant data from variant picker if available
    if (variantId && typeof getVariantDataFromPicker === 'function') {
      const variantData = getVariantDataFromPicker(variantId);
      if (variantData) {
        productData.product_discounted_price = variantData.price;
        productData.product_price = variantData.compare_at_price || variantData.price;
        productData.product_discount_price = variantData.compare_at_price > variantData.price
          ? variantData.compare_at_price - variantData.price
          : null;
        productData.is_in_stock = variantData.inventory_quantity ?? null;
        productData.product_available_quantity = variantData.inventory_quantity ?? null;
        if (variantData.compare_at_price && variantData.compare_at_price > variantData.price) {
          const discountAmount = variantData.compare_at_price - variantData.price;
          productData.product_discount_percent = Math.round((discountAmount * 100) / variantData.compare_at_price);
        }
      }
    }

    function getPageNameFromUrl() {
      if (path.includes('/products/')) return 'pdp';
      if (path.includes('/collections/')) return 'plp';
      if (path.includes('/cart')) return 'cart';
      if (path.includes('/checkout')) return 'checkout';
      if (path.includes('/search')) return 'search';
      if (path === '/' || path === '') return 'home';
      return 'other';
    }

    const pageName = additionalData.page_name || getPageNameFromUrl();

    // GTM event data
    const eventData = {
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: pageName,
      is_logged_in: loginData.is_logged_in || false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      product_id: productData.product_id,
      product_title: productData.product_title,
      product_img_url: productData.product_img_url,
      product_slug: productData.product_slug,
      product_moq: 50,
      product_discount_percent: productData.product_discount_percent,
      product_in_stock: productData.product_available_quantity ?? null,
      product_price: productData.product_price,
      product_discount_price: productData.product_discount_price,
      product_discounted_price: productData.product_discounted_price,
      product_tag: productData.product_tag,
      product_available_quantity: productData.product_available_quantity,
      l1_category_name: productData.l1_category_name,
      l2_category_name: productData.l2_category_name,
      l3_category_name: productData.l3_category_name,
      product_category_slug: productData.product_category_slug,
      product_category_id: productData.product_category_id,
      product_sub_category_id: productData.product_sub_category_id,
      product_sub_sub_category_id: productData.product_sub_sub_category_id,
      product_variant_id: productData.product_variant_id,
      timestamp: new Date().toISOString(),
      ...additionalData,
    };

    const moeEventData = buildMoeEventDataWithProduct(
      'moe_pwst_buy_now_click',
      eventData,
      productData,
      {
        category: eventData.l1_category_name || null,
        page_url: pageUrl,
        client_type: 'pw_store',
        device_id: additionalData.device_id || null,
      },
      { pageUrl: pageUrl }
    );

    dataLayer.push(eventData);
    dataLayer.push(moeEventData);
  }
  window.trackBuyNowClick = trackBuyNowClick;

  // Attach buy now click tracking
  // RCA (Mac Chrome):
  // 1) window.trackBuyNowClick / trackAddToBag were never exported → Buy Now handler was a no-op.
  // 2) Text-node click targets break event.target.closest — use getEventElement.
  // 3) GoKwik /cart/add is outside product-form; fire add_to_bag after cart/add succeeds
  //    (not on click) so Mac Chrome does not drop the async event when checkout opens.
  // 4) cart_page_viewed only watched sidecart visibility and called missing window exports —
  //    fire explicitly after Buy Now cart/add with fireCartPageViewOnce (deduped).
  function attachBuyNowClickTracking() {
    let buyNowInFlight = false;
    let buyNowContext = null;

    function buildBuyNowProductPayload(button, productId, variantId) {
      let productDataFromForm = null;
      try {
        const productForm =
          button?.closest?.('product-form-component') ||
          document.querySelector('product-form-component');
        const raw = productForm?.dataset?.productGtm;
        if (raw) productDataFromForm = JSON.parse(raw);
      } catch (_) {}
      const pageProduct = typeof getProductData === 'function' ? getProductData() : {};
      return {
        ...(pageProduct && typeof pageProduct === 'object' ? pageProduct : {}),
        ...(productDataFromForm && typeof productDataFromForm === 'object' ? productDataFromForm : {}),
        product_id: productId || productDataFromForm?.product_id || pageProduct?.product_id || undefined,
        product_variant_id: variantId || productDataFromForm?.product_variant_id || pageProduct?.product_variant_id || undefined,
        page_name: 'Product',
        triggerElement: button || undefined,
      };
    }

    function trackBuyNowAddToBag(context) {
      if (!context) return;
      const variantId = context.product_variant_id != null ? String(context.product_variant_id) : null;
      if (shouldSkipDuplicateAddToBag(variantId, 'buy_now')) return;
      const payload = {
        ...context,
        cta_name: 'buy_now',
        total_quantity: context.total_quantity != null ? context.total_quantity : 1,
      };
      if (typeof window.addToCartGtm === 'function') {
        window.addToCartGtm(payload);
      } else if (typeof window.trackAddToBag === 'function') {
        window.trackAddToBag(payload);
      }
    }

    function trackBuyNowCartPageView() {
      setTimeout(function () {
        fireCartPageViewOnce({ page_name: 'Cart' });
      }, 350);
    }

    document.addEventListener('click', function(event) {
      const clickEl = getEventElement(event);
      if (!clickEl) return;
      const button = clickEl.closest(
        '[ref="buyNowButton"], button[ref*="buyNow"], #gokwik-buy-now, [id="gokwik-buy-now"]'
      );
      if (!button || typeof window.trackBuyNowClick !== 'function') return;

      const form = button.closest('form[data-type="add-to-cart-form"]');
      const productForm = button.closest('product-form-component');
      let productId = null;
      let variantId = null;
      let quantity = 1;

      if (form || productForm) {
        const formEl = form || productForm?.querySelector('form[data-type="add-to-cart-form"]');
        if (formEl) {
          productId = formEl.closest('[data-product-id]')?.getAttribute('data-product-id') ||
                     productForm?.getAttribute('data-product-id');
          const variantInput = formEl.querySelector('input[name="id"]');
          variantId = variantInput?.value;
          const qtyInput = formEl.querySelector('input[name="quantity"]');
          quantity = qtyInput?.value ? Number(qtyInput.value) || 1 : 1;
        }
      }

      if ((!productId || !variantId) && (button.id === 'gokwik-buy-now' || button.getAttribute('id') === 'gokwik-buy-now')) {
        const pageForm = document.querySelector('form[data-type="add-to-cart-form"]');
        const pageProductForm = document.querySelector('product-form-component');
        const formEl = pageForm || pageProductForm?.querySelector('form[data-type="add-to-cart-form"]');
        if (formEl) {
          productId = productId || formEl.closest('[data-product-id]')?.getAttribute('data-product-id') ||
                     pageProductForm?.getAttribute('data-product-id');
          variantId = variantId || formEl.querySelector('input[name="id"]')?.value;
          if (!quantity || quantity === 1) {
            const qtyInput = formEl.querySelector('input[name="quantity"]');
            quantity = qtyInput?.value ? Number(qtyInput.value) || 1 : 1;
          }
        }
      }

      buyNowInFlight = true;
      buyNowContext = buildBuyNowProductPayload(button, productId, variantId);
      buyNowContext.total_quantity = quantity;
      window.__PW_BUY_NOW_IN_FLIGHT__ = true;
      window.__PW_BUY_NOW_CONTEXT__ = buyNowContext;

      window.trackBuyNowClick({
        product_id: productId || undefined,
        product_variant_id: variantId || undefined,
      });

      setTimeout(function () {
        if (buyNowInFlight) {
          buyNowInFlight = false;
          window.__PW_BUY_NOW_IN_FLIGHT__ = false;
        }
      }, 12000);
    }, { capture: true, passive: true });

    function handleBuyNowCartAddSuccess() {
      if (!buyNowInFlight && !window.__PW_BUY_NOW_IN_FLIGHT__) return;
      const context = buyNowContext || window.__PW_BUY_NOW_CONTEXT__;
      buyNowInFlight = false;
      window.__PW_BUY_NOW_IN_FLIGHT__ = false;
      trackBuyNowAddToBag(context);
      trackBuyNowCartPageView();
      buyNowContext = null;
      window.__PW_BUY_NOW_CONTEXT__ = null;
    }

    if (!window.__PW_BUY_NOW_CART_ADD_HOOK__) {
      window.__PW_BUY_NOW_CART_ADD_HOOK__ = true;

      const originalFetch = window.fetch;
      if (typeof originalFetch === 'function') {
        window.fetch = function (input, init) {
          const url = typeof input === 'string' ? input : (input && input.url) || '';
          const promise = originalFetch.apply(this, arguments);
          if (url && String(url).indexOf('/cart/add') !== -1 && (buyNowInFlight || window.__PW_BUY_NOW_IN_FLIGHT__)) {
            promise.then(function (response) {
              if (response && response.ok) handleBuyNowCartAddSuccess();
            }).catch(function () {});
          }
          return promise;
        };
      }

      const xhrOpen = XMLHttpRequest.prototype.open;
      const xhrSend = XMLHttpRequest.prototype.send;
      XMLHttpRequest.prototype.open = function (method, url) {
        this.__pwBuyNowUrl = typeof url === 'string' ? url : '';
        return xhrOpen.apply(this, arguments);
      };
      XMLHttpRequest.prototype.send = function () {
        if (this.__pwBuyNowUrl && this.__pwBuyNowUrl.indexOf('/cart/add') !== -1) {
          this.addEventListener('load', function () {
            if (this.status >= 200 && this.status < 300 && (buyNowInFlight || window.__PW_BUY_NOW_IN_FLIGHT__)) {
              handleBuyNowCartAddSuccess();
            }
          });
        }
        return xhrSend.apply(this, arguments);
      };
    }

    document.addEventListener('cart:update', function (event) {
      if (!buyNowInFlight && !window.__PW_BUY_NOW_IN_FLIGHT__) return;
      const source = event?.detail?.data?.source;
      if (source === 'product-sticky-bar') {
        handleBuyNowCartAddSuccess();
      }
    });
  }

  // Function to attach add to bag tracking
  function attachAddToBagTracking() {
    // Track last clicked button to determine cta_name
    let lastClickedButton = null;
    let lastClickedTime = 0;
    const CLICK_DEBOUNCE_MS = 2000; // Track button clicks within 2 seconds
    let lastTrackedVariantId = null;
    let lastTrackedTime = 0;
    const TRACKING_DEBOUNCE_MS = 1000; // Prevent duplicate tracking within 1 second

      // Function to determine cta_name from button
      function getCtaName(button) {
        if (!button) return 'add_to_bag';

        const buttonText = (button.textContent || '').toLowerCase().trim();
        const buttonId = button.id || '';
        const buttonClass = button.className || '';
        const buttonRef = button.getAttribute('ref') || '';
        const parentElement = button.closest('.product-quantity-selector, quantity-selector-component');

        // Check for buy now button
        if (buttonText.includes('buy now') ||
            buttonText.includes('buy it now') ||
            buttonId.includes('buy-now') || 
            buttonClass.includes('buy-now') ||
            buttonRef.includes('buyNow') ||
            buttonRef.includes('buyNowButton') ||
            button.hasAttribute('data-gokwik-button')) {
          return 'buy_now';
        }

        // Check for quantity icon/selector (plus/minus buttons)
        if (parentElement ||
            button.closest('quantity-selector-component') ||
            button.closest('.product-quantity-selector') ||
            button.classList.contains('quantity-icon') ||
            buttonRef.includes('quantity') ||
            buttonRef.includes('plus') ||
            buttonRef.includes('minus')) {
          return 'quantity_icon';
        }

        // Default Add / Add to Bag CTAs
        return 'add_to_bag';
      }

      // Listen for product-quantity-change event (quantity +/- on PDP; cart quantity changes use quantity-selector:update)
      document.addEventListener('product-quantity-change', function(event) {
        const eventDetail = event.detail || {};
        const variantId = eventDetail.variantId ? eventDetail.variantId.toString() : null;
        const newQuantity = eventDetail.quantity || 0;
        const source = eventDetail.source;
        
        if (!variantId || !source) return;
        
        // Track PDP quantity selector changes (supports both component variants used across themes)
        if (
          source instanceof HTMLElement &&
          (
            source.tagName === 'PRODUCT-QUANTITY-SELECTOR-COMPONENT' ||
            source.tagName === 'QUANTITY-SELECTOR-COMPONENT' ||
            source.classList.contains('product-quantity-selector') ||
            source.closest?.('.product-quantity-selector')
          )
        ) {
          // Get the old quantity we stored when button was clicked
          const oldCartQuantity = quantityBeforeChange[variantId] !== undefined ? quantityBeforeChange[variantId] : 0;
          const ctaType = lastClickedCtaType[variantId] || 'quantity_icon';
          
          // Find the quantity selector component
          const quantitySelector = source;
          const button = quantitySelector.querySelector('button[name="plus"], button[name="delete-minus"], .quantity-plus, .quantity-delete-minus');
          
          // Try to get product ID
          let productId = null;
          const productForm = quantitySelector.closest('product-form-component, form[data-type="add-to-cart-form"]');
          if (productForm) {
            if (productForm.hasAttribute('data-product-id')) {
              productId = productForm.getAttribute('data-product-id');
            } else {
              const productIdInput = productForm.querySelector('[data-product-id]');
              if (productIdInput) {
                productId = productIdInput.getAttribute('data-product-id');
              }
            }
          }
          
          // Track add to bag if quantity increased
          if (newQuantity > oldCartQuantity) {
            const quantityAdded = newQuantity - oldCartQuantity;
            
            // Clear the stored data for this variant
            delete quantityBeforeChange[variantId];
            delete lastClickedCtaType[variantId];
            
            // Track the event
            if (typeof window.trackAddToBag === 'function') {
              // Prevent duplicate tracking
              const now = Date.now();
              if (lastTrackedVariantId === variantId && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) {
                return;
              }
              
              lastTrackedVariantId = variantId;
              lastTrackedTime = now;
              
              try {
                window.trackAddToBag({
                  cta_name: 'quantity_icon',
                  total_quantity: quantityAdded,
                  product_variant_id: variantId,
                  product_id: productId ? productId.toString() : null,
                  page_name: 'Product',
                  triggerElement: button || quantitySelector,
                });
              } catch (err) {
                console.error('Error tracking add to bag:', err);
              }
            }
          }
          else if (newQuantity < oldCartQuantity) {
            const quantityRemoved = oldCartQuantity - newQuantity;
            delete quantityBeforeChange[variantId];
            if (typeof window.trackRemoveFromBag === 'function') {
              const now = Date.now();
              const trackingKey = `remove_${variantId}`;
              if (lastTrackedVariantId === trackingKey && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) {
                delete lastClickedCtaType[variantId];
                return;
              }
              lastTrackedVariantId = trackingKey;
              lastTrackedTime = now;
              try {
                window.trackRemoveFromBag({
                  cta_name: ctaType,
                  total_quantity: quantityRemoved,
                  product_variant_id: variantId,
                  product_id: productId ? productId.toString() : null,
                  page_name: 'Product',
                  triggerElement: button || quantitySelector,
                });
              } catch (err) {
                console.error('Error tracking remove from bag:', err);
              }
            }
            delete lastClickedCtaType[variantId];
          } else {
            delete quantityBeforeChange[variantId];
            delete lastClickedCtaType[variantId];
          }
        }
      });

      // Listen for quantity-selector:update (theme cart drawer / cart page quantity changes)
      document.addEventListener('quantity-selector:update', function(event) {
        const eventDetail = event.detail || {};
        const newQuantity = eventDetail.quantity ?? 0;
        const cartLine = eventDetail.cartLine;

        // Only handle cart (has cartLine); PDP uses product-quantity-change
        if (!cartLine) return;

        // Use composedPath() to find quantity selector (handles shadow DOM retargeting)
        const path = event.composedPath?.() || (event.target ? [event.target] : []);
        let quantitySelector = path.find(function(el) {
          return el && (el.dataset?.variantId || el.getAttribute?.('data-variant-id')) && (el.tagName === 'CART-QUANTITY-SELECTOR-COMPONENT' || el.tagName === 'QUANTITY-SELECTOR-COMPONENT');
        });
        if (!quantitySelector) {
          quantitySelector = event.target?.closest?.('cart-quantity-selector-component, quantity-selector-component');
        }

        if (!quantitySelector) return;

        const variantId = (quantitySelector.dataset?.variantId || quantitySelector.getAttribute?.('data-variant-id'))?.toString();
        if (!variantId) return;

        const quantityInput = quantitySelector.querySelector?.('input[type="number"]');
        const oldQuantity = quantityInput
          ? parseInt(quantityInput.getAttribute?.('data-cart-quantity') || '0')
          : 0;

        const cartRow = quantitySelector.closest?.('tr[data-product-id]');
        const productId = cartRow?.dataset?.productId || cartRow?.getAttribute?.('data-product-id') || null;

        if (newQuantity > oldQuantity) {
          const quantityAdded = newQuantity - oldQuantity;
          if (typeof window.trackAddToBag === 'function') {
            const now = Date.now();
            if (lastTrackedVariantId === variantId && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) return;
            lastTrackedVariantId = variantId;
            lastTrackedTime = now;
            try {
              window.trackAddToBag({
                cta_name: 'quantity_icon',
                total_quantity: quantityAdded,
                product_variant_id: variantId,
                product_id: productId ? productId.toString() : null,
                page_name: 'Cart',
                triggerElement: quantitySelector,
              });
            } catch (err) {
              console.error('Error tracking add to bag from cart:', err);
            }
          }
        } else if (newQuantity < oldQuantity) {
          const quantityRemoved = oldQuantity - newQuantity;
          if (typeof window.trackRemoveFromBag === 'function') {
            const now = Date.now();
            const trackingKey = 'remove_' + variantId;
            if (lastTrackedVariantId === trackingKey && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) return;
            lastTrackedVariantId = trackingKey;
            lastTrackedTime = now;
            try {
              window.trackRemoveFromBag({
                cta_name: newQuantity === 0 ? 'delete' : 'quantity_icon',
                total_quantity: quantityRemoved,
                product_variant_id: variantId,
                product_id: productId ? productId.toString() : null,
                page_name: 'Cart',
                triggerElement: quantitySelector,
              });
            } catch (err) {
              console.error('Error tracking remove from bag from cart:', err);
            }
          }
        }
      });

      // Listen for Gokwik sidecart quantity_change (postMessage from shadow DOM cart)
      let cartQuantityByVariant = {};
      function fetchCartData() {
        return fetch('/cart.js').then(function(r) { return r.json(); });
      }
      function initCartQuantityState() {
        fetchCartData().then(function(cart) {
          window.__PW_CART_ID__ = cart.token || cart.id || null;
          (cart.items || []).forEach(function(item) {
            const vid = item.variant_id?.toString();
            if (vid) cartQuantityByVariant[vid] = item.quantity || 0;
          });
        }).catch(function() {});
      }
      initCartQuantityState();

      document.addEventListener(
        'click',
        function (event) {
          const path = event.composedPath?.() || (event.target ? [event.target] : []);
          const button = path.find(function (el) {
            return (
              el &&
              (el.tagName === 'BUTTON' ||
                el.getAttribute?.('role') === 'button' ||
                el.matches?.('[role="button"]'))
            );
          });
          if (!button) return;

          const buttonText = (button.textContent || '').trim().toLowerCase();
          const isAddButton =
            buttonText === '+ add' ||
            buttonText === 'add' ||
            buttonText.startsWith('+ add') ||
            button.name === 'add' ||
            button.classList?.contains('quick-add__button');
          if (!isAddButton) return;

          const upsellHost = path.find(function (el) {
            return el && typeof el.closest === 'function' && isCartUpsellSectionElement(el);
          });
          if (!upsellHost) return;

          const upsellCard =
            path.find(function (el) {
              return (
                el &&
                typeof el.closest === 'function' &&
                !isCartLineItemElement(el) &&
                (el.matches?.(
                  '.swiper-slide, .resource-list__item, product-card, .product-card, [data-product-id], [class*="product-card"], [class*="product-item"]'
                ) ||
                  el.closest?.(
                    '.swiper-slide, .resource-list__item, product-card, .product-card, [data-product-id], [class*="product-card"], [class*="product-item"]'
                  ))
              );
            }) || upsellHost;

          const cardElement =
            upsellCard?.closest?.(
              '.swiper-slide, .resource-list__item, product-card, .product-card, [data-product-id], [class*="product-card"], [class*="product-item"]'
            ) || upsellCard;

          const variantId =
            button.getAttribute('data-variant-id') ||
            button.dataset?.variantId ||
            cardElement?.getAttribute?.('data-variant-id') ||
            cardElement?.getAttribute?.('data-product-variant-id') ||
            null;
          const productId =
            cardElement?.getAttribute?.('data-product-id') ||
            button.getAttribute('data-product-id') ||
            null;
          const parsedCardData = parseUpsellCardProductData(cardElement, variantId);
          const productPositionInsideWidget = getCartUpsellProductPosition(cardElement || button);

          storeCartUpsellClickContext({
            variantId: variantId,
            productId: productId,
            triggerElement: button,
            cardElement: cardElement,
            productData: parsedCardData,
            product_position_inside_widget: productPositionInsideWidget,
          });

          lastClickedButton = button;
          lastClickedTime = Date.now();
        },
        true
      );

      window.addEventListener('message', function(event) {
        const data = event.data;
        if (!data || data.name !== 'quantity_change' || !data.body) return;

        const id = data.body.id;
        const newQuantity = data.body.quantity ?? 0;
        if (!id) return;

        const variantId = id.toString();
        const oldQuantity = cartQuantityByVariant[variantId] ?? 0;
        cartQuantityByVariant[variantId] = newQuantity;

        function trackWithProductId(fn, opts) {
          fetchCartData().then(function(cart) {
            window.__PW_CART_ID__ = cart.token || cart.id || null;
            const item = (cart.items || []).find(function(i) { return i.variant_id?.toString() === variantId; });
            const productId = item?.product_id ? String(item.product_id) : null;
            fn({ ...opts, product_id: productId });
          }).catch(function() {
            fn(opts);
          });
        }

        if (newQuantity > oldQuantity) {
          const quantityAdded = newQuantity - oldQuantity;
          if (typeof window.trackAddToBag === 'function') {
            const now = Date.now();
            if (lastTrackedVariantId === variantId && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) return;
            // Gokwik sidecart: when add is tracked and newQuantity <= 1, use add_to_bag
            const ctaName = (newQuantity <= 1) ? 'add_to_bag' : 'quantity_icon';
            if (shouldSkipDuplicateAddToBag(variantId, ctaName)) return;
            lastTrackedVariantId = variantId;
            lastTrackedTime = now;
            // Logic for CART YOU MAY ALSO LIKE SECTION
            if (ctaName === 'add_to_bag') {
              if (window.__PW_LAST_CART_UPSELL_CLICK__ && Date.now() - window.__PW_LAST_CART_UPSELL_CLICK__.ts < 8000) {
                window.__PW_LAST_CART_UPSELL_CLICK__.variantId = variantId;
              }
              const SIDECART_ADD_DELAY_MS = 700;
              setTimeout(async function() {
                try {
                  if (typeof Theme !== 'undefined' && Theme.utilities && typeof Theme.utilities.refreshCartWithoutReload === 'function') {
                    await Theme.utilities.refreshCartWithoutReload();
                  }
                  const upsellPayload = await buildCartUpsellAddToBagData(variantId, lastClickedButton);
                  const productData = upsellPayload.productData || {};
                  const upsellWidget = upsellPayload.upsellWidget || {};
                  if (!productData.product_id) {
                    trackWithProductId(function(opts) {
                      window.trackAddToBag({
                        cta_name: 'add_to_bag',
                        total_quantity: quantityAdded,
                        product_variant_id: variantId,
                        page_name: 'Cart',
                        page_widget_name: 'cart_upsell',
                        page_widget_position: 1,
                        triggerElement: lastClickedButton,
                        ...opts,
                      });
                    }, {});
                    return;
                  }
                  window.trackAddToBag({
                    cta_name: 'add_to_bag',
                    total_quantity: quantityAdded,
                    product_variant_id: variantId,
                    product_id: productData.product_id,
                    product_title: productData.product_title,
                    product_slug: productData.product_slug,
                    product_discount_percent: productData.product_discount_percent,
                    product_available_quantity: productData.product_available_quantity,
                    product_in_stock:
                      productData.product_in_stock ??
                      productData.product_available_quantity ??
                      productData.is_in_stock ??
                      null,
                    product_price: productData.product_price,
                    product_discount_price: productData.product_discount_price,
                    product_discounted_price: productData.product_discounted_price,
                    product_tag: productData.product_tag,
                    preorder: productData.preorder,
                    l1_category_name: productData.l1_category_name,
                    l2_category_name: productData.l2_category_name,
                    l3_category_name: productData.l3_category_name,
                    product_category_slug: productData.product_category_slug,
                    product_category_id: productData.product_category_id,
                    product_sub_category_id: productData.product_sub_category_id,
                    page_name: 'Cart',
                    page_widget_name: upsellWidget.page_widget_name || 'cart_upsell',
                    page_widget_position:
                      upsellWidget.page_widget_position != null
                        ? normalizeWidgetPositionValue(upsellWidget.page_widget_position)
                        : 1,
                    product_position_inside_widget:
                      upsellWidget.product_position_inside_widget != null
                        ? normalizeWidgetPositionValue(upsellWidget.product_position_inside_widget)
                        : getCartUpsellProductPosition(lastClickedButton),
                    triggerElement: lastClickedButton,
                    _pricesInCents: true,
                  });
                } catch (err) {
                  console.error('Error tracking add to bag from sidecart (delayed):', err);
                }
              }, SIDECART_ADD_DELAY_MS);
              // END CART YOU MAY ALSO LIKE SECTION
            } else {
              try {
                trackWithProductId(function(opts) {
                  window.trackAddToBag({
                    cta_name: ctaName,
                    total_quantity: quantityAdded,
                    product_variant_id: variantId,
                    page_name: 'Cart',
                    ...opts,
                  });
                }, {});
              } catch (err) {
                console.error('Error tracking add to bag from sidecart:', err);
              }
            }
          }
        } else if (newQuantity < oldQuantity) {
          const quantityRemoved = oldQuantity - newQuantity;
          if (typeof window.trackRemoveFromBag === 'function') {
            const now = Date.now();
            const trackingKey = 'remove_' + variantId;
            if (lastTrackedVariantId === trackingKey && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) return;
            lastTrackedVariantId = trackingKey;
            lastTrackedTime = now;
            try {
              trackWithProductId(function(opts) {
                window.trackRemoveFromBag({
                  cta_name: newQuantity === 0 ? 'delete' : 'quantity_icon',
                  total_quantity: quantityRemoved,
                  product_variant_id: variantId,
                  page_name: 'Cart',
                  page_widget_name: 'cart',
                  page_widget_position: 1,
                  ...opts,
                });
              }, {});
            } catch (err) {
              console.error('Error tracking remove from bag from sidecart:', err);
            }
          }
        }
      });

      // Listen for cart remove button click (delete icon)
      document.addEventListener('click', function(event) {
        const removeBtn = event.target.closest('.cart-items__remove, button.cart-items__remove');
        if (!removeBtn || typeof window.trackRemoveFromBag !== 'function') return;

        const cartRow = removeBtn.closest('tr[data-product-id]');
        if (!cartRow) return;

        const variantId = cartRow.dataset?.variantId || cartRow.getAttribute?.('data-variant-id');
        const productId = cartRow.dataset?.productId || cartRow.getAttribute?.('data-product-id');
        const quantityInput = cartRow.querySelector?.('input[type="number"]');
        const quantityRemoved = quantityInput
          ? parseInt(quantityInput.getAttribute?.('data-cart-quantity') || quantityInput.value || '1')
          : 1;

        if (!variantId) return;

        const now = Date.now();
        const trackingKey = 'remove_' + variantId;
        if (lastTrackedVariantId === trackingKey && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) return;
        lastTrackedVariantId = trackingKey;
        lastTrackedTime = now;

        try {
          window.trackRemoveFromBag({
            cta_name: 'delete',
            total_quantity: quantityRemoved,
            product_variant_id: variantId,
            product_id: productId ? productId.toString() : null,
            page_name: 'Cart',
            triggerElement: removeBtn,
          });
        } catch (err) {
          console.error('Error tracking remove from bag (delete button):', err);
        }
      }, true);

      // Listen for CartAddEvent (cart:update with variantId indicates add)
      document.addEventListener('cart:update', function(event) {
        const eventDetail = event.detail || {};
        const eventData = eventDetail.data || {};
        const sourceId = eventDetail.sourceId || null;
        
        let variantId = null;
        let productId = null;
        let quantity = 1;
        let ctaName = 'add_to_bag';
        let triggerElement = lastClickedButton;
        
        // Skip if this is from quantity selector (we handle it via product-quantity-change event)
        if (eventData.source === 'product-quantity-selector') {
          return;
        }
        if (eventData.source === 'product-form-component' || eventData.source === 'product-form-confirmation') {
          return;
        }
        
        // Check if this is a standard cart:update event with variantId
        // (PDP / product card add-to-cart is handled by addToCartGtm and skipped above via product-form-component source)
        if (eventData.variantId) {
          variantId = eventData.variantId.toString();
          quantity = eventData.itemCount || 1;
          ctaName = lastClickedButton && (Date.now() - lastClickedTime) < CLICK_DEBOUNCE_MS
            ? getCtaName(lastClickedButton)
            : 'add_to_bag';
          productId = eventData.productId || null;
        } else {
          // No variantId and not from quantity selector - skip tracking
          return;
        }

        // Only track if we have a variantId
        if (!variantId) {
          return;
        }

        ctaName = normalizeAddToBagCtaName(ctaName);
        if (shouldSkipDuplicateAddToBag(variantId, ctaName)) {
          return;
        }

        // Prevent duplicate tracking
        const now = Date.now();
        if (lastTrackedVariantId === variantId && (now - lastTrackedTime) < TRACKING_DEBOUNCE_MS) {
          return;
        }

        lastTrackedVariantId = variantId;
        lastTrackedTime = now;

        // Track the event
        if (typeof window.trackAddToBag === 'function') {
          try {
            window.trackAddToBag({
              cta_name: ctaName,
              total_quantity: Number(quantity) || 1,
              product_variant_id: variantId,
              product_id: productId ? productId.toString() : null,
              triggerElement: triggerElement,
            });
          } catch (err) {
            console.error('Error tracking add to bag:', err);
          }
        }
      });

      // Store old quantity when plus/minus/delete buttons are clicked (for quantity selector tracking)
      let quantityBeforeChange = {};
      let lastClickedCtaType = {}; // Store whether it was plus, minus, or delete
      
      // Track button clicks to determine cta_name and capture widget info for quick view
      document.addEventListener('click', function(event) {
        const clickEl = getEventElement(event);
        if (!clickEl) return;
        // Capture quick-add buttons, add-to-cart buttons, buy-now buttons, and quantity selectors
        const button = clickEl.closest('button[type="submit"], button[ref*="addToCart"], button[ref*="buyNow"], #gokwik-buy-now, [data-gokwik-button], button[ref*="plus"], button[ref*="minus"], button[name="plus"], button[name="minus"], button[name="delete-minus"], .quantity-plus, .quantity-minus, .quantity-delete-minus, .quantity-icon button, .quick-add__button, button[name="add"]');
        if (button) {
          const form = button.closest('form[data-type="add-to-cart-form"]');
          const quantitySelector = button.closest('quantity-selector-component, product-quantity-selector-component, cart-quantity-selector-component, .product-quantity-selector');
          const quickAddComponent = button.closest('quick-add-component');
          const isBuyNowButton = getCtaName(button) === 'buy_now';
          
          // If this is a quantity selector button (plus, minus, or delete), store the current cart quantity
          if (quantitySelector) {
            const variantId = quantitySelector.getAttribute('data-variant-id');
            if (variantId) {
              const quantityInput = quantitySelector.querySelector('input[type="number"]');
              if (quantityInput) {
                const currentCartQty = parseInt(quantityInput.getAttribute('data-cart-quantity') || quantityInput.value || '0');
                quantityBeforeChange[variantId] = currentCartQty;
                
                // Determine button type
                if (button.name === 'plus' || button.classList.contains('quantity-plus')) {
                  lastClickedCtaType[variantId] = 'quantity_icon';
                } else if (button.name === 'delete-minus' || button.classList.contains('quantity-delete-minus')) {
                  // Check if it's delete (qty = 1) or minus (qty > 1)
                  // Use the current input value to determine
                  const currentQty = parseInt(quantityInput.value || quantityInput.getAttribute('data-cart-quantity') || '0');
                  lastClickedCtaType[variantId] = currentQty === 1 ? 'delete' : 'quantity_icon';
                } else if (button.name === 'minus') {
                  lastClickedCtaType[variantId] = 'quantity_icon';
                }
              }
            }
          }
          
          if (form || quantitySelector || quickAddComponent || isBuyNowButton) {
            lastClickedButton = button;
            lastClickedTime = Date.now();

            setTimeout(function () {
              const productCardForAdd =
                button.closest('product-card, product-card-link') ||
                button.closest('.resource-list__item') ||
                button.closest('.swiper-slide[data-product-id]');
              if (productCardForAdd && typeof getWidgetInfoFromElement === 'function') {
                try {
                  const widgetInfo = getWidgetInfoFromElement(productCardForAdd);
                  const productId =
                    productCardForAdd.getAttribute('data-product-id') ||
                    productCardForAdd.querySelector?.('[data-product-id]')?.getAttribute('data-product-id') ||
                    null;
                  storeQuickViewWidgetInfo(widgetInfo, productId);
                } catch (err) {
                  console.error('Error capturing widget info for add to cart:', err);
                }
              }

              if (quickAddComponent || (button.classList.contains('quick-add__button') && (button.getAttribute('on:click')?.includes('handleClick') || button.type === 'button'))) {
                const productCard =
                  button.closest('product-card, product-card-link') ||
                  button.closest('.swiper-slide[data-product-id]') ||
                  button.closest('.resource-list__item, .product-grid__item');
                if (productCard && typeof getWidgetInfoFromElement === 'function') {
                  try {
                    const widgetInfo = getWidgetInfoFromElement(productCard);
                    const productId =
                      productCard.getAttribute('data-product-id') ||
                      productCard.querySelector?.('[data-product-id]')?.getAttribute('data-product-id') ||
                      null;
                    storeQuickViewWidgetInfo(widgetInfo, productId);
                  } catch (err) {
                    console.error('Error capturing widget info for quick view:', err);
                  }
                }
              }
            }, 0);
          }
        }
      }, true);

      // Also listen for when quick view modal opens/closes to capture/clear widget info
      const quickViewModal = document.querySelector('quick-add-dialog, #quick-add-dialog');
      if (quickViewModal) {
        // Use MutationObserver to detect when modal opens/closes
        const modalObserver = new MutationObserver(function(mutations) {
          const modalDialog = document.querySelector('quick-add-dialog dialog');
          
          if (modalDialog) {
            const isOpen = modalDialog.hasAttribute('open');
            
            if (isOpen && !window.__QUICK_VIEW_WIDGET_INFO__) {
              // Modal just opened - try to find the product card that triggered this modal
              // Look for product cards with quick-add components
              const productCards = document.querySelectorAll('[data-product-id]');
              for (const card of productCards) {
                const quickAdd = card.querySelector('quick-add-component');
                if (quickAdd) {
                  try {
                    const widgetInfo = getWidgetInfoFromElement(card);
                    if (widgetInfo.page_widget_name || widgetInfo.page_widget_position || widgetInfo.product_position_inside_widget) {
                      window.__QUICK_VIEW_WIDGET_INFO__ = widgetInfo;
                      break;
                    }
                  } catch (err) {
                    // Continue to next card
                  }
                }
              }
            } else if (!isOpen && window.__QUICK_VIEW_WIDGET_INFO__) {
              // Modal closed - clear stored widget info after a short delay to allow any pending events to use it
              setTimeout(() => {
                window.__QUICK_VIEW_WIDGET_INFO__ = null;
                window.__PW_QUICK_VIEW_WIDGET_BY_PRODUCT__ = null;
              }, 1000);
            }
          }
        });

        modalObserver.observe(quickViewModal, {
          attributes: true,
          attributeFilter: ['open'],
          subtree: true
        });
      }
  }

  // Track filter applied or removed (same payload shape; event and value key differ)
  // Event: ga_pwst_filter_applied | ga_pwst_remove_filter
  function trackFilterApplied(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) return 'pdp';
      if (path.includes('/collections/')) return 'plp';
      if (path.includes('/search')) return 'search';
      if (path === '/' || path === '') return 'home';
      return 'other';
    }

    function getCategoryNames() {
      const breadcrumbs = getBreadcrumbPathArray();
      let l1CategoryName = null;
      let l2CategoryName = null;
      let l3CategoryName = null;
      if (breadcrumbs && breadcrumbs.length > 1) {
        if (breadcrumbs.length > 1) l1CategoryName = breadcrumbs[1] || null;
        if (breadcrumbs.length > 2) l2CategoryName = breadcrumbs[2] || null;
        if (breadcrumbs.length > 3) l3CategoryName = breadcrumbs[3] || null;
      }
      return {
        l1_category_name: l1CategoryName,
        l2_category_name: l2CategoryName,
        l3_category_name: l3CategoryName,
      };
    }

    const categoryNames = getCategoryNames();
    const pageName = getPageNameFromUrl();

    const isRemove = additionalData.removed_filter_value !== undefined;
    const eventName = isRemove ? 'ga_pwst_remove_filter' : 'ga_pwst_filter_applied';
    const appliedValue = Array.isArray(additionalData.applied_filter_value) ? additionalData.applied_filter_value : (additionalData.applied_filter_value || null);
    const removedValue = Array.isArray(additionalData.removed_filter_value) ? additionalData.removed_filter_value : (additionalData.removed_filter_value || null);

    const eventData = {
      event: eventName,
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: additionalData.page_name || pageName,
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      l1_category_name: additionalData.l1_category_name || categoryNames.l1_category_name,
      l2_category_name: additionalData.l2_category_name || categoryNames.l2_category_name,
      l3_category_name: additionalData.l3_category_name || categoryNames.l3_category_name,
      is_recommended_filter: additionalData.is_recommended_filter !== undefined ? additionalData.is_recommended_filter : false,
      filters: additionalData.filters || {},
      timestamp: new Date().toISOString(),
    };
    eventData[isRemove ? 'removed_filter_value' : 'applied_filter_value'] = isRemove ? removedValue : appliedValue;

    dataLayer.push(eventData);
  }
  window.trackFilterApplied = trackFilterApplied;

  function pwGetFiltersFromParams(paramString) {
    if (!paramString) return { filters: {}, appliedFilterValues: [], removedFilterValues: [] };

    const params = new URLSearchParams(paramString);
    const filters = {};
    const availabilityLabels = {
      "1": "In Stock",
      "0": "Out of Stock",
    };
    const recentlyApplied = {};
    let previousParams = "";

    if (typeof window !== "undefined") {
      previousParams = window.__PW_LAST_FILTER_PARAMS__ || "";
      window.__PW_LAST_FILTER_PARAMS__ = paramString;
    }

    const previousPairs = new Set();
    if (previousParams) {
      const prevParams = new URLSearchParams(previousParams);
      for (const [prevKey, prevValue] of prevParams.entries()) {
        if (prevKey === "sort_by") continue;
        previousPairs.add(`${prevKey}=${prevValue}`);
      }
    }

    for (const [rawKey, rawValue] of params.entries()) {
      if (rawKey === "sort_by") continue;

      const pairKey = `${rawKey}=${rawValue}`;
      const isNewPair = !previousPairs.has(pairKey);

      let key = rawKey;

      if (key.startsWith("filter.v.")) {
        key = key.slice("filter.v.".length);
      } else if (key.startsWith("filter.p.")) {
        key = key.slice("filter.p.".length);
      } else if (key.startsWith("filter.")) {
        key = key.slice("filter.".length);
      }

      if (key.startsWith("m.custom.")) {
        key = key.slice("m.custom.".length);
      }
      if (key === "price.gte") key = "gte";
      if (key === "price.lte") key = "lte";

      let value = rawValue;

      if (key === "availability") {
        value = availabilityLabels[rawValue] || rawValue;
      }

      if (!filters[key]) {
        filters[key] = [];
      }

      filters[key].push(value);

      if (isNewPair) {
        if (!recentlyApplied[key]) {
          recentlyApplied[key] = [];
        }
        recentlyApplied[key].push(value);
      }
    }

    if (!previousParams && Object.keys(filters).length > 0) {
      for (const k in filters) {
        recentlyApplied[k] = filters[k].slice();
      }
    }

    var removedFilterValues = [];
    if (previousParams) {
      var prevParams = new URLSearchParams(previousParams);
      for (const [prevKey, prevValue] of prevParams.entries()) {
        if (prevKey === "sort_by") continue;

        var stillExists = false;
        const currentValues = params.getAll(prevKey);
        for (var j = 0; j < currentValues.length; j++) {
          if (currentValues[j] === prevValue) {
            stillExists = true;
            break;
          }
        }
        if (stillExists) continue;

        let key = prevKey;

        if (key.startsWith("filter.v.")) {
          key = key.slice("filter.v.".length);
        } else if (key.startsWith("filter.p.")) {
          key = key.slice("filter.p.".length);
        } else if (key.startsWith("filter.")) {
          key = key.slice("filter.".length);
        }

        if (key.startsWith("m.custom.")) {
          key = key.slice("m.custom.".length);
        }
        if (key === "price.gte") key = "gte";
        if (key === "price.lte") key = "lte";

        let value = prevValue;
        if (key === "availability") {
          value = availabilityLabels[prevValue] || prevValue;
        }

        removedFilterValues.push(value);
      }
    }

    var appliedFilterValues = [];
    for (var rk in recentlyApplied) {
      for (var i = 0; i < recentlyApplied[rk].length; i++) {
        appliedFilterValues.push(recentlyApplied[rk][i]);
      }
    }

    return { filters: filters, appliedFilterValues: appliedFilterValues, removedFilterValues: removedFilterValues };
  }
  window.pwGetFiltersFromParams = pwGetFiltersFromParams;

  // Track sort by applied event
  // Event: pwst_sort_by_applied
  // Definition: User applying sort by (e.g. Latest, Popularity) on PLP/search
  function trackSortByApplied(additionalData = {}) {
    const userData = getUserData();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;

    function getPageNameFromUrl() {
      const path = window.location.pathname.toLowerCase();
      if (path.includes('/products/')) return 'pdp';
      if (path.includes('/collections/')) return 'plp';
      if (path.includes('/search')) return 'search';
      if (path === '/' || path === '') return 'home';
      return 'other';
    }

    function getCategoryNames() {
      const breadcrumbs = getBreadcrumbPathArray();
      let l1CategoryName = null;
      let l2CategoryName = null;
      let l3CategoryName = null;
      if (breadcrumbs && breadcrumbs.length > 1) {
        if (breadcrumbs.length > 1) l1CategoryName = breadcrumbs[1] || null;
        if (breadcrumbs.length > 2) l2CategoryName = breadcrumbs[2] || null;
        if (breadcrumbs.length > 3) l3CategoryName = breadcrumbs[3] || null;
      }
      return {
        l1_category_name: l1CategoryName,
        l2_category_name: l2CategoryName,
        l3_category_name: l3CategoryName,
      };
    }

    const categoryNames = getCategoryNames();
    const pageName = getPageNameFromUrl();

    const eventData = {
      event: 'ga_pwst_sort_by_applied',
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      business_unit: gtmConfig.business_unit || 'pw_store',
      page_url: pageUrl,
      page_name: additionalData.page_name || pageName,
      breadcrumb_path: additionalData.breadcrumb_path || getBreadcrumbPathArray(),
      is_logged_in: isLoggedIn,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      l1_category_name: additionalData.l1_category_name || categoryNames.l1_category_name,
      l2_category_name: additionalData.l2_category_name || categoryNames.l2_category_name,
      l3_category_name: additionalData.l3_category_name || categoryNames.l3_category_name,
      sort_value: additionalData.sort_value != null ? additionalData.sort_value : null,
      timestamp: new Date().toISOString(),
    };

    dataLayer.push(eventData);
  }

  // Function to attach sort by applied tracking
  function attachSortByAppliedTracking() {
    // Capture phase: the mobile sort radio's 'change' handler calls stopPropagation()
    // (see handleSortRadioChange in mobile-filter-sort-bar.liquid), which prevents the
    // event from ever bubbling to document. Listening on capture runs before that.
    document.addEventListener('change', function(event) {
      const target = event.target;
      if (!target) return;

      let sortValue = null;

      // Desktop: select with class .custom-sort-select
      if (target.matches && target.matches('.custom-sort-select')) {
        const selectedOption = target.options[target.selectedIndex];
        sortValue = selectedOption ? selectedOption.text.trim() : (target.value || null);
      }
      // Mobile: radio input name="sort_by"
      else if (target.type === 'radio' && target.name === 'sort_by') {
        const label = target.closest('.mobile-sort-list__label');
        const textEl = label ? label.querySelector('.mobile-sort-list__text') : null;
        sortValue = textEl ? textEl.textContent.trim() : (target.value || null);
      }

      if (sortValue != null) {
        requestAnimationFrame(() => {
          setTimeout(() => {
            trackSortByApplied({ sort_value: sortValue });
          }, 0);
        });
      }
    }, true);
  }

  // Debug helper: read cart/product data directly from cart item DOM attributes
  function parseDataNumber(value) {
    if (value === null || value === undefined || value === '') return null;
    const num = Number(value);
    return Number.isNaN(num) ? null : num;
  }

  /** Shopify Liquid cart money fields (e.g. cart.total_price) are in paise/minor units. */
  function shopifyCentsToRupees(cents) {
    if (cents === null || cents === undefined) return null;
    const num = Number(cents);
    if (Number.isNaN(num)) return null;
    return Number((num / 100).toFixed(2));
  }

  function parseDataBoolean(value) {
    if (value === null || value === undefined || value === '') return null;
    if (value === 'true') return true;
    if (value === 'false') return false;
    return null;
  }

  function getCartItemRowsFromDom() {
    const rows = [];
    const seenKeys = new Set();

    const pushRows = (nodeList) => {
      nodeList.forEach((row) => {
        const key = row.getAttribute('data-key') || `${row.getAttribute('data-product-id') || ''}-${row.getAttribute('data-variant-id') || ''}`;
        if (seenKeys.has(key)) return;
        seenKeys.add(key);
        rows.push(row);
      });
    };

    pushRows(Array.from(document.querySelectorAll('.cart-items__table-row[data-product-id]')));

    const host = document.querySelector('shadow-dom-container');
    const sidecart = host?.shadowRoot?.querySelector('.sidecart');
    if (sidecart) {
      pushRows(Array.from(sidecart.querySelectorAll('.cart-items__table-row[data-product-id], [data-product-id][data-variant-id]')));
    }

    return rows;
  }

  function mapCartRowToProductData(row) {
    const priceCents = parseDataNumber(row.getAttribute('data-product-price'));
    const compareAtCents = parseDataNumber(row.getAttribute('data-product-compare-at-price'));
    const discountPercent = parseDataNumber(row.getAttribute('data-product-discount-percent'));
    const inventoryQty = parseDataNumber(row.getAttribute('data-product-inventory-quantity'));

    const actualPriceCents =
      compareAtCents !== null && priceCents !== null
        ? Math.max(compareAtCents, priceCents)
        : (compareAtCents ?? priceCents);
    const discountedPriceCents =
      compareAtCents !== null && priceCents !== null
        ? Math.min(compareAtCents, priceCents)
        : priceCents;
    const discountPriceCents =
      actualPriceCents !== null && discountedPriceCents !== null && actualPriceCents > discountedPriceCents
        ? Math.max(0, actualPriceCents - discountedPriceCents)
        : null;

    return {
      key: row.getAttribute('data-key') || null,
      parent_key: row.getAttribute('data-parent-key') || null,
      product_id: row.getAttribute('data-product-id') || null,
      product_variant_id: row.getAttribute('data-variant-id') || null,
      product_position_inside_widget: normalizeWidgetPositionValue(
        row.getAttribute('data-line-item-position')
      ),
      product_title: row.getAttribute('data-product-title') || null,
      product_img_url: row.getAttribute('data-product-img-url') || pickProductImgUrlFromElement(row),
      product_variant_title: row.getAttribute('data-product-variant-title') || null,
      product_slug: row.getAttribute('data-product-handle') || null,
      product_url: row.getAttribute('data-product-url') || null,
      product_moq: 50,
      product_discount_percent: discountPercent,
      product_in_stock: inventoryQty ?? null,
      product_price: actualPriceCents,
      product_discounted_price: discountedPriceCents,
      product_discount_price: discountPriceCents,
      product_tag: row.getAttribute('data-product-tags') || null,
      preorder: row.getAttribute('data-preorder') || null,
      product_available_quantity: inventoryQty,
      product_category_id: row.getAttribute('data-product-category-id') || null,
      product_sub_category_id: row.getAttribute('data-product-sub-category-id') || null,
      product_category_slug: row.getAttribute('data-product-category-slug') || null,
      l1_category_name: row.getAttribute('data-l1-category-name') || null,
      l2_category_name: row.getAttribute('data-l2-category-name') || null,
      l3_category_name: row.getAttribute('data-l3-category-name') || null,
      wms_sub_cat_name: row.getAttribute('data-wms-sub-cat-name') || null,
    };
  }

  async function getCartAndProductsFromCartItems() {
    console.groupCollapsed('[getCartAndProductsFromCartItems] Start');
    try {
      const cartItemsComponent =
        document.querySelector('cart-drawer-component cart-items-component[data-cart-total-price]') ||
        document.querySelector('cart-items-component[data-cart-total-price]') ||
        document.querySelector('cart-items-component');
      const rows = getCartItemRowsFromDom();
      const products = rows.map(mapCartRowToProductData);
      console.log('[getCartAndProductsFromCartItems] Row count:', rows.length);
      console.log('[getCartAndProductsFromCartItems] Product data from rows:', products);

      const cart = cartItemsComponent ? {
        cart_id: cartItemsComponent.getAttribute('data-cart-id') || null,
        item_count: parseDataNumber(cartItemsComponent.getAttribute('data-cart-item-count')),
        total_price: shopifyCentsToRupees(parseDataNumber(cartItemsComponent.getAttribute('data-cart-total-price'))),
        original_total_price: shopifyCentsToRupees(parseDataNumber(cartItemsComponent.getAttribute('data-cart-original-total-price'))),
        total_discount: shopifyCentsToRupees(parseDataNumber(cartItemsComponent.getAttribute('data-cart-total-discount'))),
        payable_amount: shopifyCentsToRupees(parseDataNumber(cartItemsComponent.getAttribute('data-cart-payable-amount'))),
        shipping_amount: shopifyCentsToRupees(parseDataNumber(cartItemsComponent.getAttribute('data-cart-shipping-price'))),
        coupon_present: parseDataBoolean(cartItemsComponent.getAttribute('data-coupon-present')),
        coupon_type: cartItemsComponent.getAttribute('data-coupon-type') || null,
        coupon_codes: (cartItemsComponent.getAttribute('data-coupon-codes') || '')
          .split(',')
          .map(function (value) { return value.trim(); })
          .filter(Boolean),
      } : null;
      const result = { cart, products };
      console.log('[getCartAndProductsFromCartItems] Final result:', result);
      return result;
    } finally {
      console.groupEnd();
    }
  }

  window.getCartAndProductsFromCartItems = getCartAndProductsFromCartItems;
  window.debugCartAndProductsFromCartItems = async function () {
    const result = await getCartAndProductsFromCartItems();
    console.log('[debugCartAndProductsFromCartItems] Result:', result);
    return result;
  };

  // Track my bag page view event (cart drawer open)
  // Event: pwst_my_bag_page_view
  // Definition: User opens the cart drawer
  // MoEngage: moe_pwst_my_bag_page_view with product_n_* structure
  async function trackMyBagPageView(additionalData = {}) {
    try {
      const domCartData = await getCartAndProductsFromCartItems();
      const cart = domCartData?.cart || null;
      const productDataArray = Array.isArray(domCartData?.products) ? domCartData.products : [];

      if (cart?.cart_id) {
        window.__PW_CART_ID__ = cart.cart_id;
      }

      const userData = getUserData();
      const pageUrl = window.location.href;
      const customerData = window.__CUSTOMER_DATA__ || {};
      const gtmConfig = window.__GTM_CONFIG__ || {};
      const loginData = window.__LOGIN_DATA__ || {};

      const productIds = productDataArray.map(p => p.product_id).filter(Boolean);

      const moeEventData = buildBaseMoeEventData('moe_pwst_my_bag_page_view', {
        client_type: 'pw_store',
        device_id: additionalData.device_id || null,
      }, { pageUrl });

      const moeData = { ...moeEventData, product_ids: productIds.length > 0 ? productIds : null };

      productDataArray.forEach((p, i) => {
        const n = i + 1;
        moeData[`product_${n}_id`] = p.product_id || null;
        moeData[`product_${n}_variant`] = p.product_variant_id || null;
        moeData[`product_${n}_title`] = p.product_title || null;
        moeData[`product_${n}_img_url`] = p.product_img_url || null;
        moeData[`product_${n}_slug`] = p.product_slug || null;
        moeData[`product_${n}_tag`] = p.product_tag || null;
        moeData[`product_${n}_in_stock`] = p.product_in_stock;
        moeData[`product_${n}_available_quantity`] = p.product_available_quantity ?? null;
        moeData[`product_${n}_moq`] = 50;
        moeData[`product_${n}_price`] = p.product_price ?? null;
        moeData[`product_${n}_discounted_price`] = p.product_discounted_price ?? null;
        moeData[`product_${n}_discount_price`] = p.product_discount_price ?? null;
        moeData[`product_${n}_discount_percent`] = p.product_discount_percent ?? null;
        moeData[`product_${n}_category_name`] = p.l1_category_name || null;
        moeData[`product_${n}_l1_category_name`] = p.l1_category_name || null;
        moeData[`product_${n}_l2_category_name`] = p.l2_category_name || null;
        moeData[`product_${n}_l3_category_name`] = p.l3_category_name || null;
      });

      dataLayer.push(moeData);
    } catch (err) {
      console.error('Error tracking my bag page view:', err);
    }
  }
  window.trackMyBagPageView = trackMyBagPageView;

  // Track cart page view event
  // Event: pwst_cart_page_view
  // Definition: User opens the cart (sidecart)
  async function trackCartPageView(additionalData = {}) {
    const userData = getUserData();
    const gtmConfig = getFreshGtmConfig();
    const isLoggedIn = window.__LOGIN_DATA__?.is_logged_in || false;
    const pageUrl = window.location.href;
    
    try {
      function parseMoneyTextToNumber(text) {
        if (!text) return null;
        const cleaned = String(text).replace(/,/g, '').replace(/[^\d.-]/g, '');
        if (!cleaned) return null;
        const num = Number(cleaned);
        return Number.isNaN(num) ? null : num;
      }

      const cartItemsComponent =
        document.querySelector('cart-drawer-component cart-items-component[data-cart-total-price]') ||
        document.querySelector('cart-items-component[data-cart-total-price]') ||
        document.querySelector('cart-items-component');
      const cartRoot = cartItemsComponent || document;

      const totalValueEl = cartRoot.querySelector('.cart__total-value, [data-cart-subtotal]');
      const originalTotalEl = cartRoot.querySelector('.cart__original-total-value');
      const discountLabelEls = Array.from(cartRoot.querySelectorAll('.cart__summary-discounts .cart__discount-label'));
      const discountValueEls = Array.from(cartRoot.querySelectorAll('.cart__summary-discounts .cart__discount-value'));

      const totalPriceFromAttr = shopifyCentsToRupees(
        parseMoneyTextToNumber(cartItemsComponent?.getAttribute('data-cart-total-price'))
      );
      const originalTotalFromAttr = shopifyCentsToRupees(
        parseMoneyTextToNumber(cartItemsComponent?.getAttribute('data-cart-original-total-price'))
      );
      const payableAmountFromAttr = shopifyCentsToRupees(
        parseMoneyTextToNumber(cartItemsComponent?.getAttribute('data-cart-payable-amount'))
      );

      const totalPriceFromDom = parseMoneyTextToNumber(totalValueEl?.textContent || '') || 0;
      const totalPrice = totalPriceFromAttr !== null ? totalPriceFromAttr : totalPriceFromDom;
      const originalTotalParsed = originalTotalFromAttr !== null
        ? originalTotalFromAttr
        : parseMoneyTextToNumber(originalTotalEl?.textContent || '');
      const originalTotalPrice = originalTotalParsed !== null ? originalTotalParsed : totalPrice;
      const couponArrayFromDom = discountLabelEls
        .map(function (el) { return (el?.textContent || '').trim(); })
        .filter(Boolean);
      const couponArray = couponArrayFromDom.length > 0 ? couponArrayFromDom : null;
      const couponPresent = !!(couponArray && couponArray.length > 0);
      const couponType = null;

      // Calculate total quantity from cart rows
      const cartRows = getCartItemRowsFromDom();
      const totalItemQuantity = cartRows.reduce(function (sum, row) {
        const qtyInput = row.querySelector('input[name^="updates"], input[type="number"]');
        const qty = qtyInput ? Number(qtyInput.value) : 1;
        return sum + (Number.isFinite(qty) && qty > 0 ? qty : 1);
      }, 0);

      // Shipping is not reliably exposed in drawer markup; keep null if unavailable
      const shippingAmount = null;
      
      // Get product data from cart item DOM data attributes (base source)
      const domCartData = await getCartAndProductsFromCartItems();
      const productDataArray = Array.isArray(domCartData?.products) ? domCartData.products : [];

      // On first open, DOM coupon labels are often empty — fall back to cart.js
      let couponArrayForEvent = couponArray;
      let couponTypeForEvent = couponType;
      let couponPresentForEvent = couponPresent;
      let couponDiscountForEvent = null;
      if (!couponArrayForEvent || couponArrayForEvent.length === 0) {
        const cartJsCouponState = await fetchCouponStateFromCartJs();
        if (cartJsCouponState) {
          couponArrayForEvent = cartJsCouponState.coupon_array;
          couponTypeForEvent = cartJsCouponState.coupon_type;
          couponPresentForEvent = cartJsCouponState.coupon_present;
          couponDiscountForEvent = cartJsCouponState.coupon_discount;
        }
      }

      // Resolve coupon fields with listener state first, then cart fallback
      const resolvedCouponState = getCouponStateForCartEvent(
        couponArrayForEvent,
        couponTypeForEvent,
        couponPresentForEvent,
        couponDiscountForEvent
      );
      const couponDiscountValue = Number(resolvedCouponState?.coupon_discount);
      const couponDiscount = Number.isFinite(couponDiscountValue) ? Math.max(0, couponDiscountValue) : 0;

      const mrpTotal = Number(originalTotalPrice.toFixed(2));
      const discountedMrp = Math.max(0, Number((mrpTotal - couponDiscount).toFixed(2)));
      const payableAmount =
        payableAmountFromAttr !== null
          ? payableAmountFromAttr
          : Number(totalPrice.toFixed(2));
      
      // Build line_items array with product objects
      const lineItems = productDataArray.map(product => ({
        product_id: product.product_id || null,
        product_title: product.product_title || null,
        product_slug: product.product_slug || null,
        product_moq: 50,
        product_discount_percent: product.product_discount_percent || null,
        product_in_stock: product.product_available_quantity || null,
        product_price: product.product_price || null,
        product_discount_price: product.product_discount_price || null,
        product_discounted_price: product.product_discounted_price || null,
        product_tag: product.product_tag || null,
        preorder: product.preorder || null,
        product_available_quantity: product.product_available_quantity || null,
        l1_category_name: product.l1_category_name || null,
        l2_category_name: product.l2_category_name || null,
        l3_category_name: product.l3_category_name || null,
        product_category_slug: product.product_category_slug || null,
        product_variant_id: product.product_variant_id || null,
      }));
      
      const eventData = {
        event: 'ga_pwst_cart_page_viewed',
        platform: getGtmPlatformValue(),
        organisation_name: gtmConfig.organisation_name || 'pw',
        business_unit: gtmConfig.business_unit || 'pw_store',
        page_url: pageUrl,
        page_name: resolveGtmPageName(additionalData.page_name || 'Cart'),
        is_logged_in: Boolean(isLoggedIn),
        from_app: typeof getFromAppFlag === 'function' ? getFromAppFlag() : false,
        user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
        pw_user_id: userData.pw_user_id,
        cohort_id: userData.cohort_id,
        cohort_name: userData.cohort_name,
        mrp_total: mrpTotal,
        discounted_mrp: discountedMrp,
        coupon_discount: couponDiscount,
        total_item_quantity: totalItemQuantity,
        payable_amount: payableAmount,
        shipping_amount: shippingAmount,
        cart_id: window.__PW_CART_ID__ || null,
        shopify_session_id: getShopifySessionId(),
        coupon_type: resolvedCouponState.coupon_type,
        coupon_present: resolvedCouponState.coupon_present,
        coupon_array: resolvedCouponState.coupon_array,
        line_items: lineItems.length > 0 ? JSON.stringify(lineItems) : null,
        timestamp: new Date().toISOString(),
      };
      
      dataLayer.push(eventData);
    } catch (err) {
      console.error('Error tracking cart page view:', err);
    }
  }
  window.trackCartPageView = trackCartPageView;

  // Function to attach cart page view tracking
  function attachCartPageViewTracking() {
    // Track if cart view has been tracked to prevent duplicates
    let cartViewTracked = false;
    let lastCartState = false; // false = closed, true = open
    let lastTrackedTime = 0;
    const TRACKING_DEBOUNCE_MS = 1000; // Prevent duplicate tracking within 1 second
    
    // Function to check if sidecart is open
    function getSideCart() {
      const host = document.querySelector('shadow-dom-container');
      const sidecart = host?.shadowRoot?.querySelector('.sidecart');
      
      // If not in DOM or not visible, treat as closed
      if (!sidecart || sidecart.getClientRects().length === 0) {
        return null;
      }
      
      return sidecart;
    }
    
    // Function to track cart page view with deduplication
    function trackCartView() {
      // Small delay to ensure cart content is loaded; fireCartPageViewOnce prevents duplicates
      setTimeout(() => {
        fireCartPageViewOnce({ page_name: 'Cart' });
      }, 300);
    }
    
    // Function to check cart state and track if opened
    function checkCartState() {
      const sideCart = getSideCart();
      const isOpen = sideCart !== null;
      
      // Track when cart opens (transitions from closed to open)
      if (isOpen && !lastCartState) {
        trackCartView();
      }
      
      // Reset tracking flag when cart closes
      if (!isOpen && lastCartState) {
        cartViewTracked = false;
      }
      
      lastCartState = isOpen;
    }
    
    // Set up observer for shadow DOM changes
    function initObserver() {
      const host = document.querySelector('shadow-dom-container');
      if (!host || !host.shadowRoot) return false;
      
      const observer = new MutationObserver(() => {
        checkCartState();
      });
      
      observer.observe(host.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'open']
      });
      
      // Also check periodically as fallback
      setInterval(checkCartState, 500);
      
      return true;
    }
    
    // Wait until shadow host exists
    const wait = setInterval(() => {
      if (initObserver()) {
        clearInterval(wait);
        checkCartState();
      }
    }, 200);
    
    // Also listen for clicks on cart-opening buttons as fallback
    document.addEventListener('click', function(event) {
      const target = getEventElement(event);
      if (!target) return;
      const cartButton = target.closest('[onclick*="openGokwikSideCart"], [onclick*="openCartDrawer"], button[on\\:click="/open"], .header-actions__bag, .header-actions__action.header-actions__bag, .mobile-sticky-cart-button__trigger');
      if (cartButton) {
        // Don't reset flags here - let the MutationObserver handle it
        // Just trigger a state check after a delay to allow cart to open
        setTimeout(() => {
          checkCartState();
        }, 500); // Delay to allow cart to open
      }
    }, true); // Use capture phase
    
    // Also listen for cart update events as fallback
    document.addEventListener('cart:update', () => {
      setTimeout(checkCartState, 100);
    });
    
    // Listen for openGokwikSideCart function calls (if available globally)
    if (typeof window.openGokwikSideCart === 'function') {
      const originalOpenGokwikSideCart = window.openGokwikSideCart;
      window.openGokwikSideCart = function(...args) {
        const result = originalOpenGokwikSideCart.apply(this, args);
        setTimeout(() => {
          checkCartState();
        }, 500);
        return result;
      };
    }
  }

  function trackProductItemsView(additionalData = {}) {
    const userData = getUserData();
    const pageName =
      (typeof getPageContext === 'function' && getPageContext() && getPageContext().pageName)
        ? getPageContext().pageName
        : (typeof getPageNameFromUrl === 'function' ? getPageNameFromUrl() : null);

    const eventData = buildBaseGtmEventData(
      'ga_pwst_product_items_viewed',
      {
        cohort_name: userData.cohort_name,
        widget_name: additionalData.widget_name || null,
        page_widget_position:
          additionalData.page_widget_position != null && additionalData.page_widget_position !== ''
            ? additionalData.page_widget_position
            : additionalData.widget_position || null,
        product_position_inside_widget:
          additionalData.product_position_inside_widget != null &&
          additionalData.product_position_inside_widget !== ''
            ? additionalData.product_position_inside_widget
            : additionalData.position_inside_widget || null,
        product_id: additionalData.product_id || null,
        product_title: additionalData.product_title || null,
        product_slug: additionalData.product_slug || null,
        product_moq: 50,
        product_discount_percent: additionalData.product_discount_percent || null,
        product_in_stock: additionalData.product_available_quantity ?? null,
        product_price: additionalData.product_price || null,
        product_discount_price: additionalData.product_discount_price || null,
        product_discounted_price: additionalData.product_discounted_price || null,
        product_tag: additionalData.product_tag || null,
        preorder: additionalData.preorder || null,
        product_available_quantity: additionalData.product_available_quantity || null,
        l1_category_name: additionalData.l1_category_name || null,
        l2_category_name: additionalData.l2_category_name || null,
        l3_category_name: additionalData.l3_category_name || null,
        product_category_slug: additionalData.product_category_slug || null,
        product_variant_id: additionalData.product_variant_id || null,
      },
      {
        pageName: additionalData.page_name || pageName,
      }
    );

    dataLayer.push(eventData);
  }

  window.trackProductItemsView = trackProductItemsView;

  function attachProductItemsViewTracking() {
    if (!document.body) {
      document.addEventListener('DOMContentLoaded', function onReady() {
        document.removeEventListener('DOMContentLoaded', onReady);
        attachProductItemsViewTracking();
      });
      return;
    }

    setTimeout(() => {
      const TARGET_SECTION_CLASSES = [
        'custom-product-list',
        'custom-product-list-load-more'
      ];
      
      const TARGET_SECTION_TESTIDS = [
        'product-list',
        'load-more-product-grid'
      ];
      
      const VISIBILITY_DWELL_MS = 4000;
      const MIN_VISIBLE_RATIO = 0.01;

      const viewedProducts = new Set();
      const visibilityDwellStart = new Map();
      const observedElements = new Set();
      const observedTrackingKeys = new Set();
      const swiperObservers = new WeakMap();

      let syncScheduled = false;
      let dwellSyncIntervalId = null;

      const scheduleIdleTask = typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback.bind(window)
        : function (callback, options) {
            const timeout = (options && options.timeout) || 100;
            window.setTimeout(function () {
              callback({ didTimeout: true, timeRemaining: function () { return 0; } });
            }, timeout);
          };

      function resolveProductObservationTarget(element) {
        if (!element) return element;
        return (
          element.closest('product-card[data-product-id]') ||
          element.closest('.product-card[data-product-id]') ||
          element.closest('.swiper-slide[data-product-id]') ||
          element.closest('li[data-product-id]') ||
          element.closest('tr[data-product-id]') ||
          (element.hasAttribute && element.hasAttribute('data-product-id') ? element : null)
        );
      }

      function getProductViewTrackingKey(element) {
        const target = resolveProductObservationTarget(element);
        if (!target) return null;
        const productId = target.getAttribute('data-product-id');
        if (!productId) return null;
        const widgetInfo = getWidgetInfoFromElement(target);
        const widgetPos = widgetInfo.page_widget_position ?? '';
        const slide = target.closest('.swiper-slide[data-product-position]');
        const productPos =
          widgetInfo.product_position_inside_widget ??
          (slide ? slide.getAttribute('data-product-position') : null) ??
          '';
        return String(productId) + ':' + String(widgetPos) + ':' + String(productPos);
      }

      function getProductVisibleRatio(element) {
        if (!element || !element.isConnected) return 0;
        const rect = element.getBoundingClientRect();
        if (rect.width <= 0 || rect.height <= 0) return 0;

        let clipLeft = 0;
        let clipTop = 0;
        let clipRight = window.innerWidth || document.documentElement.clientWidth || 0;
        let clipBottom = window.innerHeight || document.documentElement.clientHeight || 0;

        const swiperRoot = element.closest('.swiper, .swiper-container, .product-swiper');
        if (swiperRoot) {
          const swiperRect = swiperRoot.getBoundingClientRect();
          clipLeft = Math.max(clipLeft, swiperRect.left);
          clipTop = Math.max(clipTop, swiperRect.top);
          clipRight = Math.min(clipRight, swiperRect.right);
          clipBottom = Math.min(clipBottom, swiperRect.bottom);
        }

        const visibleLeft = Math.max(rect.left, clipLeft);
        const visibleTop = Math.max(rect.top, clipTop);
        const visibleRight = Math.min(rect.right, clipRight);
        const visibleBottom = Math.min(rect.bottom, clipBottom);
        const visibleWidth = Math.max(0, visibleRight - visibleLeft);
        const visibleHeight = Math.max(0, visibleBottom - visibleTop);
        const visibleArea = visibleWidth * visibleHeight;
        const elementArea = rect.width * rect.height;
        if (elementArea <= 0) return 0;
        return visibleArea / elementArea;
      }

      function isElementVisibleForProductView(element) {
        return getProductVisibleRatio(element) >= MIN_VISIBLE_RATIO;
      }

      function syncProductVisibility() {
        const now = Date.now();
        let hasPendingDwell = false;

        observedElements.forEach(function (el) {
          if (!el || !el.isConnected) return;
          const trackingKey = getProductViewTrackingKey(el);
          if (!trackingKey || viewedProducts.has(trackingKey)) return;
          if (!isInTargetSection(el)) return;

          const visibleRatio = getProductVisibleRatio(el);
          const isVisible = visibleRatio >= MIN_VISIBLE_RATIO;

          if (isVisible) {
            hasPendingDwell = true;
            const dwellStartedAt = visibilityDwellStart.get(trackingKey);
            if (dwellStartedAt == null) {
              visibilityDwellStart.set(trackingKey, now);
            } else if (now - dwellStartedAt >= VISIBILITY_DWELL_MS) {
              scheduleIdleTask(() => {
                trackProductView(el);
              }, { timeout: 200 });
              visibilityDwellStart.delete(trackingKey);
            }
          } else {
            visibilityDwellStart.delete(trackingKey);
          }
        });

        if (hasPendingDwell || visibilityDwellStart.size > 0) {
          ensureDwellSyncInterval();
        } else if (dwellSyncIntervalId != null) {
          window.clearInterval(dwellSyncIntervalId);
          dwellSyncIntervalId = null;
        }
      }

      function scheduleProductVisibilitySync() {
        if (syncScheduled) return;
        syncScheduled = true;
        // Double rAF: first frame paints interaction feedback; second runs layout reads.
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            syncScheduled = false;
            syncProductVisibility();
          });
        });
      }

      function ensureDwellSyncInterval() {
        if (dwellSyncIntervalId != null) return;
        dwellSyncIntervalId = window.setInterval(syncProductVisibility, 500);
      }

      let debouncedVisibilitySyncTimer = null;
      function debouncedProductVisibilitySync() {
        if (debouncedVisibilitySyncTimer) {
          window.clearTimeout(debouncedVisibilitySyncTimer);
        }
        debouncedVisibilitySyncTimer = window.setTimeout(function () {
          debouncedVisibilitySyncTimer = null;
          scheduleProductVisibilitySync();
        }, 100);
      }

      function ensureSwiperObserver(swiperRoot) {
        if (!swiperRoot || swiperObservers.has(swiperRoot)) {
          return swiperObservers.get(swiperRoot) || null;
        }
        const swiperObserver = new IntersectionObserver(function () {
          scheduleProductVisibilitySync();
        }, {
          root: swiperRoot,
          rootMargin: '0px',
          threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1],
        });
        swiperObservers.set(swiperRoot, swiperObserver);
        return swiperObserver;
      }

      function registerProductTarget(target) {
        if (!target) return;
        const trackingKey = getProductViewTrackingKey(target);
        const productId = target.getAttribute('data-product-id');
        if (
          !productId ||
          !trackingKey ||
          viewedProducts.has(trackingKey) ||
          observedTrackingKeys.has(trackingKey)
        ) {
          return;
        }
        if (!isInTargetSection(target)) return;

        observedTrackingKeys.add(trackingKey);
        observedElements.add(target);
        viewportObserver.observe(target);

        const swiperRoot = target.closest('.swiper, .swiper-container, .product-swiper');
        if (swiperRoot) {
          const swiperObserver = ensureSwiperObserver(swiperRoot);
          if (swiperObserver) swiperObserver.observe(target);
        }
      }

      function collectProductTargetsFromRoot(root) {
        const targetsByKey = new Map();
        if (!root) return targetsByKey;

        const swiperSlides = root.querySelectorAll('.swiper-slide[data-product-id]');
        if (swiperSlides.length > 0) {
          swiperSlides.forEach(function (slide) {
            const target = resolveProductObservationTarget(slide);
            const trackingKey = target ? getProductViewTrackingKey(target) : null;
            if (target && trackingKey && !targetsByKey.has(trackingKey)) {
              targetsByKey.set(trackingKey, target);
            }
          });
          return targetsByKey;
        }

        const gridSelectors = [
          'product-card[data-product-id]',
          '.product-card[data-product-id]',
          'li[data-product-id]',
          'tr[data-product-id]',
          'product-card-link[data-product-id]',
          '.cart-items__table-row[data-product-id]',
        ];

        gridSelectors.forEach(function (selector) {
          root.querySelectorAll(selector).forEach(function (element) {
            const target = resolveProductObservationTarget(element);
            const trackingKey = target ? getProductViewTrackingKey(target) : null;
            if (target && trackingKey && !targetsByKey.has(trackingKey)) {
              targetsByKey.set(trackingKey, target);
            }
          });
        });

        return targetsByKey;
      }

      function attachSwiperVisibilityHooks() {
        document.querySelectorAll('.product-swiper, .swiper-container, .swiper').forEach(function (swiperEl) {
          if (swiperEl.dataset.pwProductViewHooked === 'true') return;
          swiperEl.dataset.pwProductViewHooked = 'true';
          ensureSwiperObserver(swiperEl);

          function hookInstance() {
            const swiper = swiperEl.swiper;
            if (!swiper || swiper.__pwProductViewHooked) return;
            swiper.__pwProductViewHooked = true;
            // INP risk: low — swiper hooks schedule one debounced visibility sync per interaction.
            swiper.on('slideChange', scheduleProductVisibilitySync);
            swiper.on('transitionEnd', scheduleProductVisibilitySync);
            swiper.on('slideChangeTransitionEnd', scheduleProductVisibilitySync);
            swiper.on('touchEnd', scheduleProductVisibilitySync);
            swiper.on('resize', scheduleProductVisibilitySync);
            scheduleProductVisibilitySync();
          }

          if (swiperEl.swiper) {
            hookInstance();
            return;
          }

          const waitForSwiper = window.setInterval(function () {
            if (swiperEl.swiper) {
              window.clearInterval(waitForSwiper);
              hookInstance();
            }
          }, 250);

          window.setTimeout(function () {
            window.clearInterval(waitForSwiper);
          }, 15000);
        });
      }

      const viewportObserver = new IntersectionObserver(function () {
        scheduleProductVisibilitySync();
      }, {
        root: null,
        rootMargin: '0px',
        threshold: [0, 0.01, 0.1, 0.25, 0.5, 0.75, 1],
      });

      const pagePath = (window.location.pathname || '').toLowerCase();
      const isCartPage = pagePath.includes('/cart');
      const isCollectionOrSearchPage = pagePath.includes('/collections/') || pagePath.includes('/search');

      function isInTargetSection(element) {
        if (!element) return false;
        
        if (element.closest('results-list')) return true;

        if (element.closest('#predictive-search-results, #predictive-search-products')) return true;

        if (isCartPage && (element.closest('cart-items-component') || element.closest('.cart-items-component') || element.closest('.cart-items__table-row'))) {
          return true;
        }

        if (element.closest('product-recommendations') || element.closest('[data-testid="product-recommendations-section"]')) {
          return true;
        }
        
        let current = element;
        let depth = 0;
        const maxDepth = 15;
        
        while (current && depth < maxDepth) {
          if (current.tagName === 'SECTION') {
            const sectionClass = current.className ? String(current.className) : '';
            const sectionTestId = current.getAttribute('data-testid') || '';
            
            if (TARGET_SECTION_CLASSES.some(className => sectionClass.includes(className))) {
              return true;
            }
            
            if (TARGET_SECTION_TESTIDS.some(testId => sectionTestId === testId)) {
              return true;
            }
          }
          
          const parentSection = current.closest('section');
          if (parentSection) {
            const parentClass = parentSection.className ? String(parentSection.className) : '';
            const parentTestId = parentSection.getAttribute('data-testid') || '';
            
            if (TARGET_SECTION_CLASSES.some(className => parentClass.includes(className))) {
              return true;
            }
            
            if (TARGET_SECTION_TESTIDS.some(testId => parentTestId === testId)) {
              return true;
            }
          }
          
          current = current.parentElement;
          depth++;
        }
        
        return false;
      }
      
      function getProductDataFromElement(element) {
        const sourceElement = resolveProductObservationTarget(element);
        if (!sourceElement) return null;
        const trackingKey = getProductViewTrackingKey(sourceElement);
        if (!trackingKey || viewedProducts.has(trackingKey)) return null;

        const productId = sourceElement.getAttribute('data-product-id');
        if (!productId) return null;
        let dataElement = sourceElement.matches('product-card,[data-product-price],[data-product-handle]')
          ? sourceElement
          : (sourceElement.querySelector('product-card[data-product-id],.product-card[data-product-id],[data-product-price],[data-product-handle]') || sourceElement);
        if (!dataElement.getAttribute('data-product-price') && !dataElement.getAttribute('data-product-title') && !dataElement.getAttribute('data-product-handle')) {
          const widgetScope =
            sourceElement.closest('section, product-recommendations, results-list, .product-swiper, .swiper-container, .custom-product-list') ||
            sourceElement;
          const richElement =
            widgetScope.querySelector(
              'product-card[data-product-id="' + productId + '"],.product-card[data-product-id="' + productId + '"],[data-product-id="' + productId + '"][data-product-price],[data-product-id="' + productId + '"][data-product-handle]'
            ) ||
            sourceElement.querySelector(
              'product-card[data-product-id="' + productId + '"],.product-card[data-product-id="' + productId + '"],[data-product-price],[data-product-handle]'
            );
          if (richElement) dataElement = richElement;
        }
        
        const widgetInfo = getWidgetInfoFromElement(sourceElement);
        
        let l1CategoryName = dataElement.getAttribute('data-l1-category-name') || sourceElement.getAttribute('data-l1-category-name');
        let l2CategoryName = dataElement.getAttribute('data-l2-category-name') || sourceElement.getAttribute('data-l2-category-name');
        let l3CategoryName = dataElement.getAttribute('data-l3-category-name') || sourceElement.getAttribute('data-l3-category-name');
        if (!l1CategoryName || !l2CategoryName || !l3CategoryName) {
          const parentSlide = sourceElement.closest('.swiper-slide');
          if (parentSlide) {
            if (!l1CategoryName) l1CategoryName = parentSlide.getAttribute('data-l1-category-name');
            if (!l2CategoryName) l2CategoryName = parentSlide.getAttribute('data-l2-category-name');
            if (!l3CategoryName) l3CategoryName = parentSlide.getAttribute('data-l3-category-name');
          }
        }
        if (!l1CategoryName || !l2CategoryName || !l3CategoryName) {
          const parentLi = sourceElement.closest('.product-grid__item, li[data-product-id]');
          if (parentLi) {
            if (!l1CategoryName) l1CategoryName = parentLi.getAttribute('data-l1-category-name');
            if (!l2CategoryName) l2CategoryName = parentLi.getAttribute('data-l2-category-name');
            if (!l3CategoryName) l3CategoryName = parentLi.getAttribute('data-l3-category-name');
          }
        }
        
        const productAnchor = dataElement.querySelector('a[href*="/products/"]') || sourceElement.querySelector('a[href*="/products/"]');
        const productTitle =
                            dataElement.getAttribute('data-product-title')?.trim() ||
                            sourceElement.getAttribute('data-product-title')?.trim() ||
                            dataElement.querySelector('[data-product-title-tag],.product-title,[class*="product-title"],h2,h3,h4,.visually-hidden')?.textContent?.trim() ||
                            sourceElement.querySelector('[data-product-title-tag],.product-title,[class*="product-title"],h2,h3,h4,.visually-hidden')?.textContent?.trim() ||
                            productAnchor?.textContent?.trim() ||
                            null;
        const productSlug = dataElement.getAttribute('data-product-handle') ||
                           sourceElement.getAttribute('data-product-handle') ||
                           (productAnchor?.href?.match(/\/products\/([^\/\?]+)/)?.[1]) ||
                           null;
        
        const priceRaw = dataElement.getAttribute('data-product-price') || sourceElement.getAttribute('data-product-price');
        const compareAtRaw = dataElement.getAttribute('data-product-compare-at-price') || sourceElement.getAttribute('data-product-compare-at-price');
        const priceUnit =
          dataElement.getAttribute('data-gtm-price-unit') ||
          sourceElement.getAttribute('data-gtm-price-unit');
        // Only Storefront API cards (data-gtm-price-unit="rupees") skip /100. Search/collection PLP use Liquid product-card (Shopify cents) inside <results-list>.
        const pricesInCents = priceUnit !== 'rupees';
        const priceRupees = normalizeGtmProductPrice(priceRaw ? parseFloat(priceRaw) : 0, pricesInCents) ?? 0;
        const compareAtRupees = normalizeGtmProductPrice(compareAtRaw ? parseFloat(compareAtRaw) : 0, pricesInCents) ?? 0;
        const productPrice = compareAtRupees > 0 ? compareAtRupees : priceRupees;
        const productDiscountedPrice = priceRupees;
        const productDiscountPrice =
          compareAtRupees > 0 && compareAtRupees > priceRupees ? compareAtRupees - priceRupees : null;
        
        const productDiscountPercent = dataElement.getAttribute('data-product-discount-percent') || sourceElement.getAttribute('data-product-discount-percent') || null;
        const availableStr = dataElement.getAttribute('data-product-available') || sourceElement.getAttribute('data-product-available');
        const isInStock = availableStr === 'true' ? true : (availableStr === 'false' ? false : null);
        const inventoryQtyStr = dataElement.getAttribute('data-product-inventory-quantity') || sourceElement.getAttribute('data-product-inventory-quantity');
        const productAvailableQuantity = inventoryQtyStr !== null && inventoryQtyStr !== '' ? parseInt(inventoryQtyStr, 10) : null;
        const productTags = dataElement.getAttribute('data-product-tags') || sourceElement.getAttribute('data-product-tags') ||null;
        const preorder = dataElement.getAttribute('data-preorder') || sourceElement.getAttribute('data-preorder') || 'no';
        const productVariantId = dataElement.getAttribute('data-product-variant-id') || sourceElement.getAttribute('data-product-variant-id') || null;
        
        return {
          product_id: productId,
          product_title: productTitle,
          product_img_url:
            dataElement.getAttribute('data-product-img-url') ||
            sourceElement.getAttribute('data-product-img-url') ||
            pickProductImgUrlFromElement(dataElement) ||
            pickProductImgUrlFromElement(sourceElement),
          product_slug: productSlug,
          product_moq: 50,
          product_discount_percent: productDiscountPercent,
          product_in_stock: productAvailableQuantity ?? null,
          product_price: productPrice || null,
          product_discount_price: productDiscountPrice,
          product_discounted_price: productDiscountedPrice || null,
          product_tag: productTags,
          preorder: preorder,
          product_available_quantity: productAvailableQuantity,
          l1_category_name: l1CategoryName || null,
          l2_category_name: l2CategoryName || null,
          l3_category_name: l3CategoryName || null,
          product_category_slug: null,
          product_variant_id: productVariantId,
          widget_name: widgetInfo.page_widget_name,
          page_widget_position: widgetInfo.page_widget_position,
          product_position_inside_widget: widgetInfo.product_position_inside_widget,
        };
      }
      
      function trackProductView(element) {
        const target = resolveProductObservationTarget(element);
        const trackingKey = getProductViewTrackingKey(target);
        if (!trackingKey || viewedProducts.has(trackingKey)) return;

        const productData = getProductDataFromElement(target);
        if (!productData) return;

        viewedProducts.add(trackingKey);
        visibilityDwellStart.delete(trackingKey);

        try {
          trackProductItemsView(productData);
        } catch (err) {
          console.error('Error tracking product items view:', err);
        }
      }
      
      function observeProductsInTargetSections() {
        const targetSections = new Set();
        
        TARGET_SECTION_CLASSES.forEach(className => {
          document.querySelectorAll(`section.${className}, section[class*="${className}"]`).forEach(section => {
            if (section) targetSections.add(section);
          });
        });
        
        TARGET_SECTION_TESTIDS.forEach(testId => {
          document.querySelectorAll(`section[data-testid="${testId}"]`).forEach(section => {
            if (section) targetSections.add(section);
          });
        });
        
        document.querySelectorAll('product-recommendations[data-testid="product-recommendations-section"]').forEach(container => {
          if (container) targetSections.add(container);
        });

        const roots = new Set(Array.from(targetSections));

        if (isCollectionOrSearchPage) {
          document.querySelectorAll('results-list').forEach(el => roots.add(el));
        }

        document.querySelectorAll('#predictive-search-results, #predictive-search-products').forEach(el => roots.add(el));

        if (isCartPage) {
          document.querySelectorAll('cart-items-component, .cart-items-component').forEach(el => roots.add(el));
        }
        
        Array.from(roots).forEach(root => {
          const targets = collectProductTargetsFromRoot(root);
          targets.forEach(function (target) {
            registerProductTarget(target);
          });
        });

        attachSwiperVisibilityHooks();
        scheduleProductVisibilitySync();
      }

      // INP risk: low — passive scroll/resize listeners only schedule debounced visibility sync.
      window.addEventListener('scroll', debouncedProductVisibilitySync, { passive: true });
      window.addEventListener('resize', debouncedProductVisibilitySync, { passive: true });
      window.addEventListener('orientationchange', debouncedProductVisibilitySync, { passive: true });
      
      // Initial observation (try multiple times to catch sections that load later)
      observeProductsInTargetSections();
      
      // Try again after a delay to catch sections that load asynchronously
      setTimeout(() => {
        observeProductsInTargetSections();
      }, 500);
      
      setTimeout(() => {
        observeProductsInTargetSections();
      }, 1500);
      
      // Use MutationObserver to detect when new products are added to target sections
      const mutationObserver = new MutationObserver(function(mutations) {
        let shouldReobserve = false;
        mutations.forEach(mutation => {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(node => {
              if (node.nodeType === 1) { // Element node
                // Check if this node is in a target section
                if (isInTargetSection(node)) {
                  const hasProductId = node.hasAttribute && node.hasAttribute('data-product-id');
                  const containsProductCard = node.querySelector && node.querySelector('[data-product-id]');
                  if (hasProductId || containsProductCard) {
                    shouldReobserve = true;
                  }
                }
              }
            });
          }
        });
        
        if (shouldReobserve) {
          // Small delay to ensure DOM is fully rendered
          setTimeout(observeProductsInTargetSections, 100);
        }
      });
      
      // Observe document body for changes
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      // Also observe target sections directly (observe ALL matching sections)
      setTimeout(() => {
        const observedSections = new Set();
        
        // Observe sections by class
        TARGET_SECTION_CLASSES.forEach(className => {
          const sections = document.querySelectorAll(`section.${className}, section[class*="${className}"]`);
          sections.forEach(section => {
            if (section && !observedSections.has(section)) {
              observedSections.add(section);
              mutationObserver.observe(section, {
                childList: true,
                subtree: true
              });
            }
          });
        });
        
        // Observe sections by data-testid
        TARGET_SECTION_TESTIDS.forEach(testId => {
          const sections = document.querySelectorAll(`section[data-testid="${testId}"]`);
          sections.forEach(section => {
            if (section && !observedSections.has(section)) {
              observedSections.add(section);
              mutationObserver.observe(section, {
                childList: true,
                subtree: true
              });
            }
          });
        });
      }, 1000);
      
      // Also periodically check for new sections (in case they load dynamically)
      setInterval(() => {
        observeProductsInTargetSections();
      }, 2000); // Check every 2 seconds
    });
  }

  // Definition: When user lands on the homepage
  function trackHomePageExplore(additionalData = {}) {
    const customerData = window.__CUSTOMER_DATA__ || {};
    const gtmConfig = window.__GTM_CONFIG__ || {};
    const loginData = window.__LOGIN_DATA__ || {};

    const userData = {
      user_id: customerData?.customerId || null,
      pw_user_id: customerData.pw_user_id || null,
      cohort_id: customerData.cohort_id || null,
      cohort_name: customerData.cohort_name || null,
    };

    const pageUrl = window.location.href;
    const moeEventData = buildBaseMoeEventData('moe_pwst_home_page_explore', {
      client_type: 'pw_store',
      device_id: additionalData.device_id || null,
    }, {
      pageUrl: pageUrl,
    });

    console.log('ðŸ’¾ [MOE] Home page explore event:', moeEventData);
    dataLayer.push(moeEventData);
  }

  function trackStoreStart() {
    try {
      const pageUrl = window.__PW_GA_PAGE_PATH_URL__ || window.location.href;
      const eventData = buildBaseGtmEventData('ga_pwst_store_start', {}, {
        pageUrl: pageUrl,
      });
      
      const moeEventData = buildBaseMoeEventData('moe_pwst_store_start', {}, {
        pageUrl: pageUrl,
      });
      
      console.log('ðŸ’¾ [MOE] Event data:', moeEventData);
      eventData.page_name = resolveGtmPageName(eventData.page_name);
      if (typeof getPageContext === 'function') {
        const pageContext = getPageContext();
        if (pageContext && pageContext.pageSubtype && !eventData.page_subtype) {
          eventData.page_subtype = pageContext.pageSubtype;
        }
      }

      dataLayer.push(eventData);
      dataLayer.push(moeEventData);
    } catch (err) {
      console.error('Error tracking ga_pwst_store_start:', err);
    }
  }

  function initStoreStartTracking() {
    const TAB_KEY = 'pw_store_active_tabs';
    const INACTIVITY_KEY = 'pw_store_last_activity';
    const INACTIVITY_THRESHOLD = 30 * 60 * 1000; // 30 minutes in milliseconds
    const EVENT_FIRED_KEY = 'pw_store_start_fired';
    const TAB_ID = 'tab_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

    const inMemoryEventKey = '__PW_STORE_START_FIRED_IN_MEMORY__';
    if (window[inMemoryEventKey] === true) return;

    function safeSessionGet(key) {
      try {
        return sessionStorage.getItem(key);
      } catch (e) {
        return null;
      }
    }

    function safeSessionSet(key, value) {
      try {
        sessionStorage.setItem(key, value);
      } catch (e) {
        // Ignore storage write failures; we'll dedupe via in-memory flag.
      }
    }

    if (safeSessionGet(EVENT_FIRED_KEY) === 'true') return;

    let broadcastChannel = null;
    let isFirstTab = true;
    let tabCheckTimeout = null;
    let cleanupFunctions = [];

    function cleanup() {
      if (tabCheckTimeout) {
        clearTimeout(tabCheckTimeout);
        tabCheckTimeout = null;
      }
      cleanupFunctions.forEach(function(cleanupFn) {
        try {
          cleanupFn();
        } catch (e) {
          console.error('Error during cleanup:', e);
        }
      });
      cleanupFunctions = [];
      if (broadcastChannel) {
        try {
          broadcastChannel.close();
        } catch (e) {
          console.error('Error closing broadcast channel:', e);
        }
        broadcastChannel = null;
      }
    }

    if (typeof BroadcastChannel !== 'undefined') {
      broadcastChannel = new BroadcastChannel('pw_store_tabs');

      // Register this tab
      try {
        const activeTabs = JSON.parse(sessionStorage.getItem(TAB_KEY) || '[]');
        activeTabs.push({
          id: TAB_ID,
          timestamp: Date.now()
        });
        // Keep only recent tabs (within last 5 minutes)
        const now = Date.now();
        const recentTabs = activeTabs.filter(tab => now - tab.timestamp < 5 * 60 * 1000);
        sessionStorage.setItem(TAB_KEY, JSON.stringify(recentTabs));

        // Check if there are other tabs
        isFirstTab = recentTabs.length === 1;

        // Broadcast tab registration
        broadcastChannel.postMessage({
          type: 'tab_registered',
          tabId: TAB_ID
        });
      } catch (e) {
        console.error('Error registering tab:', e);
      }

      // Set up message handler (will be cleaned up once we determine first tab status)
      const messageHandler = function(event) {
        if (event.data.type === 'tab_registered') {
          // Another tab registered - this is not the first tab
          isFirstTab = false;
          cleanup(); // Clean up immediately if not first tab
        } else if (event.data.type === 'request_tab_count') {
          // Respond with current tab count
          try {
            const activeTabs = JSON.parse(sessionStorage.getItem(TAB_KEY) || '[]');
            broadcastChannel.postMessage({
              type: 'tab_count_response',
              count: activeTabs.length
            });
          } catch (e) {
            console.error('Error getting tab count:', e);
          }
        }
      };

      broadcastChannel.onmessage = messageHandler;

      // Store cleanup function for message handler
      cleanupFunctions.push(function() {
        if (broadcastChannel && broadcastChannel.onmessage === messageHandler) {
          broadcastChannel.onmessage = null;
        }
      });

      // Request tab count from other tabs
      broadcastChannel.postMessage({
        type: 'request_tab_count'
      });

      // Wait a bit to see if other tabs respond (reduced timeout for faster detection)
      tabCheckTimeout = setTimeout(function() {
        tabCheckTimeout = null;
        try {
          const activeTabs = JSON.parse(sessionStorage.getItem(TAB_KEY) || '[]');
          isFirstTab = activeTabs.length === 1;

          if (!isFirstTab) {
            cleanup(); // Clean up immediately
            return;
          }

          // Clean up BroadcastChannel listener as we've determined first tab status
          if (broadcastChannel && broadcastChannel.onmessage === messageHandler) {
            broadcastChannel.onmessage = null;
          }

          // Continue with first tab logic
          proceedWithFirstTabLogic();
        } catch (e) {
          console.error('Error checking tab count:', e);
          proceedWithFirstTabLogic();
        }
      }, 300); // Reduced from 500ms to 300ms for faster detection
    } else {
      // Fallback: Use simpler logic if BroadcastChannel is not supported
      proceedWithFirstTabLogic();
    }

    function proceedWithFirstTabLogic() {

      // Check last activity time
      function getLastActivityTime() {
        const lastActivity = safeSessionGet(INACTIVITY_KEY);
        return lastActivity ? parseInt(lastActivity, 10) : null;
      }

      function updateActivityTime() {
        safeSessionSet(INACTIVITY_KEY, Date.now().toString());
      }

      // Check if user was inactive for 30+ minutes
      const lastActivity = getLastActivityTime();
      const now = Date.now();

      // Fire event if:
      // 1. First visit (no last activity recorded), OR
      // 2. User was inactive for 30+ minutes
      if (!lastActivity) {
        // First visit or no previous activity - fire event immediately
        trackStoreStart();
        safeSessionSet(EVENT_FIRED_KEY, 'true');
        window[inMemoryEventKey] = true;
        updateActivityTime();
        // Event fired, no need to set up inactivity tracking - exit early
        return;
      } else if ((now - lastActivity) >= INACTIVITY_THRESHOLD) {
        // User was inactive for 30+ minutes - fire event
        trackStoreStart();
        safeSessionSet(EVENT_FIRED_KEY, 'true');
        window[inMemoryEventKey] = true;
        updateActivityTime();
        // Event fired, no need to set up inactivity tracking - exit early
        return;
      }

      // User was active recently - update activity time and set up inactivity tracking
      updateActivityTime();

      // Track user activity to reset inactivity timer
      // Separate frequent events (mousemove) from less frequent ones for throttling
      const frequentEvents = ['mousemove'];
      const activityEvents = ['mousedown', 'keypress', 'scroll', 'touchstart', 'click'];
      let inactivityTimer = null;
      let lastThrottledCall = 0;
      const THROTTLE_DELAY = 1000; // Throttle mousemove to once per second

      function resetInactivityTimer() {
        // Clear existing timer
        if (inactivityTimer) {
          clearTimeout(inactivityTimer);
          inactivityTimer = null;
        }

        // Update activity time
        updateActivityTime();

        // Check if event already fired - early exit
        if (safeSessionGet(EVENT_FIRED_KEY) === 'true') {
          return;
        }

        // Set new timer for 30 minutes
        inactivityTimer = setTimeout(function() {
          inactivityTimer = null;
          // Check if event was already fired
          if (safeSessionGet(EVENT_FIRED_KEY) !== 'true') {
            // Check if still first tab (only if BroadcastChannel is available)
            if (broadcastChannel) {
              try {
                const activeTabs = JSON.parse(sessionStorage.getItem(TAB_KEY) || '[]');
                const currentTabs = activeTabs.filter(tab => Date.now() - tab.timestamp < 5 * 60 * 1000);
                if (currentTabs.length === 1) {
                  trackStoreStart();
                  safeSessionSet(EVENT_FIRED_KEY, 'true');
                  window[inMemoryEventKey] = true;
                  removeActivityListeners(); // Clean up listeners once event fires
                }
              } catch (e) {
                console.error('Error checking tab count:', e);
              }
            } else {
              // Fallback: fire event if BroadcastChannel not available
              trackStoreStart();
              safeSessionSet(EVENT_FIRED_KEY, 'true');
              window[inMemoryEventKey] = true;
              removeActivityListeners(); // Clean up listeners once event fires
            }
          }
        }, INACTIVITY_THRESHOLD);
      }

      // Throttled version for frequent events
      function throttledResetInactivityTimer() {
        const now = Date.now();
        if (now - lastThrottledCall >= THROTTLE_DELAY) {
          lastThrottledCall = now;
          resetInactivityTimer();
        }
      }

      // Store event handlers for cleanup
      const eventHandlers = [];

      // Set up activity listeners with throttling for frequent events
      frequentEvents.forEach(function(eventType) {
        const handler = throttledResetInactivityTimer;
        document.addEventListener(eventType, handler, { passive: true });
        eventHandlers.push({ type: eventType, handler: handler });
      });

      activityEvents.forEach(function(eventType) {
        const handler = resetInactivityTimer;
        document.addEventListener(eventType, handler, { passive: true });
        eventHandlers.push({ type: eventType, handler: handler });
      });

      // Function to remove all activity listeners
      function removeActivityListeners() {
        eventHandlers.forEach(function(item) {
          try {
            document.removeEventListener(item.type, item.handler);
          } catch (e) {
            console.error('Error removing event listener:', e);
          }
        });
        eventHandlers.length = 0; // Clear array
        if (inactivityTimer) {
          clearTimeout(inactivityTimer);
          inactivityTimer = null;
        }
      }

      // Store cleanup function
      cleanupFunctions.push(removeActivityListeners);

      // Initialize inactivity timer
      resetInactivityTimer();

      // Clean up on page unload
      const unloadHandler = function() {
        if (inactivityTimer) {
          clearTimeout(inactivityTimer);
          inactivityTimer = null;
        }

        // Remove this tab from active tabs
        try {
          const activeTabs = JSON.parse(sessionStorage.getItem(TAB_KEY) || '[]');
          const updatedTabs = activeTabs.filter(tab => tab.id !== TAB_ID);
          sessionStorage.setItem(TAB_KEY, JSON.stringify(updatedTabs));
        } catch (e) {
          console.error('Error removing tab:', e);
        }

        cleanup(); // Use centralized cleanup
      };

      window.addEventListener('beforeunload', unloadHandler);
      cleanupFunctions.push(function() {
        window.removeEventListener('beforeunload', unloadHandler);
      });
    }
  }

  // Initialize add to bag tracking
  attachAddToBagTracking();

  // Initialize buy now click tracking
  attachBuyNowClickTracking();
  
  // Initialize sort by applied tracking
  attachSortByAppliedTracking();

  // Initialize cart page view tracking
  attachCartPageViewTracking();
  
  // Initialize product items view tracking after DOM load
  runAfterDomLoad(attachProductItemsViewTracking);

  function getKidsCouponStripItem(element) {
    if (!element || !element.closest) return null;
    return element.closest('[data-gtm-kids-coupon-strip="true"][data-coupon-item]');
  }

  function getKidsCouponStripPayload(item) {
    if (!item) return null;
    const couponCode = (item.getAttribute('data-gtm-coupon-code') || '').trim();
    const couponType = (item.getAttribute('data-gtm-coupon-type') || '').trim();
    return {
      coupon_code: couponCode || null,
      coupon_type: couponType || null,
    };
  }

  function pushKidsCouponStripEvents(gaEventName, moeEventName, item) {
    const couponPayload = getKidsCouponStripPayload(item);
    if (!couponPayload) return;

    const pageContext =
      typeof getPageContext === 'function' ? getPageContext() : { pageName: null };

    const eventData = buildBaseGtmEventData(
      gaEventName,
      {
        coupon_type: couponPayload.coupon_type,
        coupon_code: couponPayload.coupon_code,
      },
      { pageName: pageContext.pageName || null }
    );

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    } catch (e) {
      console.error('Error pushing ' + gaEventName + ':', e);
    }

    try {
      if (typeof buildBaseMoeEventData === 'function') {
        const moeEventData = buildBaseMoeEventData(
          moeEventName,
          {
            coupon_type: couponPayload.coupon_type,
            coupon_code: couponPayload.coupon_code,
            page_name: pageContext.pageName || null,
          },
          { pageUrl: window.location.href }
        );
        window.dataLayer.push(moeEventData);
      }
    } catch (e) {
      console.error('Error pushing ' + moeEventName + ':', e);
    }
  }

  function trackKidsCouponsStripViewed(item) {
    pushKidsCouponStripEvents(
      'ga_pwst_coupons_strip_viewed',
      'moe_pwst_coupons_strip_viewed',
      item
    );
  }

  function trackKidsCouponsStripClicked(item) {
    const now = Date.now();
    window.__PW_COUPON_STRIP_CLICK_LAST__ = window.__PW_COUPON_STRIP_CLICK_LAST__ || { item: null, ts: 0 };
    if (
      window.__PW_COUPON_STRIP_CLICK_LAST__.item === item &&
      now - window.__PW_COUPON_STRIP_CLICK_LAST__.ts < 600
    ) {
      return;
    }
    window.__PW_COUPON_STRIP_CLICK_LAST__ = { item: item, ts: now };

    pushKidsCouponStripEvents(
      'ga_pwst_coupons_strip_clicked',
      'moe_pwst_coupons_strip_clicked',
      item
    );
  }

  function observeKidsCouponStripViews() {
    const items = document.querySelectorAll('[data-gtm-kids-coupon-strip="true"][data-coupon-item]');
    if (!items.length) return;

    window.__PW_COUPON_STRIP_VIEWED_ITEMS__ =
      window.__PW_COUPON_STRIP_VIEWED_ITEMS__ || new WeakSet();

    if (typeof IntersectionObserver === 'undefined') {
      items.forEach(function (item) {
        if (window.__PW_COUPON_STRIP_VIEWED_ITEMS__.has(item)) return;
        window.__PW_COUPON_STRIP_VIEWED_ITEMS__.add(item);
        trackKidsCouponsStripViewed(item);
      });
      return;
    }

    if (!window.__PW_COUPON_STRIP_VIEW_OBSERVER__) {
      window.__PW_COUPON_STRIP_VIEW_OBSERVER__ = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.4) return;
            const item = entry.target;
            if (window.__PW_COUPON_STRIP_VIEWED_ITEMS__.has(item)) {
              observer.unobserve(item);
              return;
            }
            window.__PW_COUPON_STRIP_VIEWED_ITEMS__.add(item);
            observer.unobserve(item);
            trackKidsCouponsStripViewed(item);
          });
        },
        { threshold: [0.4], root: null, rootMargin: '0px' }
      );
    }

    items.forEach(function (item) {
      if (item.__pwCouponStripObserved) return;
      item.__pwCouponStripObserved = true;
      window.__PW_COUPON_STRIP_VIEW_OBSERVER__.observe(item);
    });
  }

  function attachKidsCouponsStripTracking() {
    if (window.__PW_COUPON_STRIP_TRACKING_BOUND__) {
      observeKidsCouponStripViews();
      return;
    }
    window.__PW_COUPON_STRIP_TRACKING_BOUND__ = true;

    document.addEventListener(
      'click',
      function (event) {
        if (!(event.target instanceof Element)) return;
        if (event.target.closest('[data-coupon-prev], [data-coupon-next], [data-coupon-dot]')) return;
        const item = getKidsCouponStripItem(event.target);
        if (!item) return;
        trackKidsCouponsStripClicked(item);
      },
      true
    );

    document.addEventListener('shopify:section:load', function () {
      observeKidsCouponStripViews();
    });

    observeKidsCouponStripViews();
  }

  attachKidsCouponsStripTracking();

  function getKidsTabbedCarouselRoot(element) {
    if (!element || !element.closest) return null;
    return element.closest('[data-gtm-kids-tabbed-carousel="true"]');
  }

  function getKidsTabbedCarouselProductItem(element) {
    if (!element || !element.closest) return null;
    const carousel = getKidsTabbedCarouselRoot(element);
    if (!carousel) return null;
    return (
      element.closest('.swiper-slide[data-product-id]') ||
      element.closest('product-card[data-product-id]')
    );
  }

  function getKidsTabbedCarouselProductCard(item) {
    if (!item) return null;
    if (item.matches && item.matches('product-card[data-product-id], .product-card[data-product-id]')) {
      return item;
    }
    return item.querySelector('product-card[data-product-id], .product-card[data-product-id]') || item;
  }

  function getKidsTabbedCarouselTabName(carousel) {
    if (!carousel) return null;
    const fromAttr = (carousel.getAttribute('data-gtm-tab-name') || '').trim();
    if (fromAttr) return fromAttr;
    const activeTab =
      carousel.querySelector('[data-tab][aria-selected="true"]') ||
      carousel.querySelector('[data-tab].is-active');
    if (!activeTab) return null;
    return (
      (activeTab.getAttribute('data-tab-name') || '').trim() ||
      (activeTab.textContent || '').trim() ||
      null
    );
  }

  function getKidsTabbedCarouselWidgetName(carousel) {
    if (!carousel) return null;
    const fromAttr = (carousel.getAttribute('data-gtm-widget-name') || '').trim();
    if (fromAttr) return fromAttr;
    const title = carousel.querySelector('.tabbed-collection__title');
    const fromTitle = title && title.textContent ? title.textContent.trim() : '';
    return fromTitle || null;
  }

  function getKidsTabbedCarouselProductPosition(item, carousel) {
    const slide = item && item.closest ? item.closest('.swiper-slide[data-product-id]') : item;
    const fromAttr =
      (slide && slide.getAttribute && slide.getAttribute('data-product-position')) ||
      (item && item.getAttribute && item.getAttribute('data-product-position'));
    if (fromAttr) {
      const parsed = Number(fromAttr);
      if (Number.isFinite(parsed)) return parsed;
    }
    if (!carousel) return null;
    const slides = Array.from(carousel.querySelectorAll('.swiper-slide[data-product-id]'));
    const index = slides.indexOf(slide);
    return index >= 0 ? index + 1 : null;
  }

  function getKidsTabbedCarouselPayload(item) {
    if (!item) return null;
    const carousel = getKidsTabbedCarouselRoot(item);
    if (!carousel) return null;
    const card = getKidsTabbedCarouselProductCard(item);
    if (!card) return null;

    const productId = card.getAttribute('data-product-id') || item.getAttribute('data-product-id');
    if (!productId) return null;

    const priceRaw = card.getAttribute('data-product-price');
    const compareAtRaw = card.getAttribute('data-product-compare-at-price');
    const pricesInCents = card.getAttribute('data-gtm-price-unit') !== 'rupees';
    const priceRupees =
      typeof normalizeGtmProductPrice === 'function'
        ? normalizeGtmProductPrice(priceRaw ? parseFloat(priceRaw) : 0, pricesInCents) ?? 0
        : priceRaw
          ? parseFloat(priceRaw)
          : 0;
    const compareAtRupees =
      typeof normalizeGtmProductPrice === 'function'
        ? normalizeGtmProductPrice(compareAtRaw ? parseFloat(compareAtRaw) : 0, pricesInCents) ?? 0
        : compareAtRaw
          ? parseFloat(compareAtRaw)
          : 0;
    const productPrice = compareAtRupees > 0 ? compareAtRupees : priceRupees;
    const productDiscountedPrice = priceRupees;
    const productDiscountPrice =
      compareAtRupees > 0 && compareAtRupees > priceRupees ? compareAtRupees - priceRupees : null;

    const discountRaw = card.getAttribute('data-product-discount-percent');
    const discountPercent = discountRaw != null && discountRaw !== '' ? Number(discountRaw) : null;
    const inventoryRaw = card.getAttribute('data-product-inventory-quantity');
    const productAvailableQuantity =
      typeof window.parseProductAvailableQuantity === 'function'
        ? window.parseProductAvailableQuantity(inventoryRaw)
        : inventoryRaw != null && inventoryRaw !== ''
          ? parseInt(inventoryRaw, 10)
          : null;

    const widgetPosition =
      typeof resolvePageWidgetPosition === 'function'
        ? resolvePageWidgetPosition(carousel, carousel)
        : null;

    return {
      tab_name: getKidsTabbedCarouselTabName(carousel),
      widget_name: getKidsTabbedCarouselWidgetName(carousel),
      widget_position: widgetPosition,
      product_position_inside_widget: getKidsTabbedCarouselProductPosition(item, carousel),
      product_id: productId,
      product_title:
        (card.getAttribute('data-product-title') || '').trim() ||
        (card.querySelector('h3, .main-title-container p') &&
          card.querySelector('h3, .main-title-container p').textContent.trim()) ||
        null,
      product_slug: card.getAttribute('data-product-handle') || null,
      product_moq: 50,
      product_discount_percent: Number.isFinite(discountPercent) ? discountPercent : null,
      product_in_stock: productAvailableQuantity ?? null,
      product_price: productPrice || null,
      product_discount_price: productDiscountPrice,
      product_discounted_price: productDiscountedPrice || null,
      product_tag:
        card.getAttribute('data-product-tag') ||
        card.getAttribute('data-product-tags') ||
        null,
      preorder: card.getAttribute('data-preorder') || 'no',
      product_available_quantity: productAvailableQuantity,
      product_category_id: card.getAttribute('data-product-category-id') || null,
      product_sub_category_id: card.getAttribute('data-product-sub-category-id') || null,
      product_category_slug: card.getAttribute('data-product-category-slug') || null,
      product_variant_id: card.getAttribute('data-product-variant-id') || null,
    };
  }

  function pushKidsTabbedCarouselEvents(gaEventName, moeEventName, item) {
    const payload = getKidsTabbedCarouselPayload(item);
    if (!payload) return;

    const pageContext =
      typeof getPageContext === 'function' ? getPageContext() : { pageName: null };

    const eventData = buildBaseGtmEventData(gaEventName, payload, {
      pageName: pageContext.pageName || null,
    });
    if (eventData.page_widget_position != null && eventData.widget_position == null) {
      eventData.widget_position = eventData.page_widget_position;
    } else if (payload.widget_position != null) {
      eventData.widget_position = payload.widget_position;
    }

    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(eventData);
    } catch (e) {
      console.error('Error pushing ' + gaEventName + ':', e);
    }

    try {
      if (typeof buildBaseMoeEventData === 'function') {
        const moeEventData = buildBaseMoeEventData(
          moeEventName,
          Object.assign({}, payload, { page_name: pageContext.pageName || null }),
          { pageUrl: window.location.href }
        );
        window.dataLayer.push(moeEventData);
      }
    } catch (e) {
      console.error('Error pushing ' + moeEventName + ':', e);
    }
  }

  function trackKidsTabbedCarouselViewed(item) {
    pushKidsTabbedCarouselEvents(
      'ga_pwst_tabbed_product_carousel_viewed',
      'moe_pwst_tabbed_product_carousel_viewed',
      item
    );
  }

  function trackKidsTabbedCarouselItemClicked(item) {
    const now = Date.now();
    window.__PW_TABBED_CAROUSEL_CLICK_LAST__ = window.__PW_TABBED_CAROUSEL_CLICK_LAST__ || {
      item: null,
      ts: 0,
    };
    if (
      window.__PW_TABBED_CAROUSEL_CLICK_LAST__.item === item &&
      now - window.__PW_TABBED_CAROUSEL_CLICK_LAST__.ts < 600
    ) {
      return;
    }
    window.__PW_TABBED_CAROUSEL_CLICK_LAST__ = { item: item, ts: now };

    pushKidsTabbedCarouselEvents(
      'ga_pwst_tabbed_product_carousel_item_clicked',
      'moe_pwst_tabbed_product_carousel_item_clicked',
      item
    );
  }

  function observeKidsTabbedCarouselViews() {
    const items = document.querySelectorAll(
      '[data-gtm-kids-tabbed-carousel="true"] .swiper-slide[data-product-id]'
    );
    if (!items.length) return;

    window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__ =
      window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__ || new WeakSet();

    if (typeof IntersectionObserver === 'undefined') {
      items.forEach(function (item) {
        if (window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__.has(item)) return;
        window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__.add(item);
        trackKidsTabbedCarouselViewed(item);
      });
      return;
    }

    if (!window.__PW_TABBED_CAROUSEL_VIEW_OBSERVER__) {
      window.__PW_TABBED_CAROUSEL_VIEW_OBSERVER__ = new IntersectionObserver(
        function (entries, observer) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || entry.intersectionRatio < 0.4) return;
            const item = entry.target;
            if (window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__.has(item)) {
              observer.unobserve(item);
              return;
            }
            window.__PW_TABBED_CAROUSEL_VIEWED_ITEMS__.add(item);
            observer.unobserve(item);
            trackKidsTabbedCarouselViewed(item);
          });
        },
        { threshold: [0.4], root: null, rootMargin: '0px' }
      );
    }

    items.forEach(function (item) {
      if (item.__pwTabbedCarouselObserved) return;
      item.__pwTabbedCarouselObserved = true;
      window.__PW_TABBED_CAROUSEL_VIEW_OBSERVER__.observe(item);
    });
  }

  function observeKidsTabbedCarouselDom() {
    document.querySelectorAll('[data-gtm-kids-tabbed-carousel="true"] [data-product-grid]').forEach(function (grid) {
      if (grid.__pwTabbedCarouselMo) return;
      grid.__pwTabbedCarouselMo = true;
      const mo = new MutationObserver(function () {
        observeKidsTabbedCarouselViews();
      });
      mo.observe(grid, { childList: true });
    });
  }

  function attachKidsTabbedCarouselTracking() {
    if (window.__PW_TABBED_CAROUSEL_TRACKING_BOUND__) {
      observeKidsTabbedCarouselViews();
      return;
    }
    window.__PW_TABBED_CAROUSEL_TRACKING_BOUND__ = true;

    document.addEventListener(
      'click',
      function (event) {
        if (!(event.target instanceof Element)) return;
        if (
          event.target.closest(
            '[data-tab], [data-tab-prev], [data-tab-next], [data-product-prev], [data-product-next]'
          )
        ) {
          return;
        }
        const item = getKidsTabbedCarouselProductItem(event.target);
        if (!item) return;
        trackKidsTabbedCarouselItemClicked(item);
      },
      true
    );

    document.addEventListener('tabbed-collection:products-ready', function () {
      observeKidsTabbedCarouselDom();
      observeKidsTabbedCarouselViews();
    });

    document.addEventListener('shopify:section:load', function () {
      observeKidsTabbedCarouselDom();
      observeKidsTabbedCarouselViews();
    });

    observeKidsTabbedCarouselDom();
    observeKidsTabbedCarouselViews();
  }

  attachKidsTabbedCarouselTracking();

  var COUPON_MESSAGE_ACTIONS = {
    coupon_code_applied_sc: 'apply',
    remove_applied_offer_sc: 'remove',
    view_offers_clicked_sc: 'view'
  };
  function trackCouponEvent(action, payload) {
    if (!action) return;
    var customerData = window.__CUSTOMER_DATA__ || {};
    var gtmConfig = window.__GTM_CONFIG__ || {};
    var loginData = window.__LOGIN_DATA__ || {};
    var userData = {
      user_id: customerData.customerId || null,
      pw_user_id: customerData.pw_user_id || null,
      cohort_id: customerData.cohort_id || null,
      cohort_name: customerData.cohort_name || null,
    };
    var pageUrl = window.location.href;
    var body = payload && payload.body !== undefined ? payload.body : (payload || {});
    var ctaName = body.cta_name || (action === 'apply' ? 'apply' : action === 'remove' ? 'remove' : action === 'view' ? 'copy' : null);
    var cartId = body.cart_id || payload.cart_id || null;
    if (!cartId) cartId = window.__PW_CART_ID__ || null;
    
    var eventPageName = null;
    let cartShadow = document.querySelector('shadow-dom-container')
    let isCartOpen = cartShadow?.shadowRoot?.querySelector('.sidecart');
    if (isCartOpen) {
      eventPageName = 'Cart';
    } else if (typeof getPageContext === 'function') {
      var pageContext = getPageContext();
    
      eventPageName =
        pageContext && pageContext.pageName != null
          ? pageContext.pageName
          : null;
    }
    var eventData = {
      event: 'ga_pwst_coupon_actions_taken',
      action: action,
      platform: gtmConfig.platform || 'web',
      organisation_name: gtmConfig.organisation_name || 'pw',
      page_url: pageUrl,
      is_logged_in: loginData.is_logged_in || false,
      user_id: (window.__CUSTOMER_DATA__ || {}).customerId ?? null,
      pw_user_id: userData.pw_user_id,
      page_name: eventPageName,
      cohort_id: userData.cohort_id,
      cohort_name: userData.cohort_name,
      business_unit: gtmConfig.business_unit || 'pw_store',
      cart_id: cartId,
      coupon_type: body.type || payload.type || null,
      coupon_code: (body.title || payload.title || null)?.toUpperCase && (body.title || payload.title || null) ? (body.title || payload.title).toUpperCase() : null,
      coupon_discount_value: body.value != null ? body.value : (payload.value != null ? payload.value : null),
      cta_name: body.cta_name || payload.cta_name || ctaName,
      timestamp: new Date().toISOString()
    };
    dataLayer.push(eventData);

    // Keep latest coupon interaction state for cart-related events (e.g., cart page view).
    var latestCouponCode = eventData.coupon_code || null;
    var latestCouponType = eventData.coupon_type || null;
    if (action === 'remove') {
      latestCouponCode = null;
      latestCouponType = null;
    }
    window.__PW_LATEST_COUPON_STATE__ = {
      action: action,
      coupon_code: latestCouponCode,
      coupon_type: latestCouponType,
      coupon_discount_value: eventData.coupon_discount_value != null ? Number(eventData.coupon_discount_value) : null,
      updated_at: Date.now()
    };

    if (action === 'apply') {
      (async function () {
        try {
          const domCartData = await getCartAndProductsFromCartItems();
          const cart = domCartData?.cart || null;
          const productDataArray = Array.isArray(domCartData?.products) ? domCartData.products : [];
          const productIds = productDataArray.map(p => p.product_id).filter(Boolean);

          const moeEventData = buildBaseMoeEventData(
            'moe_pwst_coupon_applied',
            {
              client_type: 'pw_store',
              device_id: body.device_id || payload.device_id || null,
            },
            { pageUrl: pageUrl }
          );

          const couponAppliedMoeData = {
            ...moeEventData,
            amount: cart?.payable_amount ?? cart?.total_price ?? null,
            coupon_code: eventData.coupon_code || null,
            coupon_discount_value: eventData.coupon_discount_value != null ? Number(eventData.coupon_discount_value) : null,
            shipping: cart?.shipping_amount ?? null,
            product_ids: productIds.length > 0 ? productIds : null,
            timestamp: new Date().toISOString(),
          };

          productDataArray.slice(0, 10).forEach((p, i) => {
            const n = i + 1;
            couponAppliedMoeData[`product_${n}_id`] = p.product_id || null;
            couponAppliedMoeData[`product_${n}_variant`] = p.product_variant_id || null;
            couponAppliedMoeData[`product_${n}_title`] = p.product_title || null;
            couponAppliedMoeData[`product_${n}_img_url`] = p.product_img_url || null;
            couponAppliedMoeData[`product_${n}_slug`] = p.product_slug || null;
            couponAppliedMoeData[`product_${n}_tag`] = p.product_tag || null;
            couponAppliedMoeData[`product_${n}_moq`] = 50;
            couponAppliedMoeData[`product_${n}_in_stock`] = p.product_in_stock;
            couponAppliedMoeData[`product_${n}_available_quantity`] = p.product_available_quantity ?? null;
            couponAppliedMoeData[`product_${n}_price`] = p.product_price ?? null;
            couponAppliedMoeData[`product_${n}_discounted_price`] = p.product_discounted_price ?? null;
            couponAppliedMoeData[`product_${n}_discount_price`] = p.product_discount_price ?? null;
            couponAppliedMoeData[`product_${n}_discount_percent`] = p.product_discount_percent ?? null;
            couponAppliedMoeData[`product_${n}_category_name`] = p.l1_category_name || null;
          });

          dataLayer.push(couponAppliedMoeData);
        } catch (err) {
          console.error('Error tracking moe_pwst_coupon_applied:', err);
        }
      })();
    }

    // Separate event for "View all offers" with same payload except coupon_discount_value and cta_name
    if (action === 'view') {
      var viewAllEventData = {
        ...eventData,
        event: 'ga_pwst_coupons_view_all_cta_clicked'
      };
      delete viewAllEventData.coupon_discount_value;
      delete viewAllEventData.cta_name;
      dataLayer.push(viewAllEventData);

      var moeViewAllCouponsEvent = buildBaseMoeEventData(
        'moe_pwst_view_all_coupons',
        {
          amount: null,
          coupon_list: null,
          coupon_present: null,
          screen_name: eventPageName,
          shipping: null,
        },
        {
          pageUrl: pageUrl,
        }
      );

      dataLayer.push(moeViewAllCouponsEvent);
    }
  }

  function attachCouponMessageListener() {
    window.addEventListener('message', function(e) {
      if (!e || !e.data || typeof e.data.name !== 'string') return;
      var action = COUPON_MESSAGE_ACTIONS[e.data.name];
      if (action) {
        trackCouponEvent(action, e.data.body || e.data);
      }
    });
  }

  function getCouponStateForCartEvent(cartCouponArray, cartCouponType, cartCouponPresent, cartCouponDiscount) {
    const latestCoupon = window.__PW_LATEST_COUPON_STATE__ || null;
    const hasLatestCoupon = !!(latestCoupon && latestCoupon.coupon_code);
    const fallbackArray = Array.isArray(cartCouponArray) && cartCouponArray.length > 0 ? cartCouponArray : null;
    const parsedLatestDiscount = latestCoupon && latestCoupon.coupon_discount_value != null
      ? Number(latestCoupon.coupon_discount_value)
      : null;
    const safeLatestDiscount = Number.isFinite(parsedLatestDiscount) ? Math.max(0, parsedLatestDiscount) : null;
    const parsedCartDiscount = cartCouponDiscount != null ? Number(cartCouponDiscount) : null;
    const safeCartDiscount = Number.isFinite(parsedCartDiscount) ? Math.max(0, parsedCartDiscount) : null;

    if (hasLatestCoupon) {
      return {
        coupon_type: latestCoupon.coupon_type || cartCouponType || null,
        coupon_present: true,
        coupon_array: [latestCoupon.coupon_code],
        coupon_discount: safeLatestDiscount != null ? safeLatestDiscount : safeCartDiscount
      };
    }

    return {
      coupon_type: cartCouponType || null,
      coupon_present: !!cartCouponPresent,
      coupon_array: fallbackArray,
      coupon_discount: safeCartDiscount
    };
  }

  async function fetchCouponStateFromCartJs() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return null;
      const cart = await response.json();
      const codes = [];

      if (Array.isArray(cart.discount_codes)) {
        cart.discount_codes.forEach(function (discount) {
          const code = discount && discount.code != null ? String(discount.code).trim() : '';
          if (code) codes.push(code);
        });
      }

      let couponType = null;
      if (Array.isArray(cart.cart_level_discount_applications)) {
        cart.cart_level_discount_applications.forEach(function (app) {
          if (!app) return;
          if (app.type === 'discount_code' && app.title) {
            const title = String(app.title).trim();
            if (title && codes.indexOf(title) === -1) codes.push(title);
          }
          if (app.value_type === 'percentage') {
            couponType = 'PERCENTAGE_OFF';
          } else if (app.value_type === 'fixed_amount' && couponType !== 'PERCENTAGE_OFF') {
            couponType = 'FLATOFF';
          }
        });
      }

      const totalDiscount = shopifyCentsToRupees(cart.total_discount);
      return {
        coupon_present: codes.length > 0 || (totalDiscount != null && totalDiscount > 0),
        coupon_array: codes.length > 0 ? codes : null,
        coupon_type: couponType,
        coupon_discount: totalDiscount != null ? Math.max(0, totalDiscount) : null,
      };
    } catch (err) {
      console.error('Error fetching coupon state from cart.js:', err);
      return null;
    }
  }

  function parseOrderItemIds(rawOrderItemIds) {
    if (rawOrderItemIds == null) return [];
    if (Array.isArray(rawOrderItemIds)) return rawOrderItemIds;
    return String(rawOrderItemIds)
      .split(',')
      .map(function (id) { return id.trim(); })
      .filter(function (id) { return id !== ''; });
  }

  function trackOrderClick(button) {
    if (!button) return;
    try {
      var orderId = button.getAttribute('data-order-id') || null;
      var totalAmountRaw = button.getAttribute('data-total-amount');
      var orderItemIds = parseOrderItemIds(button.getAttribute('data-order-item-id'));
      var parsedAmount = totalAmountRaw !== null && totalAmountRaw !== '' ? Number(totalAmountRaw) : null;
      var totalAmount = Number.isNaN(parsedAmount) ? null : parsedAmount;

      var eventData = null;
      if (typeof buildBaseGtmEventData === 'function') {
        eventData = buildBaseGtmEventData(
          'ga_pwst_track_order_clicked',
          {
            order_id: orderId,
            total_amount: totalAmount,
            order_item_id: orderItemIds
          },
          {
            pageName: 'order_details'
          }
        );
        delete eventData.page_subtype;
      } else {
        var gtmConfig = window.__GTM_CONFIG__ || {};
        var loginData = window.__LOGIN_DATA__ || {};
        var customerData = window.__CUSTOMER_DATA__ || {};

        eventData = {
          event: 'ga_pwst_track_order_clicked',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          page_url: window.location.href,
          page_name: 'Order',
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: customerData.pw_user_id || null,
          cohort_id: customerData.cohort_id || null,
          cohort_name: customerData.cohort_name || null,
          business_unit: gtmConfig.business_unit || 'pw_store',
          order_id: orderId,
          total_amount: totalAmount !== null ? Math.round(totalAmount) : null,
          order_item_id: orderItemIds,
          timestamp: new Date().toISOString()
        };
      }

      dataLayer.push(eventData);
    } catch (error) {
      console.error('Error tracking ga_pwst_track_order_clicked:', error);
    }
  }

  function attachTrackOrderClickTracking() {
    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;
      var trackBtn = event.target.closest('.order-detail__item-actions-btn-track-btn__track');
      if (!trackBtn) return;
      trackOrderClick(trackBtn);
    });
  }

  function trackExternalOrderPageIngress(link) {
    if (!link) return;
    try {
      const widgetName = link.getAttribute('data-widget-name') || null;
      const redirectionUrl = link.getAttribute('href') || null;
      const pageName =
        typeof getPageContext === 'function' ? getPageContext().pageName : 'Account';
      const additionalData = {
        widget_name: widgetName,
        redirection_url: redirectionUrl,
      };

      if (typeof buildBaseGtmEventData === 'function') {
        dataLayer.push(
          buildBaseGtmEventData('ga_pwst_external_order_page_ingress', additionalData, {
            pageName,
          })
        );
      }

      if (typeof buildBaseMoeEventData === 'function') {
        dataLayer.push(
          buildBaseMoeEventData('moe_pwst_external_order_page_ingress', additionalData)
        );
      }
    } catch (error) {
      console.error('Error tracking ga_pwst_external_order_page_ingress:', error);
    }
  }

  function attachExternalOrderPageIngressTracking() {
    document.addEventListener('click', function(event) {
      if (!(event.target instanceof Element)) return;
      const ingressLink = event.target.closest('a[data-external-order-ingress="true"][href]');
      if (!ingressLink) return;
      trackExternalOrderPageIngress(ingressLink);
    }, true);
  }

  // ============================================================================
  // Share Click Event (Product Title Share)
  // Event: ga_pwst_share_clicked
  // Notes:
  // - `blocks/product-title-share.liquid` uses inline `onclick="shareProduct()"`.
  // - We attach a delegated click handler to the share icon container.
  // ============================================================================
  function trackPwstShareClicked(additionalData) {
    try {
      additionalData = additionalData || {};
      var productData = typeof getProductData === 'function' ? getProductData() : {};
      var couponInfo = (typeof getCouponInfo === 'function') ? getCouponInfo() : { coupon_present: false };
      var userDataForCohort = (typeof getUserData === 'function') ? getUserData() : {};

      // Determine boolean is_in_stock from available quantity
      var qty = productData.product_available_quantity;
      var computedIsInStock = null;
      if (qty !== undefined && qty !== null) {
        var n = Number(qty);
        computedIsInStock = Number.isFinite(n) ? n > 0 : null;
      }
      if (computedIsInStock === null) computedIsInStock = !!productData.is_in_stock;

      var eventData = null;
      if (typeof buildBaseGtmEventData === 'function') {
        eventData = buildBaseGtmEventData(
          'ga_pwst_share_clicked',
          {
            page_name: additionalData.page_name || 'pdp',
            breadcrumb_path: getBreadcrumbPathArray(),
            social_channel_selected: additionalData.social_channel_selected || null,
            action_taken: additionalData.action_taken || null,
            redirected: additionalData.action_taken || null,
            redirection_url: additionalData.redirection_url || window.location.href,
            coupon_present:
              additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present,
            ...additionalData,
          },
          { pageName: 'pdp' }
        );

        eventData.cohort_name = userDataForCohort.cohort_name ?? (window.__CUSTOMER_DATA__ || {}).cohort_name ?? null;
      } else {
        var gtmConfig = window.__GTM_CONFIG__ || {};
        var loginData = window.__LOGIN_DATA__ || {};
        var customerData = window.__CUSTOMER_DATA__ || {};

        eventData = {
          event: 'ga_pwst_share_clicked',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          page_name: additionalData.page_name || 'pdp',
          breadcrumb_path: getBreadcrumbPathArray(),
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: userDataForCohort.pw_user_id || customerData.pw_user_id || null,
          cohort_id: userDataForCohort.cohort_id || customerData.cohort_id || null,
          cohort_name: userDataForCohort.cohort_name || customerData.cohort_name || null,
          timestamp: new Date().toISOString(),
          ...additionalData,
        };
      }

      // Ensure required payload fields for GA event
      eventData.coupon_present =
        additionalData.coupon_present !== undefined ? additionalData.coupon_present : couponInfo.coupon_present;

      eventData.social_channel_selected = additionalData.social_channel_selected || null;
      eventData.action_taken = additionalData.action_taken || null;
      eventData.redirection_url = additionalData.redirection_url || window.location.href;

      eventData.product_id = additionalData.product_id !== undefined ? additionalData.product_id : productData.product_id;
      eventData.product_title =
        additionalData.product_title !== undefined ? additionalData.product_title : productData.product_title;
      eventData.product_slug =
        additionalData.product_slug !== undefined ? additionalData.product_slug : productData.product_slug;
      eventData.product_moq =
        additionalData.product_moq !== undefined ? additionalData.product_moq : productData.product_moq;
      eventData.product_discount_percent =
        additionalData.product_discount_percent !== undefined
          ? additionalData.product_discount_percent
          : productData.product_discount_percent;
      eventData.is_in_stock =
        additionalData.is_in_stock !== undefined ? additionalData.is_in_stock : computedIsInStock;
      eventData.product_price =
        additionalData.product_price !== undefined ? additionalData.product_price : productData.product_price;
      eventData.product_discount_price =
        additionalData.product_discount_price !== undefined
          ? additionalData.product_discount_price
          : productData.product_discount_price;
      eventData.product_discounted_price =
        additionalData.product_discounted_price !== undefined
          ? additionalData.product_discounted_price
          : productData.product_discounted_price;
      eventData.product_tag =
        additionalData.product_tag !== undefined ? additionalData.product_tag : productData.product_tag;
      eventData.preorder = additionalData.preorder !== undefined ? additionalData.preorder : productData.preorder;
      eventData.product_available_quantity =
        additionalData.product_available_quantity !== undefined
          ? additionalData.product_available_quantity
          : productData.product_available_quantity;
      eventData.l1_category_name =
        additionalData.l1_category_name !== undefined ? additionalData.l1_category_name : productData.l1_category_name;
      eventData.l2_category_name =
        additionalData.l2_category_name !== undefined ? additionalData.l2_category_name : productData.l2_category_name;
      eventData.l3_category_name =
        additionalData.l3_category_name !== undefined ? additionalData.l3_category_name : productData.l3_category_name;
      eventData.product_variant_id =
        additionalData.product_variant_id !== undefined ? additionalData.product_variant_id : productData.product_variant_id;

      dataLayer.push(eventData);
    } catch (error) {
      console.error('Error tracking ga_pwst_share_clicked:', error);
    }
  }

  function attachPwstShareClickedTracking() {
    try {
      if (window.__PW_SHARE_CLICKED_ATTACHED__) return;
      window.__PW_SHARE_CLICKED_ATTACHED__ = true;

      var lastTs = 0;

      document.addEventListener(
        'click',
        function(event) {
          try {
            if (!(event.target instanceof Element)) return;

            // `blocks/product-title-share.liquid` -> `<div class="share-icon-container" ... aria-label="Share product">`
            var shareEl = event.target.closest('[aria-label="Share product"]');
            if (!shareEl) return;

            var now = Date.now();
            if (now - lastTs < 800) return; // simple dedupe for double clicks
            lastTs = now;

            var container = shareEl.closest('[data-product-title-share]');
            var productId = container ? container.getAttribute('data-product-id') : null;
            var variantId = container ? container.getAttribute('data-variant-id') : null;

            // Best-effort mapping:
            // - If Web Share API exists, we treat it as "redirected" (native share sheet).
            // - Otherwise, the fallback copies the product link.
            var action_taken = (navigator && navigator.share && typeof navigator.share === 'function') ? 'redirected' : 'copied_link';

            trackPwstShareClicked({
              social_channel_selected: null, // this component doesn't provide which channel was chosen
              action_taken: action_taken,
              redirection_url: window.location.href,
              product_id: productId || undefined,
              product_variant_id: variantId || undefined,
            });
          } catch (e) {}
        },
        true
      );
    } catch (error) {
      console.error('Error attaching ga_pwst_share_clicked tracking:', error);
    }
  }

  // ============================================================================
  // Dorans Back-in-Stock (Out of Stock) Notify Me Event
  // Event: ga_pwst_product_notify_me_submitted
  function combineNotifyMeFirstLastName(first, last) {
    first = first ? String(first).trim() : '';
    last = last ? String(last).trim() : '';
    var combined = (first + (first && last ? ' ' : '') + last).trim();
    return combined || null;
  }

  function getShopifyCustomerDisplayName() {
    var customerData = window.__CUSTOMER_DATA__ || {};
    var fromParts = combineNotifyMeFirstLastName(customerData.first_name, customerData.last_name);
    if (fromParts) return fromParts;
    if (customerData.customer_name) {
      var name = String(customerData.customer_name).trim();
      return name || null;
    }
    return null;
  }

  function findNotifyMeInputByLabel(root, labelText) {
    var target = String(labelText || '').trim().toLowerCase();
    if (!target || !root) return null;

    var labels = root.querySelectorAll('label');
    for (var i = 0; i < labels.length; i++) {
      var label = labels[i];
      var text = (label.textContent || '').trim().toLowerCase();
      if (text !== target && text.indexOf(target) !== 0) continue;

      var forId = label.getAttribute('for');
      if (forId) {
        try {
          var byId = root.querySelector('#' + CSS.escape(forId));
          if (byId) return byId;
        } catch (e) {
          var byIdFallback = document.getElementById(forId);
          if (byIdFallback) return byIdFallback;
        }
      }

      var container = label.parentElement;
      if (container) {
        var inContainer = container.querySelector('input.dr-input, input[type="text"], input:not([type])');
        if (inContainer) return inContainer;
      }
    }
    return null;
  }

  function getNotifyMeNameInputs(modalRoot) {
    var form =
      (modalRoot && modalRoot.querySelector && modalRoot.querySelector('form.dr-bis-form')) ||
      document.querySelector('form.dr-bis-form') ||
      modalRoot ||
      document;

    var firstInput =
      form.querySelector(
        'input[name="firstName"], input[name="first_name"], input[autocomplete="given-name"]'
      ) || findNotifyMeInputByLabel(form, 'first name');
    var lastInput =
      form.querySelector(
        'input[name="lastName"], input[name="last_name"], input[autocomplete="family-name"]'
      ) || findNotifyMeInputByLabel(form, 'last name');

    if (!firstInput || !lastInput) {
      var textInputs = Array.prototype.slice
        .call(form.querySelectorAll('input.dr-input, input[type="text"], input:not([type])'))
        .filter(function (inp) {
          var type = (inp.getAttribute('type') || 'text').toLowerCase();
          if (type === 'email' || type === 'tel' || type === 'phone' || type === 'checkbox' || type === 'hidden') {
            return false;
          }
          var ph = (inp.getAttribute('placeholder') || '').toLowerCase();
          if (ph.indexOf('email') !== -1 || ph.indexOf('phone') !== -1) return false;
          return true;
        });

      if (!firstInput) {
        firstInput =
          textInputs.find(function (inp) {
            var ph = (inp.getAttribute('placeholder') || '').toLowerCase();
            return ph.indexOf('first') !== -1;
          }) || textInputs[0] || null;
      }
      if (!lastInput) {
        lastInput =
          textInputs.find(function (inp) {
            var ph = (inp.getAttribute('placeholder') || '').toLowerCase();
            return ph.indexOf('last') !== -1;
          }) || null;
        if (lastInput === firstInput) {
          lastInput = textInputs.length > 1 ? textInputs[1] : null;
        }
      }
    }

    return { firstInput: firstInput, lastInput: lastInput };
  }

  function formatNotifyMePhoneNumber(phone) {
    if (phone == null || String(phone).trim() === '') return null;
    var digits = String(phone).replace(/\D/g, '');
    if (!digits) return null;
    return digits.length > 10 ? digits.slice(-10) : digits;
  }

  function getShopifyCustomerPhoneNumber() {
    var customerData = window.__CUSTOMER_DATA__ || {};
    var phone = customerData.phone_number;

    if (phone == null || String(phone).trim() === '') {
      try {
        var raw = window.sessionStorage.getItem('PW_CUSTOMER_DATA');
        if (raw) {
          var stored = JSON.parse(raw);
          phone = stored && stored.phone_number;
        }
      } catch (e) {}
    }

    return formatNotifyMePhoneNumber(phone);
  }

  function resolveNotifyMePhoneNumber(modalRoot) {
    var isLoggedIn = Boolean((window.__LOGIN_DATA__ || {}).is_logged_in);
    var customerPhone = getShopifyCustomerPhoneNumber();

    if (isLoggedIn && customerPhone) {
      return customerPhone;
    }

    var form =
      (modalRoot && modalRoot.querySelector && modalRoot.querySelector('form.dr-bis-form')) ||
      document.querySelector('form.dr-bis-form') ||
      modalRoot ||
      document;

    var phoneInput =
      form.querySelector(
        'input[name="phone"], input[name="phone_number"], input[type="tel"], input[autocomplete="tel"]'
      ) || findNotifyMeInputByLabel(form, 'phone');
    var fromForm = phoneInput && phoneInput.value ? String(phoneInput.value).trim() : null;
    if (fromForm) {
      var formattedFormPhone = formatNotifyMePhoneNumber(fromForm);
      if (formattedFormPhone) {
        return formattedFormPhone;
      }
    }

    return customerPhone;
  }

  function resolveNotifyMeEmail(modalRoot) {
    var form =
      (modalRoot && modalRoot.querySelector && modalRoot.querySelector('form.dr-bis-form')) ||
      document.querySelector('form.dr-bis-form') ||
      modalRoot ||
      document;

    var emailInput =
      form.querySelector('input[name="email"]') ||
      form.querySelector('input[type="email"]') ||
      form.querySelector('input[id*="email"]');
    var fromForm = emailInput && emailInput.value ? String(emailInput.value).trim() : null;
    if (fromForm) {
      return fromForm;
    }

    var customerData = window.__CUSTOMER_DATA__ || {};
    return customerData.email ? String(customerData.email).trim() : null;
  }

  function resolveNotifyMeFirstLastName(modalRoot) {
    var inputs = getNotifyMeNameInputs(modalRoot);
    var firstName = inputs.firstInput && inputs.firstInput.value ? String(inputs.firstInput.value).trim() : '';
    var lastName = inputs.lastInput && inputs.lastInput.value ? String(inputs.lastInput.value).trim() : '';
    var customerData = window.__CUSTOMER_DATA__ || {};
    var isLoggedIn = Boolean((window.__LOGIN_DATA__ || {}).is_logged_in);

    if (!firstName && isLoggedIn && customerData.first_name) {
      firstName = String(customerData.first_name).trim();
    }
    if (!lastName && isLoggedIn && customerData.last_name) {
      lastName = String(customerData.last_name).trim();
    }

    return {
      first_name: firstName || null,
      last_name: lastName || null,
    };
  }

  function resolveNotifyMeUserName(modalRoot) {
    var names = resolveNotifyMeFirstLastName(modalRoot);
    var formName = combineNotifyMeFirstLastName(names.first_name, names.last_name);
    var isLoggedIn = Boolean((window.__LOGIN_DATA__ || {}).is_logged_in);

    if (!isLoggedIn) {
      return formName;
    }

    if (formName) {
      return formName;
    }

    return getShopifyCustomerDisplayName();
  }

  function trackMoeBackInStockTest1(modalRoot, additionalData) {
    try {
      additionalData = additionalData || {};
      modalRoot = modalRoot || document;

      var names = resolveNotifyMeFirstLastName(modalRoot);
      var productData = typeof getProductData === 'function' ? getProductData() : {};
      var variantId =
        additionalData.product_variant_id !== undefined
          ? additionalData.product_variant_id
          : productData.product_variant_id !== undefined
            ? productData.product_variant_id
            : null;

      dataLayer.push({
        event: 'moe_pwst_notify_me_submitted',
          phone_number: resolveNotifyMePhoneNumber(modalRoot),
          email: resolveNotifyMeEmail(modalRoot),
          first_name: names.first_name,
          last_name: names.last_name,
          product_title: productData.product_title || null,
          product_img_url: productData.product_img_url || null,
          product_variant: variantId != null ? String(variantId) : null,
      });
    } catch (error) {
      console.error('Error tracking moe_back_in_stock_test1:', error);
    }
  }

  function trackPwstProductNotifyMeSubmitted(additionalData) {
    try {
      additionalData = additionalData || {};

      var productData = typeof getProductData === 'function' ? getProductData() : {};
      var userDataForCohort = typeof getUserData === 'function' ? getUserData() : {};

      var email_address = additionalData.email_address || null;
      var user_name =
        additionalData.user_name != null && String(additionalData.user_name).trim() !== ''
          ? String(additionalData.user_name).trim()
          : null;

      // Compute is_in_stock from inventory qty when available
      var computedIsInStock = null;
      var qty = productData.product_available_quantity;
      if (qty !== undefined && qty !== null) {
        var n = Number(qty);
        computedIsInStock = Number.isFinite(n) ? n > 0 : null;
      }
      if (computedIsInStock === null && productData.is_in_stock !== undefined) {
        // Some product helpers store a numeric quantity in is_in_stock; normalize best-effort.
        var n2 = Number(productData.is_in_stock);
        computedIsInStock = Number.isFinite(n2) ? n2 > 0 : null;
      }

      var eventData = null;
      if (typeof buildBaseGtmEventData === 'function') {
        eventData = buildBaseGtmEventData(
          'ga_pwst_product_notify_me_submitted',
          {
            page_name: 'Product',
            breadcrumb_path: getBreadcrumbPathArray(),
            email_address: email_address,
            user_name: user_name,
            cohort_name: userDataForCohort.cohort_name || null,
            ...additionalData,
          },
          { pageName: 'pdp' }
        );
      } else {
        // Fallback construction (should be rare if helpers are present)
        var gtmConfig = window.__GTM_CONFIG__ || {};
        var loginData = window.__LOGIN_DATA__ || {};
        var customerData = window.__CUSTOMER_DATA__ || {};

        eventData = {
          event: 'ga_pwst_product_notify_me_submitted',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          page_name: 'Product',
          breadcrumb_path: getBreadcrumbPathArray(),
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: userDataForCohort.pw_user_id || customerData.pw_user_id || null,
          cohort_id: userDataForCohort.cohort_id || customerData.cohort_id || null,
          cohort_name: userDataForCohort.cohort_name || customerData.cohort_name || null,
          timestamp: new Date().toISOString(),
          email_address: email_address,
          user_name: user_name,
          ...additionalData,
        };
      }

      // Merge coupon + product fields using shared helpers.
      if (typeof mergeCouponInfo === 'function') {
        eventData = mergeCouponInfo(eventData, additionalData || {});
      }

      if (typeof mergeProductData === 'function') {
        eventData = mergeProductData(eventData, productData, additionalData || {});
      }

      // Ensure correct key name: your param list expects `is_in_stock`, but mergeProductData uses `product_in_stock`.
      eventData.is_in_stock =
        additionalData.is_in_stock !== undefined ? additionalData.is_in_stock : (computedIsInStock ?? eventData.product_in_stock ?? null);

      // Ensure required product quantity key is present.
      if (eventData.product_available_quantity === undefined) {
        eventData.product_available_quantity = productData.product_available_quantity ?? null;
      }

      dataLayer.push(eventData);
    } catch (error) {
      console.error('Error tracking ga_pwst_product_notify_me_submitted:', error);
    }
  }

  function resolveSaleNotifyMeAttributes(formValues) {
    const form = formValues || {};
    const customerData = window.__CUSTOMER_DATA__ || {};
    const customerPhone = getShopifyCustomerPhoneNumber();
    const formPhone = form.phone_number != null ? String(form.phone_number).trim() : '';
    const formEmail = form.email != null ? String(form.email).trim() : '';
    const formFirst = form.first_name != null ? String(form.first_name).trim() : '';
    const formLast = form.last_name != null ? String(form.last_name).trim() : '';
    const customerEmail = customerData.email ? String(customerData.email).trim() : '';
    const customerFirst = customerData.first_name ? String(customerData.first_name).trim() : '';
    const customerLast = customerData.last_name ? String(customerData.last_name).trim() : '';

    return {
      phone_number: formatNotifyMePhoneNumber(customerPhone || formPhone || null),
      email: formEmail || customerEmail || null,
      first_name: formFirst || customerFirst || null,
      last_name: formLast || customerLast || null,
    };
  }

  function trackPwstSaleNotifyMeSubmitted(formValues) {
    try {
      if (window.__PW_SALE_NOTIFY_ME_TRACKED__) return true;

      const attrs = resolveSaleNotifyMeAttributes(formValues);
      window.dataLayer = window.dataLayer || [];

      if (typeof buildBaseGtmEventData === 'function') {
        dataLayer.push(buildBaseGtmEventData('ga_pwst_sale_notify_me_submitted', attrs));
      } else {
        const gtmConfig = window.__GTM_CONFIG__ || {};
        const loginData = window.__LOGIN_DATA__ || {};
        const customerData = window.__CUSTOMER_DATA__ || {};
        const userData = typeof getUserData === 'function' ? getUserData() : {};
        dataLayer.push({
          event: 'ga_pwst_sale_notify_me_submitted',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: userData.pw_user_id || customerData.pw_user_id || null,
          timestamp: new Date().toISOString(),
          ...attrs,
        });
      }

      if (typeof buildBaseMoeEventData === 'function') {
        dataLayer.push(buildBaseMoeEventData('moe_pwst_sale_notify_me_submitted', attrs));
      } else {
        dataLayer.push({
          event: 'moe_pwst_sale_notify_me_submitted',
          ...attrs,
        });
      }

      window.__PW_SALE_NOTIFY_ME_TRACKED__ = true;
      return true;
    } catch (error) {
      window.__PW_SALE_NOTIFY_ME_TRACKED__ = false;
      console.error('Error tracking pwst_sale_notify_me_submitted:', error);
      return false;
    }
  }

  window.resolveSaleNotifyMeAttributes = resolveSaleNotifyMeAttributes;
  window.trackPwstSaleNotifyMeSubmitted = trackPwstSaleNotifyMeSubmitted;

  const PW_DEVICE_ID_STORAGE_KEY = 'pw_store_device_id';
  const DEVICE_ID_STORAGE_KEYS = [PW_DEVICE_ID_STORAGE_KEY, 'device_id', 'deviceId', 'pw_device_id'];
  const FLASH_BANNER_CLICK_SELECTOR = [
    'a.flash-sale-countdown__view-all',
    'a.flash-sale-desktop-banner__cta',
    'a.flash-sale-countdown__sticky-inner',
    'a.fssb__cta',
    'a.fssb__inner',
  ].join(', ');
  const FLASH_BANNER_CLICK_DEBOUNCE_MS = 400;

  function readLocalStorage(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function writeLocalStorage(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {}
  }

  function createDeviceId() {
    try {
      if (window.crypto && typeof window.crypto.randomUUID === 'function') {
        return window.crypto.randomUUID();
      }
    } catch (error) {}

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
      const random = (Math.random() * 16) | 0;
      const value = char === 'x' ? random : (random & 0x3) | 0x8;
      return value.toString(16);
    });
  }

  function resolvePwDeviceId() {
    try {
      const params = new URLSearchParams(window.location.search);
      const fromUrl = params.get('device_id') || params.get('deviceId');
      if (fromUrl) {
        writeLocalStorage(PW_DEVICE_ID_STORAGE_KEY, fromUrl);
        return fromUrl;
      }
    } catch (error) {}

    const stored = DEVICE_ID_STORAGE_KEYS.map(readLocalStorage).find(Boolean);
    if (stored) return stored;

    const created = createDeviceId();
    writeLocalStorage(PW_DEVICE_ID_STORAGE_KEY, created);
    return created;
  }

  function isFlashBannerClickPage() {
    const template = document.getElementById('MainContent')?.getAttribute('data-template') || '';
    if (template.startsWith('collection') || template.includes('cohort')) return true;
    return (window.location.pathname || '').startsWith('/collections/');
  }

  function trackPwstSaleFlashBannerClick(source) {
    try {
      const section = source?.closest?.('.flash-sale-countdown, .flash-sale-desktop-banner, .fssb') || null;
      const attrs = {
        device_id: resolvePwDeviceId(),
        flash_state: section?.classList.contains('is-live') ? 'live' : 'upcoming',
        page_type: 'Sale',
        placement: 'index',
      };

      window.dataLayer = window.dataLayer || [];

      if (typeof buildBaseGtmEventData === 'function') {
        dataLayer.push(buildBaseGtmEventData('ga_pwst_sale_flash_banner_click', attrs));
      } else {
        const gtmConfig = window.__GTM_CONFIG__ || {};
        const loginData = window.__LOGIN_DATA__ || {};
        const customerData = window.__CUSTOMER_DATA__ || {};
        const userData = typeof getUserData === 'function' ? getUserData() : {};
        dataLayer.push({
          event: 'ga_pwst_sale_flash_banner_click',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          is_logged_in: Boolean(loginData.is_logged_in),
          user_id: customerData.customerId || null,
          pw_user_id: userData.pw_user_id || customerData.pw_user_id || null,
          cohort_id: userData.cohort_id || customerData.cohort_id || null,
          timestamp: new Date().toISOString(),
          ...attrs,
        });
      }

      if (typeof buildBaseMoeEventData === 'function') {
        dataLayer.push(buildBaseMoeEventData('moe_pwst_sale_flash_banner_click', attrs));
      } else {
        dataLayer.push({
          event: 'moe_pwst_sale_flash_banner_click',
          ...attrs,
        });
      }
    } catch (error) {
      console.error('Error tracking pwst_sale_flash_banner_click:', error);
    }
  }

  function attachPwstSaleFlashBannerClickTracking() {
    if (window.__PW_SALE_FLASH_BANNER_CLICK_ATTACHED__) return;
    window.__PW_SALE_FLASH_BANNER_CLICK_ATTACHED__ = true;

    document.addEventListener(
      'click',
      (event) => {
        try {
          if (!(event.target instanceof Element) || !isFlashBannerClickPage()) return;

          const link = event.target.closest(FLASH_BANNER_CLICK_SELECTOR);
          if (!link || link.closest('[data-flash-sale-notify]')) return;

          const now = Date.now();
          const lastClickAt = window.__PW_SALE_FLASH_BANNER_CLICK_TS__ || 0;
          if (now - lastClickAt < FLASH_BANNER_CLICK_DEBOUNCE_MS) return;
          window.__PW_SALE_FLASH_BANNER_CLICK_TS__ = now;

          trackPwstSaleFlashBannerClick(link);
        } catch (error) {
          console.error('Error handling pwst_sale_flash_banner_click:', error);
        }
      },
      true
    );
  }

  window.trackPwstSaleFlashBannerClick = trackPwstSaleFlashBannerClick;

  function attachDoranNotifyMeSubmitTracking() {
    try {
      if (window.__PW_DORAN_NOTIFY_TRACKING_ATTACHED__) return;
      window.__PW_DORAN_NOTIFY_TRACKING_ATTACHED__ = true;

      // Capture product context when user opens the Dorans modal.
      document.addEventListener(
        'click',
        function(event) {
          try {
            if (!(event.target instanceof Element)) return;
            var inline = event.target.closest('[data-dr="back-in-stock-inline-button"]');
            if (!inline) return;
            window.__PW_DORAN_NOTIFY_CONTEXT__ = {
              product_id: inline.getAttribute('data-product-id') || null,
              product_variant_id: inline.getAttribute('data-selected-variant-id') || null,
            };
          } catch (e) {}
        },
        true
      );

      // Fire event when user submits the modal form.
      document.addEventListener(
        'click',
        function(event) {
          try {
            if (!(event.target instanceof Element)) return;
            var btn = event.target.closest('button.dr-submission-button');
            if (!btn) return;

            var now = Date.now();
            window.__PW_DORAN_NOTIFY_LAST_TS__ = window.__PW_DORAN_NOTIFY_LAST_TS__ || 0;
            if (now - window.__PW_DORAN_NOTIFY_LAST_TS__ < 800) return;
            window.__PW_DORAN_NOTIFY_LAST_TS__ = now;

            var modalRoot =
              btn.closest('.dr-back-in-stock-modal') ||
              btn.closest('[data-dr="back-in-stock-modal"]') ||
              document.querySelector('.dr-back-in-stock-modal') ||
              document.querySelector('form.dr-bis-form') ||
              document.body;

            var email_address = resolveNotifyMeEmail(modalRoot);
            var user_name = resolveNotifyMeUserName(modalRoot);

            var ctx = window.__PW_DORAN_NOTIFY_CONTEXT__ || {};
            var product_variant_id =
              ctx.product_variant_id !== undefined ? ctx.product_variant_id : undefined;

            trackPwstProductNotifyMeSubmitted({
              email_address: email_address,
              user_name: user_name,
              product_id: ctx.product_id !== undefined ? ctx.product_id : undefined,
              product_variant_id: product_variant_id,
            });

            trackMoeBackInStockTest1(modalRoot, { product_variant_id: product_variant_id });
          } catch (e) {}
        },
        true
      );
    } catch (error) {
      console.error('Error attaching Dorans notify tracking:', error);
    }
  }

  function trackJudgemeWriteReviewClicked(additionalData) {
    try {
      var productData = typeof getProductData === 'function' ? getProductData() : {};
      var userDataForCohort = (typeof getUserData === 'function') ? getUserData() : {};

      var eventData = null;
      if (typeof buildBaseGtmEventData === 'function') {
        eventData = buildBaseGtmEventData(
          'ga_pwst_write_product_review_clicked',
          {
            page_name: 'Product',
            breadcrumb_path: getBreadcrumbPathArray(),
            ...additionalData,
          },
          { pageName: 'pdp' }
        );
      } else {
        var gtmConfig = window.__GTM_CONFIG__ || {};
        var loginData = window.__LOGIN_DATA__ || {};
        var customerData = window.__CUSTOMER_DATA__ || {};
        var userData = typeof getUserData === 'function' ? getUserData() : {};

        eventData = {
          event: 'ga_pwst_write_product_review_clicked',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          page_name: 'Product',
          breadcrumb_path: getBreadcrumbPathArray(),
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: userData.pw_user_id || customerData.pw_user_id || null,
          cohort_id: userData.cohort_id || customerData.cohort_id || null,
          cohort_name: userData.cohort_name || customerData.cohort_name || null,
          timestamp: new Date().toISOString(),
          ...additionalData,
        };
      }

      // Align user_id with existing GA-style events (customerId)
      eventData.user_id = (window.__CUSTOMER_DATA__ || {}).customerId ?? null;
      eventData.cohort_name = userDataForCohort.cohort_name ?? (window.__CUSTOMER_DATA__ || {}).cohort_name ?? null;

      // Merge coupon + product fields
      if (typeof mergeCouponInfo === 'function') {
        eventData = mergeCouponInfo(eventData, additionalData || {});
      } else {
        var couponInfo = (typeof getCouponInfo === 'function') ? getCouponInfo() : { coupon_present: false, coupon_type: null };
        eventData.coupon_present = (additionalData && additionalData.coupon_present !== undefined) ? additionalData.coupon_present : couponInfo.coupon_present;
        eventData.coupon_type = (additionalData && additionalData.coupon_type !== undefined) ? additionalData.coupon_type : couponInfo.coupon_type;
      }

      if (typeof mergeProductData === 'function') {
        eventData = mergeProductData(eventData, productData, additionalData || {});
      } else {
        eventData = {
          ...eventData,
          product_id: productData.product_id || null,
          product_title: productData.product_title || null,
          product_slug: productData.product_slug || null,
          product_moq: 50,
          product_discount_percent: productData.product_discount_percent || null,
          is_in_stock: productData.is_in_stock ?? null,
          product_price: productData.product_price ?? null,
          product_discount_price: productData.product_discount_price ?? null,
          product_discounted_price: productData.product_discounted_price ?? null,
          product_tag: productData.product_tag || null,
          preorder: productData.preorder || null,
          product_available_quantity: productData.product_available_quantity ?? null,
          l1_category_name: productData.l1_category_name || null,
          l2_category_name: productData.l2_category_name || null,
          l3_category_name: productData.l3_category_name || null,
          product_category_slug: productData.product_category_slug || null,
          product_variant_id: productData.product_variant_id || null,
        };
      }

      dataLayer.push(eventData);
    } catch (error) {
      console.error('Error tracking ga_pwst_write_product_review_clicked:', error);
    }
  }

  function trackJudgemeWriteReviewSubmitted(additionalData) {
    try {
      var productData = typeof getProductData === 'function' ? getProductData() : {};
      var userDataForCohort = (typeof getUserData === 'function') ? getUserData() : {};

      var eventData = null;
      if (typeof buildBaseGtmEventData === 'function') {
        eventData = buildBaseGtmEventData(
          'ga_pwst_write_product_review_submitted',
          {
            page_name: 'Product',
            breadcrumb_path: getBreadcrumbPathArray(),
            ...additionalData,
          },
          { pageName: 'pdp' }
        );
      } else {
        var gtmConfig = window.__GTM_CONFIG__ || {};
        var loginData = window.__LOGIN_DATA__ || {};
        var customerData = window.__CUSTOMER_DATA__ || {};
        var userData = typeof getUserData === 'function' ? getUserData() : {};

        eventData = {
          event: 'ga_pwst_write_product_review_submitted',
          platform: gtmConfig.platform || 'web',
          organisation_name: gtmConfig.organisation_name || 'pw',
          business_unit: gtmConfig.business_unit || 'pw_store',
          page_url: window.location.href,
          page_name: 'Product',
          breadcrumb_path: getBreadcrumbPathArray(),
          is_logged_in: loginData.is_logged_in || false,
          user_id: customerData.customerId || null,
          pw_user_id: userData.pw_user_id || customerData.pw_user_id || null,
          cohort_id: userData.cohort_id || customerData.cohort_id || null,
          cohort_name: userData.cohort_name || customerData.cohort_name || null,
          timestamp: new Date().toISOString(),
          ...additionalData,
        };
      }

      eventData.user_id = (window.__CUSTOMER_DATA__ || {}).customerId ?? null;
      eventData.cohort_name = userDataForCohort.cohort_name ?? (window.__CUSTOMER_DATA__ || {}).cohort_name ?? null;

      if (typeof mergeCouponInfo === 'function') {
        eventData = mergeCouponInfo(eventData, additionalData || {});
      } else {
        var couponInfo2 = (typeof getCouponInfo === 'function') ? getCouponInfo() : { coupon_present: false, coupon_type: null };
        eventData.coupon_present = (additionalData && additionalData.coupon_present !== undefined) ? additionalData.coupon_present : couponInfo2.coupon_present;
        eventData.coupon_type = (additionalData && additionalData.coupon_type !== undefined) ? additionalData.coupon_type : couponInfo2.coupon_type;
      }

      if (typeof mergeProductData === 'function') {
        eventData = mergeProductData(eventData, productData, additionalData || {});
      } else {
        eventData = {
          ...eventData,
          product_id: productData.product_id || null,
          product_title: productData.product_title || null,
          product_slug: productData.product_slug || null,
          product_moq: 50,
          product_discount_percent: productData.product_discount_percent || null,
          is_in_stock: productData.is_in_stock ?? null,
          product_price: productData.product_price ?? null,
          product_discount_price: productData.product_discount_price ?? null,
          product_discounted_price: productData.product_discounted_price ?? null,
          product_tag: productData.product_tag || null,
          preorder: productData.preorder || null,
          product_available_quantity: productData.product_available_quantity ?? null,
          l1_category_name: productData.l1_category_name || null,
          l2_category_name: productData.l2_category_name || null,
          l3_category_name: productData.l3_category_name || null,
          product_variant_id: productData.product_variant_id || null,
        };
      }

      dataLayer.push(eventData);
    } catch (error) {
      console.error('Error tracking ga_pwst_write_product_review_submitted:', error);
    }
  }

  function collectJudgemeMediaUrls() {
    try {
      function base64ToBlobUrl(base64) {
        try {
          if (!base64 || typeof base64 !== 'string') return null;
          var parts = base64.split(',');
          if (!parts || parts.length < 2) return null;

          var meta = parts[0];
          var data = parts[1];
          var mimeMatch = meta.match(/:(.*?);/);
          var mime = mimeMatch && mimeMatch[1] ? mimeMatch[1] : 'application/octet-stream';

          var binary = atob(data);
          var buffer = new Uint8Array(binary.length);

          for (var i = 0; i < binary.length; i++) {
            buffer[i] = binary.charCodeAt(i);
          }

          var blob = new Blob([buffer], { type: mime });
          return URL.createObjectURL(blob);
        } catch (e) {
          return null;
        }
      }

      // Convert any base64 thumbnails to blob URLs so downstream collection can include them.
      // Note: blob URLs are only valid in the browser that generated them.
      document
        .querySelectorAll('img[src^="data:image"].jdgm-write-review-modal__media-thumbnail')
        .forEach(function(img) {
          try {
            if (!img || !img.src || img.src.indexOf('data:image') !== 0) return;
            var blobUrl = base64ToBlobUrl(img.src);
            if (blobUrl) img.src = blobUrl;
          } catch (e) {}
        });

      var urls = [];
      var mediaNodes = document.querySelectorAll('.jdgm-write-review-modal__media-preview-content img.jdgm-write-review-modal__media-thumbnail');
      Array.prototype.forEach.call(mediaNodes, function(img) {
        if (!img) return;
        var u = (img.currentSrc || img.getAttribute('src') || img.getAttribute('data-src') || '').trim();
        if (!u) return;
        urls.push(u);
      });

      var cleaned = [];
      urls.forEach(function(u) {
        if (!u) return;
        if (u.indexOf('data:') === 0) return;
        if (cleaned.indexOf(u) !== -1) return;
        cleaned.push(u);
      });

      return cleaned;
    } catch (e) {
      return [];
    }
  }

  function fireJudgemeSubmittedWithRetries(basePayload, attempt) {
    var a = attempt || 0;
    var urls = collectJudgemeMediaUrls();
    var hasUploadPreviews = !!document.querySelector('.jdgm-write-review-modal__media-preview-content img.jdgm-write-review-modal__media-thumbnail');
    if (hasUploadPreviews && urls.length === 0 && a < 12) {
      setTimeout(function() {
        fireJudgemeSubmittedWithRetries(basePayload, a + 1);
      }, 400);
      return;
    }

    trackJudgemeWriteReviewSubmitted({
      ...basePayload,
      multimedia_attached_list: urls,
    });
  }

  function attachJudgemeWriteReviewListeners() {
    try {
      if (window.__PW_JDGM_REVIEW_OBSERVER_ATTACHED__) return;
      window.__PW_JDGM_REVIEW_OBSERVER_ATTACHED__ = true;

      function tryAttach() {
        var writeReviewBtn = document.querySelector('.jdgm-write-rev-link');
        if (writeReviewBtn && !writeReviewBtn.__pwstListenerAttached) {
          writeReviewBtn.__pwstListenerAttached = true;
          writeReviewBtn.addEventListener('click', function() {
            trackJudgemeWriteReviewClicked();
          });
        }
      }
      tryAttach();

      if (!window.__PW_JDGM_SUBMIT_DELEGATE_ATTACHED__) {
        window.__PW_JDGM_SUBMIT_DELEGATE_ATTACHED__ = true;
        window.__PW_JDGM_LAST_SUBMIT_TS__ = 0;

        document.addEventListener('click', function(event) {
          try {
            if (!(event.target instanceof Element)) return;
            var btn = event.target.closest(
              '.jdgm-write-review-modal__nav-btn.jdgm-write-review-modal__nav-btn-next'
            );
            if (!btn) return;

            var now = Date.now();
            if (now - (window.__PW_JDGM_LAST_SUBMIT_TS__ || 0) < 1500) return;
            window.__PW_JDGM_LAST_SUBMIT_TS__ = now;
            var modalRoot =
              btn.closest('.jdgm-write-review-modal__container') ||
              btn.closest('.jdgm-write-review-modal') ||
              document.body;

            var currentPageEl = modalRoot.querySelector('.jdgm-write-review-modal__page.current-page');
            var currentPageNum = currentPageEl ? parseInt(currentPageEl.getAttribute('data-page'), 10) : NaN;

            var introPageEl = modalRoot.querySelector('.jdgm-write-review-modal__page[data-page="1"].current-page');
            if (!introPageEl) introPageEl = modalRoot.querySelector('.jdgm-write-review-modal__page--review-form-intro.current-page');
            var isIntroActive = !!introPageEl || currentPageNum === 1;

            var thankYouPageEl = modalRoot.querySelector('.jdgm-write-review-modal__page--thank-you');
            var thankYouPageNum = thankYouPageEl ? parseInt(thankYouPageEl.getAttribute('data-page'), 10) : 5;

            if (!Number.isFinite(thankYouPageNum)) thankYouPageNum = 5;
            if (!Number.isFinite(currentPageNum)) currentPageNum = 1;

            if (typeof modalRoot.__pwstNextCount !== 'number') {
              modalRoot.__pwstNextCount = 0;
              modalRoot.__pwstNextCountStartPage = null;
              modalRoot.__pwstSubmittedFired = false;
            }

            if (modalRoot.__pwstSubmittedFired) return;

            if (isIntroActive && modalRoot.__pwstNextCount > 0) {
              modalRoot.__pwstNextCount = 0;
              modalRoot.__pwstNextCountStartPage = 1;
              modalRoot.__pwstSubmittedFired = false;
            }

            if (modalRoot.__pwstNextCount === 0 && modalRoot.__pwstNextCountStartPage == null) {
              modalRoot.__pwstNextCountStartPage = Number.isFinite(currentPageNum)
                ? currentPageNum
                : 1;
            }

            modalRoot.__pwstNextCount += 1;

            var startPage = modalRoot.__pwstNextCountStartPage || 1;
            var finalCount = thankYouPageNum - startPage; // e.g., 5 - 1 = 4
            if (!Number.isFinite(finalCount) || finalCount < 1) finalCount = 4;

            var isFinalByCount = modalRoot.__pwstNextCount === finalCount;

            var page4MediaInput =
              modalRoot.querySelector(
                '.jdgm-write-review-modal__page[data-page="4"] input[type="file"][name="media"]'
              ) ||
              modalRoot.querySelector(
                '.jdgm-write-review-modal__page--share-media input[type="file"][name="media"]'
              );
            var page4ThumbEl =
              modalRoot.querySelector(
                '.jdgm-write-review-modal__page[data-page="4"] img.jdgm-write-review-modal__media-thumbnail'
              ) ||
              modalRoot.querySelector(
                '.jdgm-write-review-modal__page--share-media img.jdgm-write-review-modal__media-thumbnail'
              );
            var hasUploadedMedia =
              !!(
                (page4MediaInput && page4MediaInput.files && page4MediaInput.files.length) ||
                page4ThumbEl
              );

            if (!isFinalByCount && !hasUploadedMedia) return;
            modalRoot.__pwstSubmittedFired = true;

            var ratingInput = document.querySelector('input[name="score"]');
            var rating_given = ratingInput ? Number(ratingInput.value) : null;

            var reviewBodyEl = document.getElementById('jdgm-review-body-input');
            var review_text = reviewBodyEl ? (reviewBodyEl.value || '') : '';

            fireJudgemeSubmittedWithRetries( 
              {
                rating_given: Number.isFinite(rating_given) ? rating_given : null,
                review_text: review_text,
              },
              0
            );
          } catch (e) {}
        }, true);
      }

      var root = document.body || document.documentElement;
      if (!root) return;

      var observer = new MutationObserver(function() {
        tryAttach();
      });
      observer.observe(root, { childList: true, subtree: true });

      setTimeout(function() {
        try { observer.disconnect(); } catch (e) {}
      }, 15000);
    } catch (error) {
      console.error('Error attaching Judge.me review listeners:', error);
    }
  }

  runAfterDomLoad(function() {
    attachCouponMessageListener();
    attachTrackOrderClickTracking();
    attachExternalOrderPageIngressTracking();
    attachPwstShareClickedTracking();
    attachDoranNotifyMeSubmitTracking();
    attachPwstSaleFlashBannerClickTracking();
    attachJudgemeWriteReviewListeners();
    initLoginNameEntryTracking();

    attachFaqViewTracking();

    attachProductPreviewViewedTracking();

    if (!window.__PAGE_VIEW_TRACKED__) {
      window.__PAGE_VIEW_TRACKED__ = true;
      trackPageView();
    }
    try {
      initStoreStartTracking();
    } catch (e) {
      console.error('Error initializing store start tracking:', e);
    }
  });

  scheduleLoadingTimeTracking();
